// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from '@hey-api/client-fetch';
import type { GetAccessData, GetAccessResponse, GetPlatformStatusData, GetPlatformStatusResponse, RepublishScopeGraphData, RepublishScopeGraphResponse, ListOrganizationsData, ListOrganizationsResponse, GetOrganizationData, GetOrganizationResponse, UpdateOrganizationData, UpdateOrganizationResponse, ListOrdersData, ListOrdersResponse, CreateOrderData, CreateOrderResponse, DeleteOrderData, DeleteOrderResponse, GetOrderData, GetOrderResponse, UpdateOrderData, UpdateOrderResponse, OrderTimelineData, OrderTimelineResponse, ListMarketingRulesData, ListMarketingRulesResponse, GetMarketingRuleData, GetMarketingRuleResponse, GetMarketingRuleStateData, GetMarketingRuleStateResponse, GetMarketingLiveCoefficientsData, GetMarketingLiveCoefficientsResponse, ListMarketingRuleExecutionsData, ListMarketingRuleExecutionsResponse, GetMarketingRuleExecutionData, GetMarketingRuleExecutionResponse, DownloadMarketingRuleExecutionData, DownloadMarketingRuleExecutionResponse, DownloadMarketingRuleExecutionExcelData, DownloadMarketingRuleAuditData, TestMarketingRuleData, TestMarketingRuleResponse, ExecuteMarketingRulesData, ExecuteMarketingRulesResponse, StreamMarketingRulesData, ListMarketingRuleExclusionsData, ListMarketingRuleExclusionsResponse, CreateMarketingRuleExclusionData, CreateMarketingRuleExclusionResponse, DeleteMarketingRuleExclusionData, DeleteMarketingRuleExclusionResponse, ListMarketingRuleAutomationsData, ListMarketingRuleAutomationsResponse, SetMarketingRuleAutomationData, SetMarketingRuleAutomationResponse, ListMarketingAutomationDecisionsData, ListMarketingAutomationDecisionsResponse, GetMarketingAutomationShadowData, GetMarketingAutomationShadowResponse, DeleteMarketingRuleAutomationData, DeleteMarketingRuleAutomationResponse, GetMarketingEngineConfigData, GetMarketingEngineConfigResponse, UpdateMarketingEngineConfigData, UpdateMarketingEngineConfigResponse, GetMarketingRulesHealthData, GetMarketingRulesHealthResponse, ExplainMarketingRulesHealthData, ExplainMarketingRulesHealthResponse, ListAdsStoresData, ListAdsStoresResponse, ListAdsBrandsData, ListAdsBrandsResponse, GetAdsPerformanceData, GetAdsPerformanceResponse, ListAdsNegativesData, ListAdsNegativesResponse, GetAdsTrendData, GetAdsTrendResponse, GetSearchAnalyticsData, GetSearchAnalyticsResponse, GetSearchQueryKeywordsData, GetSearchQueryKeywordsResponse, GetFocusSearchTermSheetData, GetFocusSearchTermSheetResponse, ListFocusSearchTermHistoryTermsData, ListFocusSearchTermHistoryTermsResponse, GetFocusSearchTermHistoryData, GetFocusSearchTermHistoryResponse, ListAdsChangesData, ListAdsChangesResponse, GetAdsChangeSummaryData, GetAdsChangeSummaryResponse, GetAdsChangePulseData, GetAdsChangePulseResponse, GetTargetTimelineData, GetTargetTimelineResponse, ListTargetTimelinesData, ListTargetTimelinesResponse, GetSearchTermTimelineData, GetSearchTermTimelineResponse, GetAdGroupTimelineData, GetAdGroupTimelineResponse, GetCampaignTimelineData, GetCampaignTimelineResponse, GetReportSyncData, GetReportSyncResponse, ListReportTypesData, ListReportTypesResponse, ListAdGroupMasterData, ListAdGroupMasterResponse, DownloadAdGroupMasterTemplateData, ListUploadStoresData, ListUploadStoresResponse, DownloadUploadTemplateData, CheckUploadData, CheckUploadResponse, ListUploadsData, ListUploadsResponse, RaiseUploadData, RaiseUploadResponse, CheckNewTargetsData, CheckNewTargetsResponse, AmsViewListSellersData, AmsViewListSellersResponse, AmsViewListBrandsData, AmsViewListBrandsResponse, AmsViewGetAdGroupCountsData, AmsViewGetAdGroupCountsResponse, AmsViewListAdGroupsData, AmsViewListAdGroupsResponse, AmsViewGetTopAsinsData, AmsViewGetTopAsinsResponse, AmsViewGetCampaignTrendData, AmsViewGetCampaignTrendResponse, AmsViewGetAdGroupTrendData, AmsViewGetAdGroupTrendResponse, AmsViewGetOverallTrendData, AmsViewGetOverallTrendResponse, AmsViewExportWorkbookData, AmsViewListAdProductsData, AmsViewListAdProductsResponse, AmsViewListTargetsData, AmsViewListTargetsResponse, AmsViewListSearchTermsData, AmsViewListSearchTermsResponse, AmsViewListNegativesData, AmsViewListNegativesResponse, AmsViewListAltProductsData, AmsViewListAltProductsResponse, AmsViewGetEntityTrendData, AmsViewGetEntityTrendResponse, AmsViewGetAggregateTrendData, AmsViewGetAggregateTrendResponse, AmsViewGetAggregateData, AmsViewGetAggregateResponse, ReviewAmsListRowsData, ReviewAmsListRowsResponse, ReviewAmsGetSummaryData, ReviewAmsGetSummaryResponse, ReviewAmsExportRowsCsvData, ReviewAmsListNegativesData, ReviewAmsListNegativesResponse, ReviewAmsExportNegativesCsvData, ReviewAmsResolveTargetInstancesData, ReviewAmsResolveTargetInstancesResponse, ReviewAmsResolveSearchTermOriginsData, ReviewAmsResolveSearchTermOriginsResponse, ReviewAmsResolveAdProductInstancesData, ReviewAmsResolveAdProductInstancesResponse, ReviewAmsResolveBrandAdGroupsData, ReviewAmsResolveBrandAdGroupsResponse, AmsViewGetAmazonWriteLockData, AmsViewGetAmazonWriteLockResponse, AmsViewAddTargetData, AmsViewAddNegativeData, AmsViewUpdateNegativeData, AmsViewAddAdProductData, AmsViewUpdateAdProductData, ReviewAmsChangeBidData, ReviewAmsChangeBidResponse, ReviewAmsPauseTargetData, ReviewAmsPauseTargetResponse, ReviewAmsAddNegativeData, ReviewAmsAddNegativeResponse, ReviewAmsAddTargetData, ReviewAmsAddTargetResponse, BidSimulatorWhatIfData, BidSimulatorWhatIfResponse, BidSimulatorCurveData, BidSimulatorCurveResponse, BidSimulatorRecommendationData, BidSimulatorRecommendationResponse, BidSimulatorAccuracyData, BidSimulatorAccuracyResponse, DownloadOptimizationTemplateData, RunOptimizationUploadData, GetCostStatusData, GetCostStatusResponse, GetCostOptionsData, GetCostOptionsResponse, ListCostsData, ListCostsResponse, ExportCostsData, DownloadCostTemplateData, PreviewCostUploadData, PreviewCostUploadResponse, CommitCostUploadData, CommitCostUploadResponse, DeleteCostData, DeleteCostResponse, EditCostData, EditCostResponse, GetFeeStatusData, GetFeeStatusResponse, ListFeeStoresData, ListFeeStoresResponse, ListFeesData, ListFeesResponse, ExportFeesData, DownloadFeeTemplateData, PreviewFeeUploadData, PreviewFeeUploadResponse, CommitFeeUploadData, CommitFeeUploadResponse, ListSkusData, ListSkusResponse, ListSkuCostsData, ListSkuCostsResponse, ExportSheetData, ListOrderBookData, ListOrderBookResponse, ListOrderBookOrdersData, ListOrderBookOrdersResponse, CountOrderBookStatusesData, CountOrderBookStatusesResponse, GetOrderBookAnalyticsData, GetOrderBookAnalyticsResponse, ExportOrderBookData, ListOrderUploadStoresData, ListOrderUploadStoresResponse, GetOrderBookOrderData, GetOrderBookOrderResponse, ListProductStoresData, ListProductStoresResponse, ListProductsData, ListProductsResponse, ExportProductsData, ListReturnStoresData, ListReturnStoresResponse, ListReturnsData, ListReturnsResponse, ExportReturnsData, ListSettlementStoresData, ListSettlementStoresResponse, ListSettlementLinesData, ListSettlementLinesResponse, ExportSettlementLinesData, ListPerformanceMasterStoresData, ListPerformanceMasterStoresResponse, DownloadPerformanceMasterTemplateData, PreviewPerformanceMasterData, PreviewPerformanceMasterResponse, ListDaypartingEntitiesData, ListDaypartingEntitiesResponse, GetDaypartingWeekdayProfileData, GetDaypartingWeekdayProfileResponse, ListDaypartingSchedulesData, ListDaypartingSchedulesResponse, CreateDaypartingScheduleData, CreateDaypartingScheduleResponse, DeleteDaypartingScheduleData, DeleteDaypartingScheduleResponse, GetDaypartingScheduleData, GetDaypartingScheduleResponse, UpdateDaypartingScheduleData, UpdateDaypartingScheduleResponse, ListDaypartingEventsData, ListDaypartingEventsResponse, ListFocusedSkusData, ListFocusedSkusResponse, AddFocusedSkusData, AddFocusedSkusResponse, RemoveFocusedSkusData, RemoveFocusedSkusResponse, DownloadFocusedSkuTemplateData, PreviewFocusedSkuUploadData, PreviewFocusedSkuUploadResponse, CommitFocusedSkuUploadData, CommitFocusedSkuUploadResponse, GetFocusedSkuSheetOptionsData, GetFocusedSkuSheetOptionsResponse, GetFocusedSkuSheetData, GetFocusedSkuSheetResponse, SaveFocusedSkuNotesData, SaveFocusedSkuNotesResponse, RunAutoOrderingForecastData, RunAutoOrderingForecastResponse, ReadAutoOrderingPlanningData, ReadAutoOrderingPlanningResponse, DownloadAutoOrderingTemplateData, AutoOrderingVendorOptionsData, AutoOrderingVendorOptionsResponse, AutoOrderingNextVoCodeData, AutoOrderingNextVoCodeResponse, PoFulfilmentSummaryData, PoFulfilmentSummaryResponse, ListPoFulfilmentPurchaseOrdersData, ListPoFulfilmentPurchaseOrdersResponse, ReadPoFulfilmentPurchaseOrderData, ReadPoFulfilmentPurchaseOrderResponse, CreatePoFulfilmentLegsData, CreatePoFulfilmentLegsResponse, SendPoFulfilmentToWarehouseData, SendPoFulfilmentToWarehouseResponse, AcknowledgePoFulfilmentPurchaseOrderData, AcknowledgePoFulfilmentPurchaseOrderResponse, ExportPoFulfilmentReportData, RetailerPoFulfilmentLookupsData, RetailerPoFulfilmentLookupsResponse, RetailerPoFulfilmentSummaryData, RetailerPoFulfilmentSummaryResponse, ListRetailerPoFulfilmentData, ListRetailerPoFulfilmentResponse, ExportRetailerPoFulfilmentData, RetailerPoFulfilmentLinesData, RetailerPoFulfilmentLinesResponse, DashboardSalesMarketingData, DashboardSalesMarketingResponse, DashboardFlowData, DashboardFlowResponse, DashboardForecastData, DashboardForecastResponse, DashboardGrowthData, DashboardGrowthResponse, DashboardMoversData, DashboardMoversResponse, DashboardNoSaleData, DashboardNoSaleResponse, DashboardStockCoverData, DashboardStockCoverResponse, DashboardSuppressedData, DashboardSuppressedResponse, DashboardAdSlotsData, DashboardAdSlotsResponse, DashboardDistressedData, DashboardDistressedResponse, DashboardFreshnessData, DashboardFreshnessResponse, DashboardCountriesData, DashboardCountriesResponse, DashboardForumData, DashboardForumResponse, GetFocusTermSheetOptionsData, GetFocusTermSheetOptionsResponse, GetFocusTermSheetData, GetFocusTermSheetResponse, SaveFocusTermBidActionsData, SaveFocusTermBidActionsResponse, GetFocusTermColumnValuesData, GetFocusTermColumnValuesResponse, RunFocusTermSnapshotData, RunFocusTermSnapshotResponse, GetFocusTermHistoryTermsData, GetFocusTermHistoryTermsResponse, GetFocusTermHistoryData, GetFocusTermHistoryResponse, CreateSearchTermDataData, CreateSearchTermDataResponse, ListMySearchTermDataData, ListMySearchTermDataResponse, ListTicketsData, ListTicketsResponse, CreateTicketsData, CreateTicketsResponse, TicketsByIdsData, TicketsByIdsResponse, CountTicketsData, CountTicketsResponse, TicketWorklistData, TicketWorklistResponse, TicketDoneSeriesData, TicketDoneSeriesResponse, GetTicketAccessData, GetTicketAccessResponse, ListTicketTypesData, ListTicketTypesResponse, UpdateTicketTypeData, UpdateTicketTypeResponse, ReadTicketNotificationsData, ReadTicketNotificationsResponse, DismissTicketNotificationsData, DismissTicketNotificationsResponse, RaiseDetectedTicketsData, RaiseDetectedTicketsResponse, ReportTicketData, ReportTicketResponse, ReportedSourceIdsData, ReportedSourceIdsResponse, DeleteTicketData, DeleteTicketResponse, GetTicketData, GetTicketResponse, UpdateTicketData, UpdateTicketResponse, AssignTicketData, AssignTicketResponse, UnassignTicketData, UnassignTicketResponse, ChangeTicketStatusData, ChangeTicketStatusResponse, ActOnTicketData, ActOnTicketResponse, ListTicketReportsData, ListTicketReportsResponse, ListTicketCommentsData, ListTicketCommentsResponse, CreateTicketCommentData, CreateTicketCommentResponse, ListNotificationsData, ListNotificationsResponse, ClearMyTimezoneData, ClearMyTimezoneResponse, ReadMyTimezonesData, ReadMyTimezonesResponse, SetMyTimezoneData, SetMyTimezoneResponse, ListTicketFormMarketplacesData, ListTicketFormMarketplacesResponse, ListTicketFormBrandsData, ListTicketFormBrandsResponse, ListTicketFormStoresData, ListTicketFormStoresResponse, ListTicketFormWarehousesData, ListTicketFormWarehousesResponse, DownloadTicketItemsTemplateData, ReadTicketItemsSheetData, ReadTicketItemsSheetResponse, DataVaultSummaryData, DataVaultSummaryResponse, DataVaultOrdersTrendData, DataVaultOrdersTrendResponse, DataVaultListProductsData, DataVaultListProductsResponse, DataVaultEditProductsData, DataVaultEditProductsResponse, DataVaultExportProductsData, DataVaultValuesProductsData, DataVaultValuesProductsResponse, DataVaultAggregateProductsData, DataVaultAggregateProductsResponse, DataVaultListInternalSkusData, DataVaultListInternalSkusResponse, DataVaultEditInternalSkusData, DataVaultEditInternalSkusResponse, DataVaultExportInternalSkusData, DataVaultValuesInternalSkusData, DataVaultValuesInternalSkusResponse, DataVaultListCostsData, DataVaultListCostsResponse, DataVaultEditCostsData, DataVaultEditCostsResponse, DataVaultExportCostsData, DataVaultValuesCostsData, DataVaultValuesCostsResponse, DataVaultAggregateCostsData, DataVaultAggregateCostsResponse, DataVaultListRetailerCostsData, DataVaultListRetailerCostsResponse, DataVaultEditRetailerCostsData, DataVaultEditRetailerCostsResponse, DataVaultExportRetailerCostsData, DataVaultValuesRetailerCostsData, DataVaultValuesRetailerCostsResponse, DataVaultListFeesData, DataVaultListFeesResponse, DataVaultEditFeesData, DataVaultEditFeesResponse, DataVaultExportFeesData, DataVaultValuesFeesData, DataVaultValuesFeesResponse, DataVaultAggregateFeesData, DataVaultAggregateFeesResponse, DataVaultListOrdersData, DataVaultListOrdersResponse, DataVaultEditOrdersData, DataVaultEditOrdersResponse, DataVaultExportOrdersData, DataVaultValuesOrdersData, DataVaultValuesOrdersResponse, DataVaultAggregateOrdersData, DataVaultAggregateOrdersResponse, DataVaultListReturnsData, DataVaultListReturnsResponse, DataVaultEditReturnsData, DataVaultEditReturnsResponse, DataVaultExportReturnsData, DataVaultValuesReturnsData, DataVaultValuesReturnsResponse, DataVaultAggregateReturnsData, DataVaultAggregateReturnsResponse, DataVaultListSettlementsData, DataVaultListSettlementsResponse, DataVaultEditSettlementsData, DataVaultEditSettlementsResponse, DataVaultExportSettlementsData, DataVaultValuesSettlementsData, DataVaultValuesSettlementsResponse, DataVaultAggregateSettlementsData, DataVaultAggregateSettlementsResponse, DataVaultListTicketExceptionsData, DataVaultListTicketExceptionsResponse, DataVaultEditTicketExceptionsData, DataVaultEditTicketExceptionsResponse, DataVaultExportTicketExceptionsData, DataVaultValuesTicketExceptionsData, DataVaultValuesTicketExceptionsResponse, DataVaultListMailExceptionsData, DataVaultListMailExceptionsResponse, DataVaultEditMailExceptionsData, DataVaultEditMailExceptionsResponse, DataVaultExportMailExceptionsData, DataVaultValuesMailExceptionsData, DataVaultValuesMailExceptionsResponse, DataVaultEditableProductsData, DataVaultEditableProductsResponse, DataVaultDeleteProductsData, DataVaultDeleteProductsResponse, DataVaultEditableInternalSkusData, DataVaultEditableInternalSkusResponse, DataVaultDeleteInternalSkusData, DataVaultDeleteInternalSkusResponse, DataVaultEditableCostsData, DataVaultEditableCostsResponse, DataVaultDeleteCostsData, DataVaultDeleteCostsResponse, DataVaultEditableRetailerCostsData, DataVaultEditableRetailerCostsResponse, DataVaultDeleteRetailerCostsData, DataVaultDeleteRetailerCostsResponse, DataVaultEditableOrdersData, DataVaultEditableOrdersResponse, DataVaultDeleteOrdersData, DataVaultDeleteOrdersResponse, DataVaultEditableReturnsData, DataVaultEditableReturnsResponse, DataVaultDeleteReturnsData, DataVaultDeleteReturnsResponse, DataVaultEditableSettlementsData, DataVaultEditableSettlementsResponse, DataVaultDeleteSettlementsData, DataVaultDeleteSettlementsResponse, DataVaultEditableFeesData, DataVaultEditableFeesResponse, DataVaultDeleteFeesData, DataVaultDeleteFeesResponse, DataVaultEditableTicketExceptionsData, DataVaultEditableTicketExceptionsResponse, DataVaultDeleteTicketExceptionsData, DataVaultDeleteTicketExceptionsResponse, DataVaultEditableMailExceptionsData, DataVaultEditableMailExceptionsResponse, DataVaultDeleteMailExceptionsData, DataVaultDeleteMailExceptionsResponse, LookupWarehousesData, LookupWarehousesResponse, LookupMarketplacesData, LookupMarketplacesResponse, LookupStoresData, LookupStoresResponse, LookupBrandsData, LookupBrandsResponse, LookupCategoriesData, LookupCategoriesResponse, LookupVendorsData, LookupVendorsResponse, LookupRetailersData, LookupRetailersResponse, ListCatalogueStoresData, ListCatalogueStoresResponse, ListCatalogueListingsData, ListCatalogueListingsResponse, ExportCatalogueListingsData, ExportCatalogueListingsResponse, ListAiListingStoresData, ListAiListingStoresResponse, ListAiListingJobsData, ListAiListingJobsResponse, CreateAiListingJobData, CreateAiListingJobResponse, GetAiListingJobData, GetAiListingJobResponse, SaveAiListingSelectionsData, SaveAiListingSelectionsResponse, RegenerateAiListingImageData, RegenerateAiListingImageResponse, RegenerateAiListingCategoryData, RegenerateAiListingCategoryResponse, GetAiListingUsageData, GetAiListingUsageResponse, ProxyAiListingImageData, ReadMyAnalystAccessData, ReadMyAnalystAccessResponse, ListConversationsData, ListConversationsResponse, CreateConversationData, CreateConversationResponse, BulkDeleteConversationsData, BulkDeleteConversationsResponse, DeleteConversationData, DeleteConversationResponse, UpdateConversationData, UpdateConversationResponse, ReadConversationMessagesData, ReadConversationMessagesResponse, ExportConversationData, ResumeConversationStreamData, ResumeConversationStreamResponse, ReadSharedConversationData, ReadSharedConversationResponse, ChatData, ChatError, ResumeRunStreamData, ResumeRunStreamResponse, CancelRunData, CancelRunResponse, RateAnswerData, RateAnswerResponse, RecordAnswerSignalData, RecordAnswerSignalResponse, ReadResultData, ReadResultResponse, ExportResultData, ReadTimingData, ReadTimingResponse, ReadScopeOptionsData, ReadScopeOptionsResponse, ReadUsageData, ReadUsageResponse, ListMemoryData, ListMemoryResponse, AddMemoryData, AddMemoryResponse, DeleteMemoryData, DeleteMemoryResponse, ListReportsData, ListReportsResponse, SaveReportData, SaveReportResponse, CompareReportsData, CompareReportsResponse, DeleteReportData, DeleteReportResponse, ReadReportData, ReadReportResponse, AdminListQuestionsData, AdminListQuestionsResponse, AdminReadRunTraceData, AdminReadRunTraceResponse, AdminUpdateFlagData, AdminUpdateFlagResponse, AdminListUsageData, AdminListUsageResponse, AdminResetBudgetData, AdminResetBudgetResponse, AdminReadBudgetData, AdminReadBudgetResponse, AdminSetBudgetData, AdminSetBudgetResponse, AdminListProviderCooldownsData, AdminListProviderCooldownsResponse, AdminEndProviderCooldownData, AdminEndProviderCooldownResponse, AdminReadOverviewData, AdminReadOverviewResponse, AdminMineFailuresData, AdminMineFailuresResponse, AdminMineSqlTopicsData, AdminMineSqlTopicsResponse, AdminMineUnmatchedTermsData, AdminMineUnmatchedTermsResponse, AdminPromoteRunData, AdminPromoteRunResponse, AdminSuggestFixData, AdminSuggestFixResponse, AdminListEvalQuestionsData, AdminListEvalQuestionsResponse, AdminDeleteEvalQuestionData, AdminDeleteEvalQuestionResponse, AdminSetEvalQuestionActiveData, AdminSetEvalQuestionActiveResponse, AdminListEvalRunsData, AdminListEvalRunsResponse, AdminListVerifiedData, AdminListVerifiedResponse, AdminCreateVerifiedData, AdminCreateVerifiedResponse, AdminDeleteVerifiedData, AdminDeleteVerifiedResponse, AdminUpdateVerifiedData, AdminUpdateVerifiedResponse, AdminListAliasesData, AdminListAliasesResponse, AdminCreateAliasData, AdminCreateAliasResponse, AdminDeleteAliasData, AdminDeleteAliasResponse, ListStockPushStoresData, ListStockPushStoresResponse, PushStoreStockData, PushStoreStockResponse, PushStockSheetData, PushStockSheetResponse, DownloadStockSheetTemplateData, ListStockPushRunsData, ListStockPushRunsResponse, GetStockPushRunData, GetStockPushRunResponse, StockSheetTemplateColumnsData, StockSheetTemplateColumnsResponse, ListPricePushStoresData, ListPricePushStoresResponse, DownloadPriceSheetTemplateData, PushPriceSheetData, PushPriceSheetResponse, ListPricePushRunsData, ListPricePushRunsResponse, GetPricePushRunData, GetPricePushRunResponse, ListShopifySyncStoresData, ListShopifySyncStoresResponse, StartShopifySyncData, StartShopifySyncResponse, ListShopifySyncRunsData, ListShopifySyncRunsResponse, GetShopifySyncRunData, GetShopifySyncRunResponse, ListMcfStoresData, ListMcfStoresResponse, PreviewMcfOrdersData, PreviewMcfOrdersResponse, ListMcfOrdersData, ListMcfOrdersResponse, CreateMcfOrdersData, CreateMcfOrdersResponse, SyncMcfStatusData, SyncMcfStatusResponse, ExportMcfOrdersData, ListMcfRunsData, ListMcfRunsResponse, GetMcfRunData, GetMcfRunResponse, ListTiktokStoresData, ListTiktokStoresResponse, SyncTiktokProductsData, SyncTiktokProductsResponse, SyncTiktokOrdersData, SyncTiktokOrdersResponse, CorrectTiktokTrackingData, CorrectTiktokTrackingResponse, ListTiktokRunsData, ListTiktokRunsResponse, GetTiktokRunData, GetTiktokRunResponse, ListConnectionSpecsData, ListConnectionSpecsResponse, ListCarrierSpecsData, ListCarrierSpecsResponse, GetMarketplaceConnectionSpecData, GetMarketplaceConnectionSpecResponse, GetMarketplaceStreamSpecData, GetMarketplaceStreamSpecResponse, DiscoverOnboardingStreamsData, DiscoverOnboardingStreamsResponse, VerifyOnboardingCredentialsData, VerifyOnboardingCredentialsResponse, OnboardStoresData, OnboardStoresResponse, FindOnboardingDuplicatesData, FindOnboardingDuplicatesResponse, ListStoreOverviewData, ListStoreOverviewResponse, ListStorePlatformsData, ListStorePlatformsResponse, GetStoreOverviewData, GetStoreOverviewResponse, DeactivateStoreData, DeactivateStoreResponse, ReactivateStoreData, ReactivateStoreResponse, GetStoreDeletionPreviewData, GetStoreDeletionPreviewResponse, StartStoreDeletionData, StartStoreDeletionResponse, GetStoreDeletionData, GetStoreDeletionResponse, ListStoreStreamsData, ListStoreStreamsResponse, UpdateStoreStreamsData, UpdateStoreStreamsResponse, ReconcileStoreStreamsData, ReconcileStoreStreamsResponse, UpdateStoreConnectionData, UpdateStoreConnectionResponse, RotateStoreConnectionData, RotateStoreConnectionResponse, ListConnectionSiblingsData, ListConnectionSiblingsResponse, VerifyStoreConnectionData, VerifyStoreConnectionResponse, SetStoreWriteLockData, SetStoreWriteLockResponse, ListStoreActivityData, ListStoreActivityResponse, ListStoreWritesData, ListStoreWritesResponse, ListStoreWriteFreezesData, ListStoreWriteFreezesResponse, CreateStoreWriteFreezeData, CreateStoreWriteFreezeResponse, CancelStoreWriteFreezeData, CancelStoreWriteFreezeResponse, ListAlertsData, ListAlertsResponse, ListAlertRoutesData, ListAlertRoutesResponse, ReplaceAlertRoutesData, ReplaceAlertRoutesResponse, GetAlertSettingsData, GetAlertSettingsResponse, UpdateAlertSettingsData, UpdateAlertSettingsResponse, GetStoreSettingsData, GetStoreSettingsResponse, UpdateStoreSettingsData, UpdateStoreSettingsResponse, ListStoreAdsProfilesData, ListStoreAdsProfilesResponse, RefreshStoreAccountMetadataData, RefreshStoreAccountMetadataResponse, ListStoreNotesData, ListStoreNotesResponse, CreateStoreNoteData, CreateStoreNoteResponse, DeleteStoreNoteData, DeleteStoreNoteResponse, UpdateStoreNoteData, UpdateStoreNoteResponse, ListStoreGroupsData, ListStoreGroupsResponse, CreateStoreGroupData, CreateStoreGroupResponse, GetStoreHealthData, GetStoreHealthResponse, GetStoreFreshnessData, GetStoreFreshnessResponse, ListStoreRunsData, ListStoreRunsResponse, SyncStoreData, SyncStoreResponse, BackfillStoreData, BackfillStoreResponse, ListStoreCircuitsData, ListStoreCircuitsResponse, ResetStoreCircuitData, ResetStoreCircuitResponse, GetStoreExportDomainsData, GetStoreExportDomainsResponse, ListStoreExportsData, ListStoreExportsResponse, StartStoreExportData, StartStoreExportResponse, GetStoreExportData, GetStoreExportResponse, DownloadStoreExportData, DownloadStoreExportResponse, ExportStoreAuditData, GetStoreCloneTemplateData, GetStoreCloneTemplateResponse, GetStoreChecklistData, GetStoreChecklistResponse, ListBrandOverviewData, ListBrandOverviewResponse, GetBrandOverviewSummaryData, GetBrandOverviewSummaryResponse, GetBrandOverviewItemData, GetBrandOverviewItemResponse, ListUnmatchedSkuNamesData, ListUnmatchedSkuNamesResponse, CreateBrandFromSkuNameData, CreateBrandFromSkuNameResponse, LinkBrandSkuNamesData, LinkBrandSkuNamesResponse, GetBrandMergePreviewData, GetBrandMergePreviewResponse, MergeBrandData, MergeBrandResponse, ListReviewQueriesData, ListReviewQueriesResponse, RecordReviewData, RecordReviewResponse, ListSearchTermQueriesData, ListSearchTermQueriesResponse, RecordSearchTermResultData, RecordSearchTermResultResponse, CheckInData, CheckInResponse, RecordRunData, RecordRunResponse, GetScrapedDataFiltersData, GetScrapedDataFiltersResponse, ListScrapedReviewsData, ListScrapedReviewsResponse, ListScrapedSearchesData, ListScrapedSearchesResponse, ExportScrapedReviewsData, ExportScrapedSearchesData, GetFleetCatalogData, GetFleetCatalogResponse, ListFleetDevicesData, ListFleetDevicesResponse, GetFleetDeviceData, GetFleetDeviceResponse, UpdateFleetDeviceData, UpdateFleetDeviceResponse, ListFleetRunsData, ListFleetRunsResponse, ListMarketplacesData, ListMarketplacesResponse, CreateMarketplaceData, CreateMarketplaceResponse, GetMarketplaceData, GetMarketplaceResponse, UpdateMarketplaceData, UpdateMarketplaceResponse, RetireMarketplaceData, RetireMarketplaceResponse, ReinstateMarketplaceData, ReinstateMarketplaceResponse, ListMarketplaceActivityData, ListMarketplaceActivityResponse, GetMarketplaceUsageData, GetMarketplaceUsageResponse, ListBrandsData, ListBrandsResponse, CreateBrandData, CreateBrandResponse, GetBrandData, GetBrandResponse, UpdateBrandData, UpdateBrandResponse, RetireBrandData, RetireBrandResponse, ReinstateBrandData, ReinstateBrandResponse, ListBrandActivityData, ListBrandActivityResponse, GetBrandUsageData, GetBrandUsageResponse, GetBrandRetirePreviewData, GetBrandRetirePreviewResponse, ListStoresData, ListStoresResponse, CreateStoreData, CreateStoreResponse, GetStoreData, GetStoreResponse, UpdateStoreData, UpdateStoreResponse, RetireStoreData, RetireStoreResponse, ReinstateStoreData, ReinstateStoreResponse, ListWarehousesData, ListWarehousesResponse, CreateWarehouseData, CreateWarehouseResponse, GetWarehouseData, GetWarehouseResponse, UpdateWarehouseData, UpdateWarehouseResponse, RetireWarehouseData, RetireWarehouseResponse, ReinstateWarehouseData, ReinstateWarehouseResponse, ListWarehouseActivityData, ListWarehouseActivityResponse, GetWarehouseUsageData, GetWarehouseUsageResponse, GetWarehouseRetirePreviewData, GetWarehouseRetirePreviewResponse, ListRetailersData, ListRetailersResponse, CreateRetailerData, CreateRetailerResponse, GetRetailerData, GetRetailerResponse, UpdateRetailerData, UpdateRetailerResponse, RetireRetailerData, RetireRetailerResponse, ReinstateRetailerData, ReinstateRetailerResponse, ListRetailerActivityData, ListRetailerActivityResponse, GetRetailerUsageData, GetRetailerUsageResponse, ListServiceProvidersData, ListServiceProvidersResponse, CreateServiceProviderData, CreateServiceProviderResponse, GetServiceProviderData, GetServiceProviderResponse, UpdateServiceProviderData, UpdateServiceProviderResponse, RetireServiceProviderData, RetireServiceProviderResponse, ReinstateServiceProviderData, ReinstateServiceProviderResponse, ListServiceProviderActivityData, ListServiceProviderActivityResponse, GetServiceProviderUsageData, GetServiceProviderUsageResponse, ListWarehouseNotesData, ListWarehouseNotesResponse, CreateWarehouseNoteData, CreateWarehouseNoteResponse, DeleteWarehouseNoteData, DeleteWarehouseNoteResponse, UpdateWarehouseNoteData, UpdateWarehouseNoteResponse, GetWarehouseTagsData, GetWarehouseTagsResponse, ReplaceWarehouseTagsData, ReplaceWarehouseTagsResponse, GetWarehouseContactsData, GetWarehouseContactsResponse, ReplaceWarehouseContactsData, ReplaceWarehouseContactsResponse, ListBrandNotesData, ListBrandNotesResponse, CreateBrandNoteData, CreateBrandNoteResponse, DeleteBrandNoteData, DeleteBrandNoteResponse, UpdateBrandNoteData, UpdateBrandNoteResponse, GetBrandTagsData, GetBrandTagsResponse, ReplaceBrandTagsData, ReplaceBrandTagsResponse, GetBrandContactsData, GetBrandContactsResponse, ReplaceBrandContactsData, ReplaceBrandContactsResponse, ListMarketplaceNotesData, ListMarketplaceNotesResponse, CreateMarketplaceNoteData, CreateMarketplaceNoteResponse, DeleteMarketplaceNoteData, DeleteMarketplaceNoteResponse, UpdateMarketplaceNoteData, UpdateMarketplaceNoteResponse, GetMarketplaceTagsData, GetMarketplaceTagsResponse, ReplaceMarketplaceTagsData, ReplaceMarketplaceTagsResponse, GetMarketplaceContactsData, GetMarketplaceContactsResponse, ReplaceMarketplaceContactsData, ReplaceMarketplaceContactsResponse, ListVendorNotesData, ListVendorNotesResponse, CreateVendorNoteData, CreateVendorNoteResponse, DeleteVendorNoteData, DeleteVendorNoteResponse, UpdateVendorNoteData, UpdateVendorNoteResponse, GetVendorTagsData, GetVendorTagsResponse, ReplaceVendorTagsData, ReplaceVendorTagsResponse, GetVendorContactsData, GetVendorContactsResponse, ReplaceVendorContactsData, ReplaceVendorContactsResponse, ListRetailerNotesData, ListRetailerNotesResponse, CreateRetailerNoteData, CreateRetailerNoteResponse, DeleteRetailerNoteData, DeleteRetailerNoteResponse, UpdateRetailerNoteData, UpdateRetailerNoteResponse, GetRetailerTagsData, GetRetailerTagsResponse, ReplaceRetailerTagsData, ReplaceRetailerTagsResponse, GetRetailerContactsData, GetRetailerContactsResponse, ReplaceRetailerContactsData, ReplaceRetailerContactsResponse, ListServiceProviderNotesData, ListServiceProviderNotesResponse, CreateServiceProviderNoteData, CreateServiceProviderNoteResponse, DeleteServiceProviderNoteData, DeleteServiceProviderNoteResponse, UpdateServiceProviderNoteData, UpdateServiceProviderNoteResponse, GetServiceProviderTagsData, GetServiceProviderTagsResponse, ReplaceServiceProviderTagsData, ReplaceServiceProviderTagsResponse, GetServiceProviderContactsData, GetServiceProviderContactsResponse, ReplaceServiceProviderContactsData, ReplaceServiceProviderContactsResponse, ListRegistryTagsData, ListRegistryTagsResponse, ListMarketplaceCatalogueData, ListMarketplaceCatalogueResponse, GetMarketplaceCatalogueItemData, GetMarketplaceCatalogueItemResponse, ListMarketplaceFamiliesData, ListMarketplaceFamiliesResponse, ListWarehouseOverviewData, ListWarehouseOverviewResponse, ListWarehouseKindsData, ListWarehouseKindsResponse, ListWarehouseStoresData, ListWarehouseStoresResponse, ReplaceWarehouseStoresData, ReplaceWarehouseStoresResponse, GetStoreCarrierDefaultsData, GetStoreCarrierDefaultsResponse, ListVendorOverviewData, ListVendorOverviewResponse, GetVendorOverviewItemData, GetVendorOverviewItemResponse, ListVendorsData, ListVendorsResponse, CreateVendorData, CreateVendorResponse, GetVendorData, GetVendorResponse, UpdateVendorData, UpdateVendorResponse, RetireVendorData, RetireVendorResponse, ReinstateVendorData, ReinstateVendorResponse, GetVendorRetirePreviewData, GetVendorRetirePreviewResponse, GetVendorUsageData, GetVendorUsageResponse, ListVendorActivityData, ListVendorActivityResponse, GetVendorWarehousesData, GetVendorWarehousesResponse, ReplaceVendorWarehousesData, ReplaceVendorWarehousesResponse, GetVendorTaxIdsData, GetVendorTaxIdsResponse, ReplaceVendorTaxIdsData, ReplaceVendorTaxIdsResponse, BlockStockLookupsData, BlockStockLookupsResponse, ListBlockStockData, ListBlockStockResponse, CreateBlockStockData, CreateBlockStockResponse, ExportBlockStockData, BlockStockLinesData, BlockStockLinesResponse, AddBlockStockLinesData, AddBlockStockLinesResponse, ExportBlockStockLinesData, BlockStockAvailabilityData, BlockStockAvailabilityResponse, UploadBlockStockAvailabilityData, UploadBlockStockAvailabilityResponse, BlockStockAvailabilityTemplateData, ExportBlockStockAvailabilityData, MailBlockStockPackingData, MailBlockStockPackingResponse, UnblockBlockStockData, UnblockBlockStockResponse, ShiftStockData, ShiftStockResponse, ShiftStockByRetailerSkuData, ShiftStockByRetailerSkuResponse, UnblockAndShiftStockData, UnblockAndShiftStockResponse, BoxHistoryData, BoxHistoryResponse, ExportBoxHistoryInwardData, ExportBoxHistoryOutwardData, ExportBoxHistoryShiftData, ValidateWarehouseTransferData, ValidateWarehouseTransferResponse, TransferWarehouseStockData, TransferWarehouseStockResponse, BoxLookupsData, BoxLookupsResponse, BoxFilterChoicesData, BoxFilterChoicesResponse, ListBoxesData, ListBoxesResponse, ExportBoxesData, BoxContentsData, BoxContentsResponse, CashflowLookupsData, CashflowLookupsResponse, GetCashflowData, GetCashflowResponse, ListCashflowDocumentsData, ListCashflowDocumentsResponse, CreditDebitNotesLookupsData, CreditDebitNotesLookupsResponse, ListCreditDebitNotesData, ListCreditDebitNotesResponse, CreateCreditDebitNoteData, CreateCreditDebitNoteResponse, CreditDebitNoteLinesData, CreditDebitNoteLinesResponse, CheckCreditDebitNoteData, CheckCreditDebitNoteResponse, GetCreditDebitNoteData, GetCreditDebitNoteResponse, EditCreditDebitNoteData, EditCreditDebitNoteResponse, ExportCreditDebitNoteData, VoidCreditDebitNoteData, VoidCreditDebitNoteResponse, GlobalShipmentsLookupsData, GlobalShipmentsLookupsResponse, ListGlobalShipmentsData, ListGlobalShipmentsResponse, CreateGlobalShipmentData, CreateGlobalShipmentResponse, GetGlobalShipmentData, GetGlobalShipmentResponse, EditGlobalShipmentData, EditGlobalShipmentResponse, DeleteGlobalShipmentData, DeleteGlobalShipmentResponse, ReplenLookupsData, ReplenLookupsResponse, ListReplenSkusData, ListReplenSkusResponse, CheckReplenSkusData, CheckReplenSkusResponse, ApplyReplenChangesData, ApplyReplenChangesResponse, ListPurchaseOrdersData, ListPurchaseOrdersResponse, CreatePurchaseOrderData, CreatePurchaseOrderResponse, PurchaseOrderLookupsData, PurchaseOrderLookupsResponse, ListPurchaseOrderCodesData, ListPurchaseOrderCodesResponse, CheckPurchaseOrderData, CheckPurchaseOrderResponse, DeletePurchaseOrderData, DeletePurchaseOrderResponse, GetPurchaseOrderData, GetPurchaseOrderResponse, UpdatePurchaseOrderData, UpdatePurchaseOrderResponse, ExportPurchaseOrderLinesData, ReplacePurchaseOrderLinesData, ReplacePurchaseOrderLinesResponse, SetPurchaseOrderAppointmentData, SetPurchaseOrderAppointmentResponse, PurchaseOrderStockAvailabilityData, PurchaseOrderStockAvailabilityResponse, PurchaseOrderAllotmentData, PurchaseOrderAllotmentResponse, AllotPurchaseOrderBoxesData, AllotPurchaseOrderBoxesResponse, MergePurchaseOrdersData, MergePurchaseOrdersResponse, RetailerReceiptsLookupsData, RetailerReceiptsLookupsResponse, ListRetailerReceiptsData, ListRetailerReceiptsResponse, RecordRetailerReceiptData, RecordRetailerReceiptResponse, VoidRetailerReceiptData, VoidRetailerReceiptResponse, ListReviewDocumentsData, ListReviewDocumentsResponse, GetReviewDocumentData, GetReviewDocumentResponse, ExportReviewDocumentData, DecideReviewData, DecideReviewResponse, RequestReviewData, RequestReviewResponse, SalesInvoicesLookupsData, SalesInvoicesLookupsResponse, ListSalesInvoicesData, ListSalesInvoicesResponse, CreateSalesInvoiceData, CreateSalesInvoiceResponse, SalesInvoiceLinesData, SalesInvoiceLinesResponse, PreviewSalesInvoiceData, PreviewSalesInvoiceResponse, CheckSalesInvoiceData, CheckSalesInvoiceResponse, DispatchSalesInvoicesData, DispatchSalesInvoicesResponse, DeliverSalesInvoicesData, DeliverSalesInvoicesResponse, GetSalesInvoiceData, GetSalesInvoiceResponse, EditSalesInvoiceData, EditSalesInvoiceResponse, DeleteSalesInvoiceData, DeleteSalesInvoiceResponse, AddSalesInvoiceBoxData, AddSalesInvoiceBoxResponse, RemoveSalesInvoiceBoxData, RemoveSalesInvoiceBoxResponse, SalesInvoiceMappableBoxesData, SalesInvoiceMappableBoxesResponse, SalesInvoicePackingData, SalesInvoicePackingResponse, ExportSalesInvoicePackingData, ExportSalesInvoiceData, DispatchSalesInvoiceData, DispatchSalesInvoiceResponse, DeliverSalesInvoiceData, DeliverSalesInvoiceResponse, SellerFlexLookupsData, SellerFlexLookupsResponse, SellerFlexStoresData, SellerFlexStoresResponse, ListSellerFlexCountsData, ListSellerFlexCountsResponse, ExportSellerFlexCountsData, SellerFlexSummaryData, SellerFlexSummaryResponse, DeleteSellerFlexCountData, DeleteSellerFlexCountResponse, PreviewSheetData, PreviewSheetResponse, MarkSheetProblemsData, SpInvoicesLookupsData, SpInvoicesLookupsResponse, ListSpInvoicesData, ListSpInvoicesResponse, CreateSpInvoiceData, CreateSpInvoiceResponse, EditSpInvoiceData, EditSpInvoiceResponse, DeleteSpInvoiceData, DeleteSpInvoiceResponse, SpPaymentsLookupsData, SpPaymentsLookupsResponse, ListSpPaymentsData, ListSpPaymentsResponse, RecordSpPaymentData, RecordSpPaymentResponse, VoidSpPaymentData, VoidSpPaymentResponse, StockLookupsData, StockLookupsResponse, StockFiltersData, StockFiltersResponse, GetStockData, GetStockResponse, ExportStockData, StockAgeingLookupsData, StockAgeingLookupsResponse, ListStockAgeingData, ListStockAgeingResponse, StockAgeingCoverageData, StockAgeingCoverageResponse, StockAgeingBoxesData, StockAgeingBoxesResponse, ExportStockAgeingData, VendorInvoicesLookupsData, VendorInvoicesLookupsResponse, ListVendorInvoicesData, ListVendorInvoicesResponse, CreateVendorInvoiceData, CreateVendorInvoiceResponse, VendorInvoiceLinesData, VendorInvoiceLinesResponse, CheckVendorInvoiceData, CheckVendorInvoiceResponse, GetVendorInvoiceData, GetVendorInvoiceResponse, EditVendorInvoiceData, EditVendorInvoiceResponse, ExportVendorInvoiceData, CheckVendorInvoiceLinesData, CheckVendorInvoiceLinesResponse, ReplaceVendorInvoiceLinesData, ReplaceVendorInvoiceLinesResponse, DeleteVendorInvoiceData, DeleteVendorInvoiceResponse, ListVendorOrdersData, ListVendorOrdersResponse, CreateVendorOrderData, CreateVendorOrderResponse, VendorOrderLookupsData, VendorOrderLookupsResponse, ListVendorOrderCodesData, ListVendorOrderCodesResponse, CheckVendorOrderData, CheckVendorOrderResponse, DeleteVendorOrderData, DeleteVendorOrderResponse, GetVendorOrderData, GetVendorOrderResponse, UpdateVendorOrderData, UpdateVendorOrderResponse, ShiftVendorOrderData, ShiftVendorOrderResponse, MergeVendorOrdersData, MergeVendorOrdersResponse, ReplaceVendorOrderLinesData, ReplaceVendorOrderLinesResponse, ExportVendorOrderData, VendorPaymentsLookupsData, VendorPaymentsLookupsResponse, ListVendorPaymentsData, ListVendorPaymentsResponse, RecordVendorPaymentData, RecordVendorPaymentResponse, VoidVendorPaymentData, VoidVendorPaymentResponse, ReportOptionsData, ReportOptionsResponse, ReportMpSalesData, ReportMpSalesResponse, ReportNonmpSalesData, ReportNonmpSalesResponse, ReportMpPaymentsData, ReportMpPaymentsResponse, ReportMpPayoutsData, ReportMpPayoutsResponse, ReportNonmpReceiptsData, ReportNonmpReceiptsResponse, ReportReceivablesData, ReportReceivablesResponse, ReportPnlData, ReportPnlResponse, ReportSkuProfitabilityData, ReportSkuProfitabilityResponse, ReportSkuOrdersData, ReportSkuOrdersResponse, ReportSkuInvoiceLinesData, ReportSkuInvoiceLinesResponse, ReportWhStockData, ReportWhStockResponse, ReportFbaStockData, ReportFbaStockResponse, ReportInTransitData, ReportInTransitResponse, ReportAdsData, ReportAdsResponse, ReportTrafficData, ReportTrafficResponse, ReportVendorSalesData, ReportVendorSalesResponse, ReportVendorInventoryData, ReportVendorInventoryResponse, ReportListingsData, ReportListingsResponse, ReportBusinessViewData, ReportBusinessViewResponse, BusinessViewValuesData, BusinessViewValuesResponse, ExportBusinessViewData, ReportPaymentReconciliationData, ReportPaymentReconciliationResponse, ReportReviewDataData, ReportReviewDataResponse } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * What the caller may do
 * Summarise the caller's permissions and, for scoped ones, their reach.
 *
 * No permission is needed to ask: a caller with none gets empty lists, which
 * is exactly what a client needs to render a "you have no access" page. The
 * organization's reporting currency comes with it, on the same terms.
 */
export const getAccess = <ThrowOnError extends boolean = false>(options?: Options<GetAccessData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAccessResponse, unknown, ThrowOnError>({
        url: '/v1/access',
        ...options
    });
};

/**
 * Is this organization's plumbing working
 * Access-scope publishing to VentaWiz-Auth, and the background job queue.
 *
 * Needs ``registry:view`` (or ``registry:edit``) across the organization.
 */
export const getPlatformStatus = <ThrowOnError extends boolean = false>(options?: Options<GetPlatformStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPlatformStatusResponse, unknown, ThrowOnError>({
        url: '/v1/platform/status',
        ...options
    });
};

/**
 * Republish access scopes
 * Queue a publish of this organization's access scopes, due now.
 *
 * Coalesces with one already waiting, so pressing it twice queues one
 * publish. The answer is the status with the publish queued; poll
 * ``GET /v1/platform/status`` for its outcome. Needs ``registry:edit``
 * across the organization.
 */
export const republishScopeGraph = <ThrowOnError extends boolean = false>(options?: Options<RepublishScopeGraphData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RepublishScopeGraphResponse, unknown, ThrowOnError>({
        url: '/v1/platform/scope-graph/republish',
        ...options
    });
};

/**
 * List organizations
 * Return a page of organizations, newest first.
 */
export const listOrganizations = <ThrowOnError extends boolean = false>(options?: Options<ListOrganizationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListOrganizationsResponse, unknown, ThrowOnError>({
        url: '/v1/organizations',
        ...options
    });
};

/**
 * Fetch an organization
 * Return one organization by id.
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOrganizationResponse, unknown, ThrowOnError>({
        url: '/v1/organizations/{organization_id}',
        ...options
    });
};

/**
 * Change an organization's settings
 * Set the organization's reporting currency, or clear it back to the default.
 *
 * Needs ``tenants:edit`` across the organization.
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateOrganizationResponse, unknown, ThrowOnError>({
        url: '/v1/organizations/{organization_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List orders
 * Return a page of this organization's orders, newest first.
 */
export const listOrders = <ThrowOnError extends boolean = false>(options?: Options<ListOrdersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/orders',
        ...options
    });
};

/**
 * Create an order
 * Import an order.
 *
 * Send an ``Idempotency-Key`` header and a retry after a timeout replays the
 * first attempt's response instead of importing the order twice.
 */
export const createOrder = <ThrowOnError extends boolean = false>(options: Options<CreateOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateOrderResponse, unknown, ThrowOnError>({
        url: '/v1/orders',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete an order
 * Soft-delete an order.
 *
 * The row is retained and filtered from every query — payouts and
 * reconciliations reference it and must outlive it.
 */
export const deleteOrder = <ThrowOnError extends boolean = false>(options: Options<DeleteOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteOrderResponse, unknown, ThrowOnError>({
        url: '/v1/orders/{order_id}',
        ...options
    });
};

/**
 * Fetch an order
 * Return one order by id.
 */
export const getOrder = <ThrowOnError extends boolean = false>(options: Options<GetOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOrderResponse, unknown, ThrowOnError>({
        url: '/v1/orders/{order_id}',
        ...options
    });
};

/**
 * Update an order
 * Apply a partial update and return the order.
 */
export const updateOrder = <ThrowOnError extends boolean = false>(options: Options<UpdateOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateOrderResponse, unknown, ThrowOnError>({
        url: '/v1/orders/{order_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * An order's recorded history
 * Every event recorded for this order, oldest first.
 *
 * What current state cannot answer: not what the order is now, but how it
 * got here.
 */
export const orderTimeline = <ThrowOnError extends boolean = false>(options: Options<OrderTimelineData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<OrderTimelineResponse, unknown, ThrowOnError>({
        url: '/v1/orders/{order_id}/timeline',
        ...options
    });
};

/**
 * List marketing rules
 * The rule catalogue, in catalogue order. Read-only: rules are code.
 */
export const listMarketingRules = <ThrowOnError extends boolean = false>(options?: Options<ListMarketingRulesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMarketingRulesResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rules',
        ...options
    });
};

/**
 * Fetch a marketing rule
 * One rule by its exact, case-sensitive code.
 */
export const getMarketingRule = <ThrowOnError extends boolean = false>(options: Options<GetMarketingRuleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketingRuleResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rules/{rule_code}',
        ...options
    });
};

/**
 * A marketing rule's learned state
 * What the engine has learned about this rule for this organization.
 *
 * 404 until the rule first runs — "never run" and "ran and matched nothing"
 * are different answers.
 */
export const getMarketingRuleState = <ThrowOnError extends boolean = false>(options: Options<GetMarketingRuleStateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketingRuleStateResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rules/{rule_code}/state',
        ...options
    });
};

/**
 * Several rules' learned state at once
 * Every rule on a ticket in one read; a rule with no state is absent.
 */
export const getMarketingLiveCoefficients = <ThrowOnError extends boolean = false>(options: Options<GetMarketingLiveCoefficientsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetMarketingLiveCoefficientsResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/live-coefficients',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List rule executions
 * A page of runs, newest first, without their results.
 */
export const listMarketingRuleExecutions = <ThrowOnError extends boolean = false>(options?: Options<ListMarketingRuleExecutionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMarketingRuleExecutionsResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rule-executions',
        ...options
    });
};

/**
 * Fetch a rule execution
 * One run's summary, and one page of the rows it matched.
 *
 * The rows are paged, filtered by rule and searched here — a run can match
 * tens of thousands. ``rule_counts`` covers every row of the run the caller reaches, unfiltered.
 */
export const getMarketingRuleExecution = <ThrowOnError extends boolean = false>(options: Options<GetMarketingRuleExecutionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketingRuleExecutionResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rule-executions/{execution_id}',
        ...options
    });
};

/**
 * Download a rule execution's result as JSON
 * The run's result as VentaHub's ``execution_<id>.json``, streamed from its rows.
 */
export const downloadMarketingRuleExecution = <ThrowOnError extends boolean = false>(options: Options<DownloadMarketingRuleExecutionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadMarketingRuleExecutionResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rule-executions/{execution_id}/download',
        ...options
    });
};

/**
 * Download a rule execution's validation workbook
 * Summary plus one sheet per rule, VentaHub's validation workbook.
 */
export const downloadMarketingRuleExecutionExcel = <ThrowOnError extends boolean = false>(options: Options<DownloadMarketingRuleExecutionExcelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/marketing/rule-executions/{execution_id}/excel',
        ...options
    });
};

/**
 * Download a rule's audit workbook for one store
 * Detected and Undetected rows for one rule and one store, for reviewer verdicts.
 */
export const downloadMarketingRuleAudit = <ThrowOnError extends boolean = false>(options: Options<DownloadMarketingRuleAuditData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/marketing/rules/{rule_code}/audit-excel',
        ...options
    });
};

/**
 * Dry-run one rule
 * Run one rule as a dry run and return its match rate and sample actions.
 */
export const testMarketingRule = <ThrowOnError extends boolean = false>(options: Options<TestMarketingRuleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TestMarketingRuleResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rules/{rule_code}/test',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Run the marketing rules
 * Run the engine and answer when it has finished.
 *
 * A dry run raises nothing; a run that may act raises T22 tickets — unless
 * the engine's ``dry_run_only`` switch is on, which ``master_dry_run``
 * reports. A store-scoped run is always dry.
 */
export const executeMarketingRules = <ThrowOnError extends boolean = false>(options: Options<ExecuteMarketingRulesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExecuteMarketingRulesResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/execute',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Run the marketing rules, streaming progress
 * Run the engine with live progress as Server-Sent Events.
 *
 * Events: ``run_started``, ``rule_started``, ``rule_finished``,
 * ``rule_skipped``, ``rule_error``, ``phase``, ``tickets_created``, then
 * ``done`` (the run's summary) or ``error`` (the run aborted and wrote
 * nothing). ``: keepalive`` comments fill long queries.
 */
export const streamMarketingRules = <ThrowOnError extends boolean = false>(options?: Options<StreamMarketingRulesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/marketing/execute/stream',
        ...options
    });
};

/**
 * List rule exclusions
 * A page of exclusions, newest first. Expired ones are included and say so.
 */
export const listMarketingRuleExclusions = <ThrowOnError extends boolean = false>(options?: Options<ListMarketingRuleExclusionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMarketingRuleExclusionsResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rule-exclusions',
        ...options
    });
};

/**
 * Create a rule exclusion
 * Stop the engine suggesting anything — or only some rules — for a target.
 */
export const createMarketingRuleExclusion = <ThrowOnError extends boolean = false>(options: Options<CreateMarketingRuleExclusionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMarketingRuleExclusionResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rule-exclusions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a rule exclusion
 * Lift an exclusion. Reversible: the row is kept, out of every query.
 */
export const deleteMarketingRuleExclusion = <ThrowOnError extends boolean = false>(options: Options<DeleteMarketingRuleExclusionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMarketingRuleExclusionResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rule-exclusions/{exclusion_id}',
        ...options
    });
};

/**
 * List rule automation configs
 * A page of automation configs, newest first, with their targets' names.
 *
 * With ``ad_group_ids`` and ``profile_ids`` together, a config on either
 * matches: the AdGroup Master page reads a row's own configs and its store's.
 */
export const listMarketingRuleAutomations = <ThrowOnError extends boolean = false>(options?: Options<ListMarketingRuleAutomationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMarketingRuleAutomationsResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rule-automations',
        ...options
    });
};

/**
 * Set rules' automation mode on a target
 * Put rules into a mode on a profile or ad group.
 *
 * Rules already in another mode on the same target move to this one.
 * Re-sending the same target and mode updates its config in place.
 */
export const setMarketingRuleAutomation = <ThrowOnError extends boolean = false>(options: Options<SetMarketingRuleAutomationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SetMarketingRuleAutomationResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rule-automations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * What automation decided
 * Every suggestion the engine decided, one page of system-decided T22s at a time.
 *
 * ``pagination.total`` counts tickets, not decisions: a page is the next N
 * tickets' worth, as VentaHub paged it.
 */
export const listMarketingAutomationDecisions = <ThrowOnError extends boolean = false>(options?: Options<ListMarketingAutomationDecisionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMarketingAutomationDecisionsResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/automation/decisions',
        ...options
    });
};

/**
 * Shadow mode against reviewers
 * What shadow mode would have accepted, and whether reviewers agreed.
 */
export const getMarketingAutomationShadow = <ThrowOnError extends boolean = false>(options?: Options<GetMarketingAutomationShadowData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMarketingAutomationShadowResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/automation/shadow',
        ...options
    });
};

/**
 * Delete a rule automation config
 * Return a target's rules to human review.
 */
export const deleteMarketingRuleAutomation = <ThrowOnError extends boolean = false>(options: Options<DeleteMarketingRuleAutomationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMarketingRuleAutomationResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rule-automations/{automation_id}',
        ...options
    });
};

/**
 * The rules engine's master switches
 * Current switches. Never-changed switches read as their safe defaults.
 */
export const getMarketingEngineConfig = <ThrowOnError extends boolean = false>(options?: Options<GetMarketingEngineConfigData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMarketingEngineConfigResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/engine-config',
        ...options
    });
};

/**
 * Change the rules engine's master switches
 * Change only the switches sent; the rest keep their values.
 */
export const updateMarketingEngineConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateMarketingEngineConfigData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateMarketingEngineConfigResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/engine-config',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * The rules engine's learning health
 * Per-rule acceptance evidence and the engine's recent activity.
 */
export const getMarketingRulesHealth = <ThrowOnError extends boolean = false>(options?: Options<GetMarketingRulesHealthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMarketingRulesHealthResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/rules-health',
        ...options
    });
};

/**
 * A plain-English reading of the health page
 * The page's snapshot, narrated; an empty narrative and the reason when no model answers.
 */
export const explainMarketingRulesHealth = <ThrowOnError extends boolean = false>(options: Options<ExplainMarketingRulesHealthData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExplainMarketingRulesHealthResponse, unknown, ThrowOnError>({
        url: '/v1/marketing/stats/explain',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List Amazon stores with an Ads profile
 * The stores the advertising pages can show.
 */
export const listAdsStores = <ThrowOnError extends boolean = false>(options?: Options<ListAdsStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAdsStoresResponse, unknown, ThrowOnError>({
        url: '/v1/ams/stores',
        ...options
    });
};

/**
 * List brands for the advertising filters
 * This organization's brands. Bounded by the catalogue, so unpaged.
 */
export const listAdsBrands = <ThrowOnError extends boolean = false>(options?: Options<ListAdsBrandsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAdsBrandsResponse, unknown, ThrowOnError>({
        url: '/v1/ams/brands',
        ...options
    });
};

/**
 * Advertising performance at one level
 * Rows of one kind over a period, optionally against another.
 *
 * The kinds are ad groups, campaigns, ASINs, targets, search terms and
 * alternate products.
 *
 * With a comparison period this is the Review AMS Data page; without, AMS View.
 */
export const getAdsPerformance = <ThrowOnError extends boolean = false>(options: Options<GetAdsPerformanceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAdsPerformanceResponse, unknown, ThrowOnError>({
        url: '/v1/ams/performance',
        ...options
    });
};

/**
 * List negative keywords and targets
 * Negatives as currently configured — not scoped to a date range.
 */
export const listAdsNegatives = <ThrowOnError extends boolean = false>(options?: Options<ListAdsNegativesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAdsNegativesResponse, unknown, ThrowOnError>({
        url: '/v1/ams/negatives',
        ...options
    });
};

/**
 * An advertising metric over time
 * Bucketed sums from the ad-group daily data; one series per currency for money.
 */
export const getAdsTrend = <ThrowOnError extends boolean = false>(options: Options<GetAdsTrendData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAdsTrendResponse, unknown, ThrowOnError>({
        url: '/v1/ams/trend',
        ...options
    });
};

/**
 * Customer search queries and our share of them
 * Market, our-ASIN and our-ads numbers per query, over at most 92 days.
 *
 * The start is moved back to its Sunday: Brand Analytics reports whole weeks.
 */
export const getSearchAnalytics = <ThrowOnError extends boolean = false>(options: Options<GetSearchAnalyticsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSearchAnalyticsResponse, unknown, ThrowOnError>({
        url: '/v1/ams/search-analytics',
        ...options
    });
};

/**
 * Our keywords on one search query
 * Which of our ad keywords served on a query, most impressions first.
 */
export const getSearchQueryKeywords = <ThrowOnError extends boolean = false>(options: Options<GetSearchQueryKeywordsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSearchQueryKeywordsResponse, unknown, ThrowOnError>({
        url: '/v1/ams/search-analytics/keywords',
        ...options
    });
};

/**
 * A store's focus search terms for one week
 * The weekly snapshot, as frozen. Omit ``week_start`` for the latest week.
 */
export const getFocusSearchTermSheet = <ThrowOnError extends boolean = false>(options: Options<GetFocusSearchTermSheetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFocusSearchTermSheetResponse, unknown, ThrowOnError>({
        url: '/v1/ams/focus-search-terms',
        ...options
    });
};

/**
 * Focus search terms with frozen weeks
 * The terms a store's history can be read for, most spend first.
 */
export const listFocusSearchTermHistoryTerms = <ThrowOnError extends boolean = false>(options: Options<ListFocusSearchTermHistoryTermsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListFocusSearchTermHistoryTermsResponse, unknown, ThrowOnError>({
        url: '/v1/ams/focus-search-terms/terms',
        ...options
    });
};

/**
 * One focus search term across weeks
 * Every frozen week of one term, newest first.
 */
export const getFocusSearchTermHistory = <ThrowOnError extends boolean = false>(options: Options<GetFocusSearchTermHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFocusSearchTermHistoryResponse, unknown, ThrowOnError>({
        url: '/v1/ams/focus-search-terms/history',
        ...options
    });
};

/**
 * Changes applied to Amazon Ads
 * What VentaHub applied — edits made in the Amazon console are not here.
 */
export const listAdsChanges = <ThrowOnError extends boolean = false>(options: Options<ListAdsChangesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListAdsChangesResponse, unknown, ThrowOnError>({
        url: '/v1/ams/changes',
        ...options
    });
};

/**
 * Applied changes at a glance
 * Counts honouring the filters, per-tab counts, and the window's filter options.
 */
export const getAdsChangeSummary = <ThrowOnError extends boolean = false>(options: Options<GetAdsChangeSummaryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAdsChangeSummaryResponse, unknown, ThrowOnError>({
        url: '/v1/ams/changes/summary',
        ...options
    });
};

/**
 * Applied changes per day
 * Every day of the window with its changes by outcome, quiet days as zeros.
 */
export const getAdsChangePulse = <ThrowOnError extends boolean = false>(options: Options<GetAdsChangePulseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAdsChangePulseResponse, unknown, ThrowOnError>({
        url: '/v1/ams/changes/pulse',
        ...options
    });
};

/**
 * One target's history
 * Every bid and state a target had, and every change applied to it.
 */
export const getTargetTimeline = <ThrowOnError extends boolean = false>(options: Options<GetTargetTimelineData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTargetTimelineResponse, unknown, ThrowOnError>({
        url: '/v1/ams/changes/targets/{target_id}',
        ...options
    });
};

/**
 * Every target an id or text names
 * One timeline per target id the id or text resolves to, in an ad group if given.
 */
export const listTargetTimelines = <ThrowOnError extends boolean = false>(options: Options<ListTargetTimelinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListTargetTimelinesResponse, unknown, ThrowOnError>({
        url: '/v1/ams/changes/targets/{target_id}/timelines',
        ...options
    });
};

/**
 * One search term's history
 * The parent keyword's bid and the term's status over time, and its changes.
 */
export const getSearchTermTimeline = <ThrowOnError extends boolean = false>(options: Options<GetSearchTermTimelineData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSearchTermTimelineResponse, unknown, ThrowOnError>({
        url: '/v1/ams/changes/search-terms',
        ...options
    });
};

/**
 * One ad group's history
 * Every state an ad group was seen in, and every change applied to it.
 */
export const getAdGroupTimeline = <ThrowOnError extends boolean = false>(options: Options<GetAdGroupTimelineData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAdGroupTimelineResponse, unknown, ThrowOnError>({
        url: '/v1/ams/changes/ad-groups/{ad_group_id}',
        ...options
    });
};

/**
 * One campaign's history
 * A campaign's state, derived from its ad groups, and its budget changes.
 */
export const getCampaignTimeline = <ThrowOnError extends boolean = false>(options: Options<GetCampaignTimelineData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCampaignTimelineResponse, unknown, ThrowOnError>({
        url: '/v1/ams/changes/campaigns/{campaign_id}',
        ...options
    });
};

/**
 * Amazon Ads report pulls
 * The latest attempt at each report, with counts across every status.
 */
export const getReportSync = <ThrowOnError extends boolean = false>(options: Options<GetReportSyncData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetReportSyncResponse, unknown, ThrowOnError>({
        url: '/v1/ams/report-sync',
        ...options
    });
};

/**
 * Report types this organization pulls
 * For the report-type filter. Bounded, so unpaged.
 */
export const listReportTypes = <ThrowOnError extends boolean = false>(options?: Options<ListReportTypesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListReportTypesResponse, unknown, ThrowOnError>({
        url: '/v1/ams/report-sync/types',
        ...options
    });
};

/**
 * List the ad-group master
 * Ad groups with their targets, labels and linked ad groups, by name.
 */
export const listAdGroupMaster = <ThrowOnError extends boolean = false>(options?: Options<ListAdGroupMasterData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAdGroupMasterResponse, unknown, ThrowOnError>({
        url: '/v1/ams/ad-groups',
        ...options
    });
};

/**
 * Download the ad-group master template
 * An empty master sheet with this organization's brands in its dropdown.
 */
export const downloadAdGroupMasterTemplate = <ThrowOnError extends boolean = false>(options?: Options<DownloadAdGroupMasterTemplateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/ams/ad-groups/template',
        ...options
    });
};

/**
 * Stores the ads upload takes, every platform
 * Each store the caller can upload ads data for, with the uploads it takes.
 */
export const listUploadStores = <ThrowOnError extends boolean = false>(options?: Options<ListUploadStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListUploadStoresResponse, unknown, ThrowOnError>({
        url: '/v1/ams/uploads/stores',
        ...options
    });
};

/**
 * Download an ads upload's template
 * The empty sheet the store's upload takes.
 *
 * Raises:
 * ValidationFailed: The store's platform does not take this upload.
 */
export const downloadUploadTemplate = <ThrowOnError extends boolean = false>(options: Options<DownloadUploadTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/ams/uploads/template',
        ...options
    });
};

/**
 * Check an ads upload before raising it
 * What the upload would raise and the values worth confirming; nothing is raised.
 *
 * Raises:
 * ValidationFailed: The file is too large, unreadable, breaks a rule, or
 * changes nothing; or the store does not take this upload.
 */
export const checkUpload = <ThrowOnError extends boolean = false>(options: Options<CheckUploadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckUploadResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/ams/uploads/check',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * My latest ads uploads
 * The caller's last ten ads uploads, every platform, and where each approval stands.
 */
export const listUploads = <ThrowOnError extends boolean = false>(options?: Options<ListUploadsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListUploadsResponse, unknown, ThrowOnError>({
        url: '/v1/ams/uploads',
        ...options
    });
};

/**
 * Raise an ads upload for approval
 * Check the file and raise a T16 approval; nothing changes until it is accepted.
 *
 * Raises:
 * ValidationFailed: The file is too large, unreadable, breaks a rule, or
 * changes nothing; or the store does not take this upload.
 */
export const raiseUpload = <ThrowOnError extends boolean = false>(options: Options<RaiseUploadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RaiseUploadResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/ams/uploads',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Price proposed targets and flag duplicates
 * A calculation, not a change: nothing is stored or sent to Amazon.
 */
export const checkNewTargets = <ThrowOnError extends boolean = false>(options: Options<CheckNewTargetsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckNewTargetsResponse, unknown, ThrowOnError>({
        url: '/v1/ams/target-check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List the Amazon Ads stores the caller can see
 * The store options of both AMS pages (R:320-398), unpaged and ordered by marketplace.
 */
export const amsViewListSellers = <ThrowOnError extends boolean = false>(options?: Options<AmsViewListSellersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AmsViewListSellersResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/sellers',
        ...options
    });
};

/**
 * List brand options for the AMS filters
 * The brands the caller is granted, and whether "Unbranded" is offered.
 */
export const amsViewListBrands = <ThrowOnError extends boolean = false>(options?: Options<AmsViewListBrandsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AmsViewListBrandsResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/brands',
        ...options
    });
};

/**
 * Count enabled and paused ad groups per store
 * The store picker's status badges (R:401-456), zero-filled per store.
 */
export const amsViewGetAdGroupCounts = <ThrowOnError extends boolean = false>(options?: Options<AmsViewGetAdGroupCountsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AmsViewGetAdGroupCountsResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/ad-group-counts',
        ...options
    });
};

/**
 * List ad groups of several stores with window metrics
 * The AMS View main list (R:508-593): every requested store's ad groups, unpaged.
 */
export const amsViewListAdGroups = <ThrowOnError extends boolean = false>(options: Options<AmsViewListAdGroupsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewListAdGroupsResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/ad-groups-multi',
        ...options
    });
};

/**
 * Top ASINs of one ad group by sales
 * The expanded ad-group row's top ASINs (R:596-644).
 *
 * ``limit`` has no upper bound of its own, as in VentaHub, only Postgres's
 * bigint; a negative one was a Postgres error and a 500 there (fix BF-08), and
 * so was one beyond bigint - both are a 422 here.
 */
export const amsViewGetTopAsins = <ThrowOnError extends boolean = false>(options: Options<AmsViewGetTopAsinsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewGetTopAsinsResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/ad-groups/{ad_group_id}/top-asins',
        ...options
    });
};

/**
 * One campaign's metric over time
 * The Campaigns accordion chart (R:647-697): ascending buckets, no gap fill.
 */
export const amsViewGetCampaignTrend = <ThrowOnError extends boolean = false>(options: Options<AmsViewGetCampaignTrendData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewGetCampaignTrendResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/campaigns/{campaign_id}/trend',
        ...options
    });
};

/**
 * One ad group's metric over time
 * The Ad Groups accordion chart (R:700-751): ascending buckets, no gap fill.
 */
export const amsViewGetAdGroupTrend = <ThrowOnError extends boolean = false>(options: Options<AmsViewGetAdGroupTrendData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewGetAdGroupTrendResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/ad-groups/{ad_group_id}/trend',
        ...options
    });
};

/**
 * The page-level metric over time, per currency
 * The Performance Summary chart (R:850-936).
 *
 * Spend and sales come as one point per (period, marketplace currency) — there
 * is no currency conversion — and counts as one point per period with
 * ``currency = ""``.
 */
export const amsViewGetOverallTrend = <ThrowOnError extends boolean = false>(options: Options<AmsViewGetOverallTrendData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewGetOverallTrendResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/trends/overall',
        ...options
    });
};

/**
 * Download the AMS View workbook
 * The page's applied filters as a seven-sheet ``.xlsx`` attachment.
 *
 * Sheets: Summary, Campaigns, AdGroups, ASINs, Targets, Search Terms, Negatives.
 * ``campaigns`` / ``statuses`` / ``ad_group_types`` / ``targeting_types`` are
 * campaign names, ad-group states, types (SP, SB, SD) and targeting types.
 */
export const amsViewExportWorkbook = <ThrowOnError extends boolean = false>(options: Options<AmsViewExportWorkbookData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/ams-view/export',
        ...options
    });
};

/**
 * The drilled ad group's ads (ASINs tab)
 * Every ad of the ad group with its window metrics and the tab's totals (R:1041-1107).
 */
export const amsViewListAdProducts = <ThrowOnError extends boolean = false>(options: Options<AmsViewListAdProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewListAdProductsResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/ad-products/{ad_group_id}',
        ...options
    });
};

/**
 * The drilled ad group's targets
 * Every target of the ad group with its bid, window metrics and totals (R:1110-1190).
 */
export const amsViewListTargets = <ThrowOnError extends boolean = false>(options: Options<AmsViewListTargetsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewListTargetsResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/targets/{ad_group_id}',
        ...options
    });
};

/**
 * The drilled ad group's search terms
 * The window's customer search terms of the ad group and the totals (R:1193-1253).
 */
export const amsViewListSearchTerms = <ThrowOnError extends boolean = false>(options: Options<AmsViewListSearchTermsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewListSearchTermsResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/search-terms/{ad_group_id}',
        ...options
    });
};

/**
 * The drilled ad group's negatives
 * The latest snapshot of each negative keyword or product (R:1256-1310); no window.
 */
export const amsViewListNegatives = <ThrowOnError extends boolean = false>(options: Options<AmsViewListNegativesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewListNegativesResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/negatives/{ad_group_id}',
        ...options
    });
};

/**
 * Other ASINs bought after the ad group's ads
 * The purchased-product report of the ad group, grouped, with totals (R:1422-1490).
 */
export const amsViewListAltProducts = <ThrowOnError extends boolean = false>(options: Options<AmsViewListAltProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewListAltProductsResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/alt-products/{ad_group_id}',
        ...options
    });
};

/**
 * One drilled row's metric over time
 * Ascending buckets of one ASIN, target or search term of the ad group (R:761-847).
 */
export const amsViewGetEntityTrend = <ThrowOnError extends boolean = false>(options: Options<AmsViewGetEntityTrendData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewGetEntityTrendResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/ad-groups/{ad_group_id}/entity-trend',
        ...options
    });
};

/**
 * Trend of one row of an undrilled AMS View tab
 * One undrilled row's metric over time, summed across its ad groups.
 *
 * An aggregate row is one ``(store, entity)`` pair spanning every ad group in
 * scope, so its series sums across them, over the same ad groups and filters
 * the row used. Empty — never an error — for a non-Amazon store, an entity
 * with no rows in the window, or a brand scope that excludes everything.
 */
export const amsViewGetAggregateTrend = <ThrowOnError extends boolean = false>(options: Options<AmsViewGetAggregateTrendData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewGetAggregateTrendResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/aggregate/{level}/trend',
        ...options
    });
};

/**
 * One AMS View tab across every ad group in scope
 * The undrilled view of a detail tab: one row per store and entity.
 *
 * The full row set, up to 20,000 rows with ``truncated`` set when the cap
 * bites, plus per-currency totals over it. Requested stores that are visible
 * but not Amazon stores are reported in ``skipped_store_ids``. Negatives
 * ignore the dates (configuration, not a time series). ``ad_group_ids``
 * absent means no filter; present but empty means no rows.
 */
export const amsViewGetAggregate = <ThrowOnError extends boolean = false>(options: Options<AmsViewGetAggregateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AmsViewGetAggregateResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/aggregate/{level}',
        ...options
    });
};

/**
 * Review rows for one level, two periods
 * One page of a level's rows, each with its current and previous metrics (RR:202-260).
 */
export const reviewAmsListRows = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsListRowsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReviewAmsListRowsResponse, unknown, ThrowOnError>({
        url: '/v1/review-ams-data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Review KPI totals for both periods
 * The KPI strip from the ad-group daily table, whatever tab is open (RR:263-302).
 */
export const reviewAmsGetSummary = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsGetSummaryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReviewAmsGetSummaryResponse, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/summary',
        ...options
    });
};

/**
 * Download the review tab as CSV
 * The tab's full result (capped at 100,000 rows) as CSV (RR:305-400).
 */
export const reviewAmsExportRowsCsv = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsExportRowsCsvData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/export.csv',
        ...options
    });
};

/**
 * Negative keywords, latest snapshot per ad group
 * The store's negatives, each folded over the ad groups carrying it (RR:403-469).
 */
export const reviewAmsListNegatives = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsListNegativesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReviewAmsListNegativesResponse, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/negatives',
        ...options
    });
};

/**
 * Download the negatives as CSV
 * The Negatives tab as CSV, aggregated or one row per instance (RR:472-561).
 */
export const reviewAmsExportNegativesCsv = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsExportNegativesCsvData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/negatives/export.csv',
        ...options
    });
};

/**
 * Ad-group instances of a target row
 * Expand a Target row to its (ad group, target) instances over the current period.
 *
 * Each carries its current bid (live master first), window CPC, the marketplace
 * minimum bid and the CPC- and ASP-formula previews the change-bid modal shows
 * (RR:608-643). Store not visible → 404; start after end → 422.
 */
export const reviewAmsResolveTargetInstances = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsResolveTargetInstancesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReviewAmsResolveTargetInstancesResponse, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/target-instances',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Origin ad groups of a search-term row
 * List the ad groups a search term appeared in over the current period.
 *
 * Each with its six sister slots resolved to names and states (out-of-scope
 * sisters stay unnamed), flagged when the term is already a target there, and
 * the CPC-formula bid from that origin's CPC (RR:646-678).
 */
export const reviewAmsResolveSearchTermOrigins = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsResolveSearchTermOriginsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReviewAmsResolveSearchTermOriginsResponse, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/search-term-origins',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ad groups behind an ASIN row
 * Name the ad groups an ASIN or Alt Product row ran in, with each one's share.
 *
 * ``alt_product`` reads the purchased-product report, which has units and sales
 * only; every other metric is null there (RR:681-732).
 */
export const reviewAmsResolveAdProductInstances = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsResolveAdProductInstancesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReviewAmsResolveAdProductInstancesResponse, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/ad-product-instances',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Brand-wide add-target destinations
 * List every other non-archived ad group of the origin's brand on the store.
 *
 * The brand is the origin ad group's, resolved within the caller's grants; an
 * origin that is not visible is a 404 (RR:735-780). Ineligible destinations are
 * listed with the reason.
 */
export const reviewAmsResolveBrandAdGroups = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsResolveBrandAdGroupsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReviewAmsResolveBrandAdGroupsResponse, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/brand-ad-groups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Whether writes to Amazon Ads are locked
 * The lock behind both pages' "Writes to Amazon are locked" banner. Needs ``ads:view``.
 */
export const amsViewGetAmazonWriteLock = <ThrowOnError extends boolean = false>(options?: Options<AmsViewGetAmazonWriteLockData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AmsViewGetAmazonWriteLockResponse, unknown, ThrowOnError>({
        url: '/v1/ams-view/amazon-write-lock',
        ...options
    });
};

/**
 * Add a keyword or ASIN target through the ad group's sisters
 * Route the target to the exact-match or product-target sister, gate it, refuse it.
 */
export const amsViewAddTarget = <ThrowOnError extends boolean = false>(options: Options<AmsViewAddTargetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/v1/ams-view/target/{ad_group_id}/add',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Add a negative keyword or negative ASIN
 * Check the match type against the ad group's type, then refuse.
 */
export const amsViewAddNegative = <ThrowOnError extends boolean = false>(options: Options<AmsViewAddNegativeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/v1/ams-view/negatives/{ad_group_id}/add',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Enable or pause a negative
 * Find the stored negative, route it by its own type, then refuse.
 */
export const amsViewUpdateNegative = <ThrowOnError extends boolean = false>(options: Options<AmsViewUpdateNegativeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
        url: '/v1/ams-view/negatives/{ad_group_id}/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Advertise a product in the ad group
 * SP ad groups only (AV103), then refuse.
 */
export const amsViewAddAdProduct = <ThrowOnError extends boolean = false>(options: Options<AmsViewAddAdProductData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/v1/ams-view/ad-products/{ad_group_id}/add',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Enable or pause one ad
 * The ad must be the ad group's; SD is refused (AV102); then refuse.
 */
export const amsViewUpdateAdProduct = <ThrowOnError extends boolean = false>(options: Options<AmsViewUpdateAdProductData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
        url: '/v1/ams-view/ad-products/{ad_group_id}/update',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Change a target's bid
 * Compute the CPC, ASP or manual bid VentaHub would send, then refuse.
 */
export const reviewAmsChangeBid = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsChangeBidData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReviewAmsChangeBidResponse, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/actions/change-bid',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Pause a target
 * Route the pause by the target's own family, then refuse.
 */
export const reviewAmsPauseTarget = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsPauseTargetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReviewAmsPauseTargetResponse, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/actions/pause-target',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Add a negative
 * The AMS View negative matrix behind the Review state gate, then refuse.
 */
export const reviewAmsAddNegative = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsAddNegativeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReviewAmsAddNegativeResponse, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/actions/add-negative',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Add a search term as a target
 * Bid from the origin's window CPC, created in the destination; then refuse.
 */
export const reviewAmsAddTarget = <ThrowOnError extends boolean = false>(options: Options<ReviewAmsAddTargetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReviewAmsAddTargetResponse, unknown, ThrowOnError>({
        url: '/v1/review-ams-data/actions/add-target',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * What a bid, a CPC or an ACOS goal would do to one target
 * One scenario per bid asked about; a CPC or ACOS goal is converted to its bid first.
 */
export const bidSimulatorWhatIf = <ThrowOnError extends boolean = false>(options: Options<BidSimulatorWhatIfData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BidSimulatorWhatIfResponse, unknown, ThrowOnError>({
        url: '/v1/bid-simulator/what-if',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * The forecast across a grid of bids, for a chart
 * Half to one-and-a-half times today's bid, in 10-point steps.
 */
export const bidSimulatorCurve = <ThrowOnError extends boolean = false>(options: Options<BidSimulatorCurveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BidSimulatorCurveResponse, unknown, ThrowOnError>({
        url: '/v1/bid-simulator/targets/{ad_group_id}/{target_id}/curve',
        ...options
    });
};

/**
 * What bid this target should be set to, or why no advice is given
 * Advice only: it says what to set, it does not set it. Usually ``no_change``.
 */
export const bidSimulatorRecommendation = <ThrowOnError extends boolean = false>(options: Options<BidSimulatorRecommendationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BidSimulatorRecommendationResponse, unknown, ThrowOnError>({
        url: '/v1/bid-simulator/targets/{ad_group_id}/{target_id}/recommendation',
        ...options
    });
};

/**
 * How the forecast scored on weeks it had not seen
 * The latest backtest's cells; empty until a refit has run for the store.
 */
export const bidSimulatorAccuracy = <ThrowOnError extends boolean = false>(options: Options<BidSimulatorAccuracyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BidSimulatorAccuracyResponse, unknown, ThrowOnError>({
        url: '/v1/bid-simulator/accuracy',
        ...options
    });
};

/**
 * Download the optimization template
 * The blank template: an Input Data sheet to fill and the sheets results go in.
 */
export const downloadOptimizationTemplate = <ThrowOnError extends boolean = false>(options?: Options<DownloadOptimizationTemplateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/marketing/optimization/template',
        ...options
    });
};

/**
 * Compute bid recommendations from a filled-in template
 * Read the Input Data sheet, compute, and return the workbook filled in.
 *
 * A calculation, not a change: the read scope is enough.
 *
 * Raises:
 * ValidationFailed: The file is too large, is not the template, or has
 * text where a number belongs.
 */
export const runOptimizationUpload = <ThrowOnError extends boolean = false>(options: Options<RunOptimizationUploadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/marketing/optimization/run',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Whether cost changes are saved
 * Writable, or read-only with the reason.
 */
export const getCostStatus = <ThrowOnError extends boolean = false>(options?: Options<GetCostStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCostStatusResponse, unknown, ThrowOnError>({
        url: '/v1/costs/status',
        ...options
    });
};

/**
 * The costs page's picker choices
 * Warehouses, vendors, retailers and brands.
 */
export const getCostOptions = <ThrowOnError extends boolean = false>(options?: Options<GetCostOptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCostOptionsResponse, unknown, ThrowOnError>({
        url: '/v1/costs/options',
        ...options
    });
};

/**
 * List current SKU costs
 * Current costs by SKU code, filtered, sortable by any column.
 */
export const listCosts = <ThrowOnError extends boolean = false>(options: Options<ListCostsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListCostsResponse, unknown, ThrowOnError>({
        url: '/v1/costs/{kind}',
        ...options
    });
};

/**
 * Export SKU costs
 * The filtered costs as a workbook.
 */
export const exportCosts = <ThrowOnError extends boolean = false>(options: Options<ExportCostsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/costs/{kind}/export',
        ...options
    });
};

/**
 * Download the cost upload template
 * SKU Code, SKU Cost, VAT Rate, RRP.
 */
export const downloadCostTemplate = <ThrowOnError extends boolean = false>(options: Options<DownloadCostTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/costs/{kind}/template',
        ...options
    });
};

/**
 * Check a cost upload without saving it
 * Row by row: new, update, or what is wrong.
 */
export const previewCostUpload = <ThrowOnError extends boolean = false>(options: Options<PreviewCostUploadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreviewCostUploadResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/costs/{kind}/preview',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Save a cost upload
 * All or nothing: a file with any error saves nothing.
 */
export const commitCostUpload = <ThrowOnError extends boolean = false>(options: Options<CommitCostUploadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CommitCostUploadResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/costs/{kind}/commit',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Remove one SKU cost
 * Retired, not erased.
 */
export const deleteCost = <ThrowOnError extends boolean = false>(options: Options<DeleteCostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCostResponse, unknown, ThrowOnError>({
        url: '/v1/costs/{kind}/{cost_id}',
        ...options
    });
};

/**
 * Change one SKU cost
 * The old row is kept as history; a new current row replaces it.
 */
export const editCost = <ThrowOnError extends boolean = false>(options: Options<EditCostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<EditCostResponse, unknown, ThrowOnError>({
        url: '/v1/costs/{kind}/{cost_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Whether fee uploads are saved
 * Writable, or read-only with the reason.
 */
export const getFeeStatus = <ThrowOnError extends boolean = false>(options?: Options<GetFeeStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetFeeStatusResponse, unknown, ThrowOnError>({
        url: '/v1/fees/status',
        ...options
    });
};

/**
 * Stores fees can be loaded for
 * Every store, with its marketplace's fee template.
 */
export const listFeeStores = <ThrowOnError extends boolean = false>(options?: Options<ListFeeStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFeeStoresResponse, unknown, ThrowOnError>({
        url: '/v1/fees/stores',
        ...options
    });
};

/**
 * List a store's current fees
 * Current fee estimates by product, sortable by any column but ACoS.
 */
export const listFees = <ThrowOnError extends boolean = false>(options: Options<ListFeesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListFeesResponse, unknown, ThrowOnError>({
        url: '/v1/fees',
        ...options
    });
};

/**
 * Export a store's fees
 * The store's fees as a workbook; with ``q`` or filters, the matching products'.
 */
export const exportFees = <ThrowOnError extends boolean = false>(options: Options<ExportFeesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/fees/export',
        ...options
    });
};

/**
 * Download a store's fee template
 * The template for the store's marketplace.
 */
export const downloadFeeTemplate = <ThrowOnError extends boolean = false>(options: Options<DownloadFeeTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/fees/template',
        ...options
    });
};

/**
 * Check a fee upload without saving it
 * Row by row: new, update, or what is wrong.
 */
export const previewFeeUpload = <ThrowOnError extends boolean = false>(options: Options<PreviewFeeUploadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreviewFeeUploadResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/fees/preview',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Save a fee upload
 * All or nothing: a file with any error saves nothing.
 */
export const commitFeeUpload = <ThrowOnError extends boolean = false>(options: Options<CommitFeeUploadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CommitFeeUploadResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/fees/commit',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * List SKUs
 * SKUs by code, filtered, sortable by any column.
 */
export const listSkus = <ThrowOnError extends boolean = false>(options?: Options<ListSkusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListSkusResponse, unknown, ThrowOnError>({
        url: '/v1/skus',
        ...options
    });
};

/**
 * List SKU costs
 * Current SKU costs by code, filtered, sortable by any column.
 */
export const listSkuCosts = <ThrowOnError extends boolean = false>(options?: Options<ListSkuCostsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListSkuCostsResponse, unknown, ThrowOnError>({
        url: '/v1/skus/costs',
        ...options
    });
};

/**
 * Export SKUs or SKU costs
 * The filtered rows as a workbook.
 */
export const exportSheet = <ThrowOnError extends boolean = false>(options: Options<ExportSheetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/skus/sheets/{sheet}/export',
        ...options
    });
};

/**
 * List order lines
 * Order lines, newest order first unless sorted, filtered.
 */
export const listOrderBook = <ThrowOnError extends boolean = false>(options?: Options<ListOrderBookData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListOrderBookResponse, unknown, ThrowOnError>({
        url: '/v1/order-book',
        ...options
    });
};

/**
 * List orders
 * One row per order: what it is, where it stands, what it holds and where it ships.
 *
 * The latest updated first unless sorted. Ship-to is the city and country
 * only, never the buyer.
 */
export const listOrderBookOrders = <ThrowOnError extends boolean = false>(options?: Options<ListOrderBookOrdersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListOrderBookOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/order-book/orders',
        ...options
    });
};

/**
 * Count the filtered orders by status
 * Orders per status group, over the filter less its status: the status tabs.
 */
export const countOrderBookStatuses = <ThrowOnError extends boolean = false>(options?: Options<CountOrderBookStatusesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CountOrderBookStatusesResponse, unknown, ThrowOnError>({
        url: '/v1/order-book/statuses',
        ...options
    });
};

/**
 * Analyse the filtered orders
 * What the filtered orders add up to, every status counted.
 *
 * Statuses, money per currency, orders by day and timing, the 80% products
 * and categories, cancellations and destinations.
 */
export const getOrderBookAnalytics = <ThrowOnError extends boolean = false>(options?: Options<GetOrderBookAnalyticsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOrderBookAnalyticsResponse, unknown, ThrowOnError>({
        url: '/v1/order-book/analytics',
        ...options
    });
};

/**
 * Export orders
 * The filtered orders as a workbook.
 */
export const exportOrderBook = <ThrowOnError extends boolean = false>(options?: Options<ExportOrderBookData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/order-book/export',
        ...options
    });
};

/**
 * Stores orders can be uploaded for
 * Every active store the caller's grants reach, with its marketplace's order template.
 *
 * A deactivated one is absent.
 */
export const listOrderUploadStores = <ThrowOnError extends boolean = false>(options?: Options<ListOrderUploadStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListOrderUploadStoresResponse, unknown, ThrowOnError>({
        url: '/v1/order-book/upload/stores',
        ...options
    });
};

/**
 * One order with its lines
 * No buyer name or address. An order in a store out of the caller's reach is not found.
 */
export const getOrderBookOrder = <ThrowOnError extends boolean = false>(options: Options<GetOrderBookOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOrderBookOrderResponse, unknown, ThrowOnError>({
        url: '/v1/order-book/{order_id}',
        ...options
    });
};

/**
 * Stores, with what each marketplace calls its product key
 * Every store the caller's grants reach, with its marketplace's labels and upload sheet.
 */
export const listProductStores = <ThrowOnError extends boolean = false>(options?: Options<ListProductStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListProductStoresResponse, unknown, ThrowOnError>({
        url: '/v1/product-book/stores',
        ...options
    });
};

/**
 * List a store's listings
 * VentaHub's Product Data, one store at a time, sortable by any stored column.
 *
 * A store out of the caller's reach is not found.
 */
export const listProducts = <ThrowOnError extends boolean = false>(options: Options<ListProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListProductsResponse, unknown, ThrowOnError>({
        url: '/v1/product-book',
        ...options
    });
};

/**
 * Export a store's listings
 * The store's listings as a workbook, with the list's filters.
 */
export const exportProducts = <ThrowOnError extends boolean = false>(options: Options<ExportProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/product-book/export',
        ...options
    });
};

/**
 * Stores, with each marketplace's Return Data sheet
 * Every store the caller's grants reach, with its marketplace's upload sheet.
 */
export const listReturnStores = <ThrowOnError extends boolean = false>(options?: Options<ListReturnStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListReturnStoresResponse, unknown, ThrowOnError>({
        url: '/v1/return-book/stores',
        ...options
    });
};

/**
 * List a store's warehouse returns
 * VentaHub's Return Data, one store at a time, newest first unless sorted.
 *
 * A store out of the caller's reach is not found.
 */
export const listReturns = <ThrowOnError extends boolean = false>(options: Options<ListReturnsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListReturnsResponse, unknown, ThrowOnError>({
        url: '/v1/return-book',
        ...options
    });
};

/**
 * Export a store's returns
 * The store's returns as a workbook, with the list's filters.
 */
export const exportReturns = <ThrowOnError extends boolean = false>(options: Options<ExportReturnsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/return-book/export',
        ...options
    });
};

/**
 * Stores, with each marketplace's Settlement Data sheet
 * Every store the caller's grants reach, with its product label and upload sheet.
 */
export const listSettlementStores = <ThrowOnError extends boolean = false>(options?: Options<ListSettlementStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListSettlementStoresResponse, unknown, ThrowOnError>({
        url: '/v1/settlement-book/stores',
        ...options
    });
};

/**
 * List a store's settlement lines
 * VentaHub's Settlement Data, one store at a time, latest payout first.
 *
 * A store out of the caller's reach is not found.
 */
export const listSettlementLines = <ThrowOnError extends boolean = false>(options: Options<ListSettlementLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListSettlementLinesResponse, unknown, ThrowOnError>({
        url: '/v1/settlement-book',
        ...options
    });
};

/**
 * Export a store's settlement lines
 * The store's settlement lines as a workbook, with the list's filters.
 */
export const exportSettlementLines = <ThrowOnError extends boolean = false>(options: Options<ExportSettlementLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/settlement-book/export',
        ...options
    });
};

/**
 * List Otto and Noon stores
 * The stores this page serves. Few and bounded, so unpaged.
 */
export const listPerformanceMasterStores = <ThrowOnError extends boolean = false>(options?: Options<ListPerformanceMasterStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPerformanceMasterStoresResponse, unknown, ThrowOnError>({
        url: '/v1/performance-master/stores',
        ...options
    });
};

/**
 * Download a store's report template
 * The Otto or Noon template, whichever the store uses.
 */
export const downloadPerformanceMasterTemplate = <ThrowOnError extends boolean = false>(options: Options<DownloadPerformanceMasterTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/performance-master/template',
        ...options
    });
};

/**
 * Read a filled-in report without saving it
 * The rows the file holds, read the way the store's channel reads them.
 *
 * Raises:
 * ValidationFailed: The file is too large or not a readable report.
 */
export const previewPerformanceMaster = <ThrowOnError extends boolean = false>(options: Options<PreviewPerformanceMasterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreviewPerformanceMasterResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/performance-master/preview',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * List campaigns, ad groups or targets to schedule
 * One page of what a schedule can govern, by name.
 *
 * ``pagination.total`` larger than the page is VentaHub's ``capped``: a
 * "select all" over the page is not everything that matches.
 */
export const listDaypartingEntities = <ThrowOnError extends boolean = false>(options: Options<ListDaypartingEntitiesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListDaypartingEntitiesResponse, unknown, ThrowOnError>({
        url: '/v1/dayparting/entities',
        ...options
    });
};

/**
 * Performance by day of week for a selection
 * The selection summed into one Monday-to-Sunday profile, from daily data.
 *
 * Hour of day needs hourly reports, which VentaWiz does not ingest yet.
 */
export const getDaypartingWeekdayProfile = <ThrowOnError extends boolean = false>(options: Options<GetDaypartingWeekdayProfileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDaypartingWeekdayProfileResponse, unknown, ThrowOnError>({
        url: '/v1/dayparting/weekday-profile',
        ...options
    });
};

/**
 * List dayparting schedules
 * A page of schedules, newest first.
 */
export const listDaypartingSchedules = <ThrowOnError extends boolean = false>(options?: Options<ListDaypartingSchedulesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListDaypartingSchedulesResponse, unknown, ThrowOnError>({
        url: '/v1/dayparting/schedules',
        ...options
    });
};

/**
 * Create a dayparting schedule
 * Save a schedule and expand it into what it governs; the hourly worker applies it.
 */
export const createDaypartingSchedule = <ThrowOnError extends boolean = false>(options: Options<CreateDaypartingScheduleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateDaypartingScheduleResponse, unknown, ThrowOnError>({
        url: '/v1/dayparting/schedules',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a dayparting schedule
 * Remove a schedule and queue the revert of what it adjusted.
 *
 * Reversible: the row is kept, out of every query. Only its creator, or a
 * tenant-wide access administrator, may.
 */
export const deleteDaypartingSchedule = <ThrowOnError extends boolean = false>(options: Options<DeleteDaypartingScheduleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteDaypartingScheduleResponse, unknown, ThrowOnError>({
        url: '/v1/dayparting/schedules/{schedule_id}',
        ...options
    });
};

/**
 * Fetch a dayparting schedule
 * One schedule.
 */
export const getDaypartingSchedule = <ThrowOnError extends boolean = false>(options: Options<GetDaypartingScheduleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDaypartingScheduleResponse, unknown, ThrowOnError>({
        url: '/v1/dayparting/schedules/{schedule_id}',
        ...options
    });
};

/**
 * Change a dayparting schedule
 * Change only the fields sent. The selection and the lever are fixed.
 *
 * Turning a schedule off queues a revert of what it has adjusted.
 */
export const updateDaypartingSchedule = <ThrowOnError extends boolean = false>(options: Options<UpdateDaypartingScheduleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateDaypartingScheduleResponse, unknown, ThrowOnError>({
        url: '/v1/dayparting/schedules/{schedule_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List what the dayparting worker did
 * A page of apply and revert attempts, newest first.
 */
export const listDaypartingEvents = <ThrowOnError extends boolean = false>(options?: Options<ListDaypartingEventsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListDaypartingEventsResponse, unknown, ThrowOnError>({
        url: '/v1/dayparting/event-log',
        ...options
    });
};

/**
 * List a person's focused SKUs
 * One page of a list, newest first: one row per listing.
 */
export const listFocusedSkus = <ThrowOnError extends boolean = false>(options?: Options<ListFocusedSkusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFocusedSkusResponse, unknown, ThrowOnError>({
        url: '/v1/focused-skus',
        ...options
    });
};

/**
 * Add listings to a focused-SKU list
 * They also become focused tenant-wide, for tickets.
 */
export const addFocusedSkus = <ThrowOnError extends boolean = false>(options: Options<AddFocusedSkusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddFocusedSkusResponse, unknown, ThrowOnError>({
        url: '/v1/focused-skus',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Remove listings from a focused-SKU list
 * They stay focused tenant-wide; Data Vault un-focuses.
 */
export const removeFocusedSkus = <ThrowOnError extends boolean = false>(options: Options<RemoveFocusedSkusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RemoveFocusedSkusResponse, unknown, ThrowOnError>({
        url: '/v1/focused-skus/remove',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Download the focused-SKU upload template
 * Store, Retailer SKU, Seller SKU, SKU Code, DRR.
 */
export const downloadFocusedSkuTemplate = <ThrowOnError extends boolean = false>(options?: Options<DownloadFocusedSkuTemplateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/focused-skus/template',
        ...options
    });
};

/**
 * Check a focused-SKU upload without saving it
 * Row by row: the listings each row matches, or what is wrong.
 */
export const previewFocusedSkuUpload = <ThrowOnError extends boolean = false>(options: Options<PreviewFocusedSkuUploadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreviewFocusedSkuUploadResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/focused-skus/upload/preview',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Save a focused-SKU upload
 * All or nothing: a file with any error saves nothing.
 */
export const commitFocusedSkuUpload = <ThrowOnError extends boolean = false>(options: Options<CommitFocusedSkuUploadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CommitFocusedSkuUploadResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/focused-skus/upload/commit',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * The focused-SKU sheet's picker choices
 * Warehouses, stores and brands of a list; the periods; the reasons and stock issues.
 */
export const getFocusedSkuSheetOptions = <ThrowOnError extends boolean = false>(options?: Options<GetFocusedSkuSheetOptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetFocusedSkuSheetOptionsResponse, unknown, ThrowOnError>({
        url: '/v1/focused-skus/sheet/options',
        ...options
    });
};

/**
 * A focused-SKU sheet for one week or month
 * Every row, one per SKU; see docs/focused-skus/plan.md §4.3 for each column.
 */
export const getFocusedSkuSheet = <ThrowOnError extends boolean = false>(options?: Options<GetFocusedSkuSheetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetFocusedSkuSheetResponse, unknown, ThrowOnError>({
        url: '/v1/focused-skus/sheet',
        ...options
    });
};

/**
 * Save DRR Miss Reasons and Actions
 * On the latest finished period; a stale version is a 409.
 */
export const saveFocusedSkuNotes = <ThrowOnError extends boolean = false>(options: Options<SaveFocusedSkuNotesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SaveFocusedSkuNotesResponse, unknown, ThrowOnError>({
        url: '/v1/focused-skus/sheet',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Run the auto ordering forecast
 * Each SKU the warehouse sold, holds or awaits: its demand, stock and order.
 *
 * Sales are the last 90 days': the warehouse's stores' marketplace sales
 * and its DF, VO and OF invoices. Stock is the marketplace's at those stores
 * and ours here; in transit is what suppliers are sending here. The order is
 * ``Demand(FD + BD) - Demand(SD) - max(0, stock + in transit - Demand(SD))``.
 *
 * Needs ``operations:view``; PPP, CP and profitability also ``finance:view``.
 * A scoped caller's forecast counts only the rows their grants reach: a
 * warehouse grant, the warehouse's stock, inbound and invoices; a store,
 * marketplace or brand grant, the sales, stock and ads under it.
 */
export const runAutoOrderingForecast = <ThrowOnError extends boolean = false>(options: Options<RunAutoOrderingForecastData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RunAutoOrderingForecastResponse, unknown, ThrowOnError>({
        url: '/v1/operations/auto-ordering/forecast',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Read a planning upload
 * Read an event calendar, price changes or a marketing plan. Stores nothing.
 *
 * All or nothing: when any row is bad the rows are empty and ``errors``
 * says why, the first 20.
 *
 * Raises:
 * ValidationFailed: The file is too large, unreadable, or lacks a column.
 */
export const readAutoOrderingPlanning = <ThrowOnError extends boolean = false>(options: Options<ReadAutoOrderingPlanningData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReadAutoOrderingPlanningResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/operations/auto-ordering/planning/{kind}',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Download a planning template
 * The upload's header row and an example row, dated next month.
 */
export const downloadAutoOrderingTemplate = <ThrowOnError extends boolean = false>(options: Options<DownloadAutoOrderingTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/operations/auto-ordering/planning/{kind}/template',
        ...options
    });
};

/**
 * Vendors that can supply a forecast order
 * Every vendor that quotes all the SKUs at the warehouse in one currency.
 *
 * A SKU without a valid vendor cost there is listed apart: it cannot go on
 * an order until one is uploaded. Reads only. A caller granted vendors
 * rather than the warehouse sees only those vendors' terms.
 *
 * Raises:
 * ResourceNotFound: The warehouse is not the organization's, or out of reach.
 */
export const autoOrderingVendorOptions = <ThrowOnError extends boolean = false>(options: Options<AutoOrderingVendorOptionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AutoOrderingVendorOptionsResponse, unknown, ThrowOnError>({
        url: '/v1/operations/auto-ordering/vendor-options',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * The next auto vendor order code
 * ``AUTO-YYYYMMDD-N``: today's next number at the warehouse. Reserves nothing.
 *
 * Raises:
 * ResourceNotFound: The warehouse is not the organization's, or out of reach.
 */
export const autoOrderingNextVoCode = <ThrowOnError extends boolean = false>(options: Options<AutoOrderingNextVoCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AutoOrderingNextVoCodeResponse, unknown, ThrowOnError>({
        url: '/v1/operations/auto-ordering/next-vo-code',
        ...options
    });
};

/**
 * PO fill rate per store
 * Per store, the POs dated in the window: units ordered, confirmed, delivered, value.
 *
 * Ordered is what Amazon first asked for, cancellations included — the
 * only honest denominator for a fill rate.
 */
export const poFulfilmentSummary = <ThrowOnError extends boolean = false>(options: Options<PoFulfilmentSummaryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PoFulfilmentSummaryResponse, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/summary',
        ...options
    });
};

/**
 * Amazon POs with their fulfilment status
 * The marketplace's POs in the window, newest first.
 */
export const listPoFulfilmentPurchaseOrders = <ThrowOnError extends boolean = false>(options: Options<ListPoFulfilmentPurchaseOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListPoFulfilmentPurchaseOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/purchase-orders',
        ...options
    });
};

/**
 * One Amazon PO
 * Its lines, retailer and warehouses, the plan Create PO would apply, and its next step.
 *
 * Reads only, so it is safe on every expand.
 *
 * Raises:
 * ResourceNotFound: No such PO the caller can see.
 */
export const readPoFulfilmentPurchaseOrder = <ThrowOnError extends boolean = false>(options: Options<ReadPoFulfilmentPurchaseOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReadPoFulfilmentPurchaseOrderResponse, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/purchase-orders/{store_id}/{po_number}',
        ...options
    });
};

/**
 * Create or top up a PO
 * Allocate what no leg covers, write each warehouse's ops PO and block its stock.
 *
 * Never mails and never acknowledges: each is its own action.
 *
 * Raises:
 * FulfilmentWritesDisabled: The actions are switched off.
 * ResourceConflict: Amazon has closed the PO.
 */
export const createPoFulfilmentLegs = <ThrowOnError extends boolean = false>(options: Options<CreatePoFulfilmentLegsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreatePoFulfilmentLegsResponse, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/purchase-orders/{store_id}/{po_number}/create',
        ...options
    });
};

/**
 * Mail the warehouses
 * Queue every leg's packing mail, its block attached. Repeatable.
 *
 * Raises:
 * FulfilmentWritesDisabled: The actions are switched off.
 * ResourceConflict: Amazon has closed the PO, or no leg exists yet.
 */
export const sendPoFulfilmentToWarehouse = <ThrowOnError extends boolean = false>(options: Options<SendPoFulfilmentToWarehouseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SendPoFulfilmentToWarehouseResponse, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/purchase-orders/{store_id}/{po_number}/send',
        ...options
    });
};

/**
 * Acknowledge to Amazon
 * Tell Amazon the units blocked for this PO, as Accepted. Repeatable.
 *
 * Amazon answers later; the PO shows Pending until a job records it.
 *
 * Raises:
 * FulfilmentWritesDisabled: The actions are switched off.
 * ResourceConflict: Amazon has closed the PO.
 * ValidationFailed: Nothing is blocked, or the store has no credentials.
 * UpstreamUnavailable: Amazon refused or gave nothing to track.
 */
export const acknowledgePoFulfilmentPurchaseOrder = <ThrowOnError extends boolean = false>(options: Options<AcknowledgePoFulfilmentPurchaseOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AcknowledgePoFulfilmentPurchaseOrderResponse, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/purchase-orders/{store_id}/{po_number}/acknowledge',
        ...options
    });
};

/**
 * Download the PO fill-rate workbook
 * Summary per store, every PO, and every line, for the marketplace and window.
 */
export const exportPoFulfilmentReport = <ThrowOnError extends boolean = false>(options: Options<ExportPoFulfilmentReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/export',
        ...options
    });
};

/**
 * What the filters can be chosen from
 * Warehouses and retailers.
 */
export const retailerPoFulfilmentLookups = <ThrowOnError extends boolean = false>(options?: Options<RetailerPoFulfilmentLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<RetailerPoFulfilmentLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/retailer/lookups',
        ...options
    });
};

/**
 * PO fulfilment by retailer
 * One row per retailer, most units ordered first, and their total.
 */
export const retailerPoFulfilmentSummary = <ThrowOnError extends boolean = false>(options?: Options<RetailerPoFulfilmentSummaryData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<RetailerPoFulfilmentSummaryResponse, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/retailer/summary',
        ...options
    });
};

/**
 * List POs with how far each has got
 * POs newest first: units at each stage, the fill rate and a status.
 */
export const listRetailerPoFulfilment = <ThrowOnError extends boolean = false>(options?: Options<ListRetailerPoFulfilmentData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListRetailerPoFulfilmentResponse, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/retailer',
        ...options
    });
};

/**
 * Download PO fulfilment
 * The three views, as filtered, as one workbook.
 */
export const exportRetailerPoFulfilment = <ThrowOnError extends boolean = false>(options?: Options<ExportRetailerPoFulfilmentData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/retailer/export',
        ...options
    });
};

/**
 * How far each line of a PO has got
 * Each SKU on the PO, by SKU code.
 */
export const retailerPoFulfilmentLines = <ThrowOnError extends boolean = false>(options: Options<RetailerPoFulfilmentLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<RetailerPoFulfilmentLinesResponse, unknown, ThrowOnError>({
        url: '/v1/operations/po-fulfilment/retailer/{po_id}/lines',
        ...options
    });
};

/**
 * The dashboard's sales and marketing figures
 * Total sales, returns, ad sales, ad spend and ROAS for the window.
 *
 * Each is set against the same window one, two and three months back.
 * Sales are seller sales (``orders:view``) plus vendor and DF sales
 * (``operations:view``); ads need ``ads:view``. A figure the caller may not
 * read is left out; with none, 403.
 */
export const dashboardSalesMarketing = <ThrowOnError extends boolean = false>(options?: Options<DashboardSalesMarketingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardSalesMarketingResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/sales-marketing',
        ...options
    });
};

/**
 * How a figure splits, step by step
 * The figure's total split by each step in turn, largest first.
 *
 * Sales split by category, marketplace, store, brand and product category;
 * returns by all but category; ad sales and spend by marketplace, store
 * and brand. Brands and product categories past 80% fold into "Other".
 */
export const dashboardFlow = <ThrowOnError extends boolean = false>(options: Options<DashboardFlowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DashboardFlowResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/flow',
        ...options
    });
};

/**
 * Where this week or month is heading
 * The window's days, then a forecast to the horizon with its band.
 *
 * Trained on the last 365 days. The projection is the period so far plus
 * the forecast; confidence is how right the same method was over the same
 * horizon recently.
 */
export const dashboardForecast = <ThrowOnError extends boolean = false>(options: Options<DashboardForecastData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DashboardForecastResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/forecast',
        ...options
    });
};

/**
 * Month-over-month growth to the financial year's end
 * Every month from January of last year to March: actual, then projected.
 *
 * The window is fixed; the date filter is not read.
 */
export const dashboardGrowth = <ThrowOnError extends boolean = false>(options?: Options<DashboardGrowthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardGrowthResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/growth',
        ...options
    });
};

/**
 * Focused SKUs that moved most for the worse
 * The last 7 days against the 7 before; only rows that moved for the worse.
 *
 * Needs ``orders:view`` and ``inventory:view``; ads metrics also ``ads:view``.
 */
export const dashboardMovers = <ThrowOnError extends boolean = false>(options?: Options<DashboardMoversData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardMoversResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/focused/movers',
        ...options
    });
};

/**
 * Focused SKUs with no sale in 30 days
 * With their stock and the clicks they drew, most clicked first.
 */
export const dashboardNoSale = <ThrowOnError extends boolean = false>(options?: Options<DashboardNoSaleData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardNoSaleResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/focused/no-sale',
        ...options
    });
};

/**
 * Focused SKUs by days of cover
 * ``(marketplace + warehouse stock) / units a day over 30 days``, fewest days first.
 */
export const dashboardStockCover = <ThrowOnError extends boolean = false>(options?: Options<DashboardStockCoverData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardStockCoverResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/stock-cover',
        ...options
    });
};

/**
 * Stock no marketplace lists
 * SKUs with available units in our warehouses and no live listing anywhere.
 */
export const dashboardSuppressed = <ThrowOnError extends boolean = false>(options?: Options<DashboardSuppressedData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardSuppressedResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/suppressed-inventory',
        ...options
    });
};

/**
 * Sponsored slots won on focused search terms
 * The last 7 days' scrapes: how often a focused ASIN showed, and in a sponsored slot.
 */
export const dashboardAdSlots = <ThrowOnError extends boolean = false>(options?: Options<DashboardAdSlotsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardAdSlotsResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/ad-slots',
        ...options
    });
};

/**
 * Ad groups whose week went wrong
 * Conversion down a quarter on the week before, or ACOS past 1.5x target.
 */
export const dashboardDistressed = <ThrowOnError extends boolean = false>(options?: Options<DashboardDistressedData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardDistressedResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/distressed-ad-groups',
        ...options
    });
};

/**
 * How fresh each store's data is
 * Each store's newest order, stock reading, ads day, settlement and listing price.
 */
export const dashboardFreshness = <ThrowOnError extends boolean = false>(options?: Options<DashboardFreshnessData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardFreshnessResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/data-freshness',
        ...options
    });
};

/**
 * Where the window's marketplace orders ship
 * Seller orders, units and sales per ship-to country, for the sales map.
 *
 * Orders and units count every currency's stores; sales only the
 * currency's, or with ``convert_to`` every currency's, converted. Needs
 * ``orders:view``.
 */
export const dashboardCountries = <ThrowOnError extends boolean = false>(options?: Options<DashboardCountriesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardCountriesResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/countries',
        ...options
    });
};

/**
 * The community forum's activity
 * The top ten threads and the month's ten most active members.
 *
 * ``connected`` is false when the forum is not configured or does not
 * answer; the lists are then empty and nothing fails.
 */
export const dashboardForum = <ThrowOnError extends boolean = false>(options?: Options<DashboardForumData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DashboardForumResponse, unknown, ThrowOnError>({
        url: '/v1/dashboard/forum',
        ...options
    });
};

/**
 * Stores with a frozen focus search term week
 * Stores the caller may open the sheet for: those with at least one frozen week.
 */
export const getFocusTermSheetOptions = <ThrowOnError extends boolean = false>(options?: Options<GetFocusTermSheetOptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetFocusTermSheetOptionsResponse, unknown, ThrowOnError>({
        url: '/v1/focus-search-term/sheet/options',
        ...options
    });
};

/**
 * One frozen week of a store's focus search terms
 * One page of terms, each with its ASINs; only the latest week is editable.
 */
export const getFocusTermSheet = <ThrowOnError extends boolean = false>(options: Options<GetFocusTermSheetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFocusTermSheetResponse, unknown, ThrowOnError>({
        url: '/v1/focus-search-term/sheet',
        ...options
    });
};

/**
 * Save bid actions on the latest focus search term week
 * All or nothing; a term changed since it was loaded is a 409.
 */
export const saveFocusTermBidActions = <ThrowOnError extends boolean = false>(options: Options<SaveFocusTermBidActionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SaveFocusTermBidActionsResponse, unknown, ThrowOnError>({
        url: '/v1/focus-search-term/sheet',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Distinct values of one sheet column
 * For the column's filter list; ``__blank__`` stands for no value.
 */
export const getFocusTermColumnValues = <ThrowOnError extends boolean = false>(options: Options<GetFocusTermColumnValuesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFocusTermColumnValuesResponse, unknown, ThrowOnError>({
        url: '/v1/focus-search-term/sheet/column-values',
        ...options
    });
};

/**
 * Freeze a store's focus search term week
 * The latest completed week, or the one named; Ops edits survive a re-run.
 */
export const runFocusTermSnapshot = <ThrowOnError extends boolean = false>(options: Options<RunFocusTermSnapshotData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RunFocusTermSnapshotResponse, unknown, ThrowOnError>({
        url: '/v1/focus-search-term/sheet/snapshot',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Focus search terms with frozen weeks
 * The history's term picker, by spend, and its brands across every week.
 */
export const getFocusTermHistoryTerms = <ThrowOnError extends boolean = false>(options: Options<GetFocusTermHistoryTermsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFocusTermHistoryTermsResponse, unknown, ThrowOnError>({
        url: '/v1/focus-search-term/history/terms',
        ...options
    });
};

/**
 * One focus search term across its frozen weeks
 * Newest week first, each with its per-ASIN split.
 */
export const getFocusTermHistory = <ThrowOnError extends boolean = false>(options: Options<GetFocusTermHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFocusTermHistoryResponse, unknown, ThrowOnError>({
        url: '/v1/focus-search-term/history',
        ...options
    });
};

/**
 * Record a Search Term Data form entry
 * Puts the term on the store's focus list: the sheet's next snapshot includes it.
 */
export const createSearchTermData = <ThrowOnError extends boolean = false>(options: Options<CreateSearchTermDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateSearchTermDataResponse, unknown, ThrowOnError>({
        url: '/v1/focus-search-term/search-term-data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Your Search Term Data form entries
 * Newest first. Unpaginated, as VentaHub's: a person's entries for a month.
 */
export const listMySearchTermData = <ThrowOnError extends boolean = false>(options?: Options<ListMySearchTermDataData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMySearchTermDataResponse, unknown, ThrowOnError>({
        url: '/v1/focus-search-term/search-term-data/user-history',
        ...options
    });
};

/**
 * List tickets
 * One page of one view, under the filters, newest first by default.
 */
export const listTickets = <ThrowOnError extends boolean = false>(options?: Options<ListTicketsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListTicketsResponse, unknown, ThrowOnError>({
        url: '/v1/tickets',
        ...options
    });
};

/**
 * Raise tickets
 * Raise tickets of one type. A payload may raise several, or none.
 */
export const createTickets = <ThrowOnError extends boolean = false>(options: Options<CreateTicketsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTicketsResponse, unknown, ThrowOnError>({
        url: '/v1/tickets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fetch tickets by id, as list rows
 * The given tickets as list rows, under the list's visibility — for pins.
 */
export const ticketsByIds = <ThrowOnError extends boolean = false>(options: Options<TicketsByIdsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TicketsByIdsResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/by-ids',
        ...options
    });
};

/**
 * Count tickets per view
 * How many tickets every view holds under the same filters, for the tab badges.
 */
export const countTickets = <ThrowOnError extends boolean = false>(options?: Options<CountTicketsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CountTicketsResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/counts',
        ...options
    });
};

/**
 * The caller's ticket worklist by type
 * The caller's worklist, one row per ticket type.
 *
 * The unassigned pool and the caller's in progress and pending are live;
 * what they resolved and reviewed is the week's; overdue is past the ETA.
 * Notifications are left out. Needs ``tickets:view``.
 */
export const ticketWorklist = <ThrowOnError extends boolean = false>(options: Options<TicketWorklistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TicketWorklistResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/worklist',
        ...options
    });
};

/**
 * The caller's tickets done per day
 * How many of the caller's tickets were solved, reviewed or assigned on each day.
 *
 * Every day of the range is listed, zeros included. Needs ``tickets:view``.
 */
export const ticketDoneSeries = <ThrowOnError extends boolean = false>(options: Options<TicketDoneSeriesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TicketDoneSeriesResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/done-series',
        ...options
    });
};

/**
 * What the caller may do with tickets
 * The caller's principal id and whether they hold ``tickets:edit``.
 */
export const getTicketAccess = <ThrowOnError extends boolean = false>(options?: Options<GetTicketAccessData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTicketAccessResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/access',
        ...options
    });
};

/**
 * List ticket types
 * Every type the dashboard lists, by code, with its section and ETA.
 */
export const listTicketTypes = <ThrowOnError extends boolean = false>(options?: Options<ListTicketTypesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListTicketTypesResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/types',
        ...options
    });
};

/**
 * Change a ticket type's ETA
 * Set a type's ETA. It applies to every tenant: the table is global.
 */
export const updateTicketType = <ThrowOnError extends boolean = false>(options: Options<UpdateTicketTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateTicketTypeResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/types/{ticket_type_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Mark notification tickets read
 * Set the read flag on notification tickets; others are ignored.
 */
export const readTicketNotifications = <ThrowOnError extends boolean = false>(options: Options<ReadTicketNotificationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReadTicketNotificationsResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/notifications/read',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Dismiss notification tickets
 * Close notification tickets as RESOLVED and read; others are ignored.
 */
export const dismissTicketNotifications = <ThrowOnError extends boolean = false>(options: Options<DismissTicketNotificationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DismissTicketNotificationsResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/notifications/dismiss',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Run a ticket type's detector
 * Find this tenant's items for a type and raise them, as the job would.
 */
export const raiseDetectedTickets = <ThrowOnError extends boolean = false>(options: Options<RaiseDetectedTicketsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RaiseDetectedTicketsResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/raise/{ticket_type_id}',
        ...options
    });
};

/**
 * Report a problem with a ticket
 * Raise a T8 for the technical team about a ticket; 409 if one is already open.
 */
export const reportTicket = <ThrowOnError extends boolean = false>(options: Options<ReportTicketData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReportTicketResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/report',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Tickets with an open report
 * The ids of tickets somebody has an open report on, to flag them in a list.
 */
export const reportedSourceIds = <ThrowOnError extends boolean = false>(options?: Options<ReportedSourceIdsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReportedSourceIdsResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/reported-source-ids',
        ...options
    });
};

/**
 * Delete a ticket
 * Remove a ticket. Reversible: the row is kept, out of every query.
 */
export const deleteTicket = <ThrowOnError extends boolean = false>(options: Options<DeleteTicketData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteTicketResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/{ticket_id}',
        ...options
    });
};

/**
 * Fetch a ticket
 * One ticket with its items and description.
 */
export const getTicket = <ThrowOnError extends boolean = false>(options: Options<GetTicketData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTicketResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/{ticket_id}',
        ...options
    });
};

/**
 * Edit a ticket you raised
 * Change the payload or description, while nobody has picked it up.
 */
export const updateTicket = <ThrowOnError extends boolean = false>(options: Options<UpdateTicketData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateTicketResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/{ticket_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Assign a ticket
 * Give it an owner; omit ``principal_id`` to take it yourself.
 */
export const assignTicket = <ThrowOnError extends boolean = false>(options: Options<AssignTicketData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AssignTicketResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/{ticket_id}/assign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Unassign a ticket
 * Take its owner off it, back to PENDING.
 */
export const unassignTicket = <ThrowOnError extends boolean = false>(options: Options<UnassignTicketData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnassignTicketResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/{ticket_id}/unassign',
        ...options
    });
};

/**
 * Change a ticket's status
 * Move it, and optionally its progress. REVIEWED needs ``tickets:edit``.
 */
export const changeTicketStatus = <ThrowOnError extends boolean = false>(options: Options<ChangeTicketStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChangeTicketStatusResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/{ticket_id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Decide a ticket's items
 * Hand item-level decisions to the ticket's type.
 */
export const actOnTicket = <ThrowOnError extends boolean = false>(options: Options<ActOnTicketData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ActOnTicketResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/{ticket_id}/actions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List the reports filed on a ticket
 * Every report (T8) raised on this ticket, newest first.
 */
export const listTicketReports = <ThrowOnError extends boolean = false>(options: Options<ListTicketReportsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListTicketReportsResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/{ticket_id}/reports',
        ...options
    });
};

/**
 * List a ticket's comments
 * The conversation, oldest first, without the description.
 */
export const listTicketComments = <ThrowOnError extends boolean = false>(options: Options<ListTicketCommentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListTicketCommentsResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/{ticket_id}/comments',
        ...options
    });
};

/**
 * Comment on a ticket
 * Add a comment. Anyone who can see the ticket may.
 */
export const createTicketComment = <ThrowOnError extends boolean = false>(options: Options<CreateTicketCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTicketCommentResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/{ticket_id}/comments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * The caller's notifications
 * The caller's notifications of the last fortnight, newest first.
 *
 * Only ever the caller's own: assignments to them, comments on tickets they
 * raised or own, mentions of them, and AI Analyst answers they asked to be
 * told about — never their own actions. Read state is the browser's.
 */
export const listNotifications = <ThrowOnError extends boolean = false>(options?: Options<ListNotificationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListNotificationsResponse, unknown, ThrowOnError>({
        url: '/v1/notifications',
        ...options
    });
};

/**
 * Clear a time zone for a page and/or a store
 * Drop one narrowing, so the page falls back to the next in the chain.
 */
export const clearMyTimezone = <ThrowOnError extends boolean = false>(options?: Options<ClearMyTimezoneData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<ClearMyTimezoneResponse, unknown, ThrowOnError>({
        url: '/v1/me/timezones',
        ...options
    });
};

/**
 * The caller's time zones
 * The caller's narrowings, and the zones of every store they may see.
 *
 * Needs only a session: a person with no view permission gets their
 * narrowings and an empty store list.
 */
export const readMyTimezones = <ThrowOnError extends boolean = false>(options?: Options<ReadMyTimezonesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReadMyTimezonesResponse, unknown, ThrowOnError>({
        url: '/v1/me/timezones',
        ...options
    });
};

/**
 * Set a time zone for a page and/or a store
 * Set the zone the caller reads a page's, a store's or both's times in.
 *
 * The same store and page again replaces the zone.
 */
export const setMyTimezone = <ThrowOnError extends boolean = false>(options: Options<SetMyTimezoneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetMyTimezoneResponse, unknown, ThrowOnError>({
        url: '/v1/me/timezones',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List marketplaces for a ticket form
 * The tenant's marketplaces by name: what an item's ``mp_id`` may be.
 */
export const listTicketFormMarketplaces = <ThrowOnError extends boolean = false>(options?: Options<ListTicketFormMarketplacesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListTicketFormMarketplacesResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/forms/marketplaces',
        ...options
    });
};

/**
 * List brands for a ticket form
 * The tenant's brands by name: what a T1 item's ``brand_id`` may be.
 */
export const listTicketFormBrands = <ThrowOnError extends boolean = false>(options?: Options<ListTicketFormBrandsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListTicketFormBrandsResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/forms/brands',
        ...options
    });
};

/**
 * List stores for the ticket filters
 * The tenant's stores with their marketplace: what a ticket's ``store_id`` may be.
 */
export const listTicketFormStores = <ThrowOnError extends boolean = false>(options?: Options<ListTicketFormStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListTicketFormStoresResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/forms/stores',
        ...options
    });
};

/**
 * List warehouses for the ticket filters
 * The tenant's warehouses by name: what a ticket's ``warehouse_id`` may be.
 */
export const listTicketFormWarehouses = <ThrowOnError extends boolean = false>(options?: Options<ListTicketFormWarehousesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListTicketFormWarehousesResponse, unknown, ThrowOnError>({
        url: '/v1/tickets/forms/warehouses',
        ...options
    });
};

/**
 * Download a ticket type's item sheet template
 * The blank sheet a T9 or T10 is raised from: ``retailer_sku``, ``comments``.
 */
export const downloadTicketItemsTemplate = <ThrowOnError extends boolean = false>(options: Options<DownloadTicketItemsTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/tickets/forms/{ticket_type_id}/items-sheet',
        ...options
    });
};

/**
 * Read an uploaded item sheet
 * Read the sheet's rows for the form to preview. Nothing is stored or raised.
 */
export const readTicketItemsSheet = <ThrowOnError extends boolean = false>(options: Options<ReadTicketItemsSheetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReadTicketItemsSheetResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/tickets/forms/{ticket_type_id}/items-sheet',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * The Data Vault landing numbers
 * Listings, SKUs, recent orders per currency, returns and settlement lines.
 */
export const dataVaultSummary = <ThrowOnError extends boolean = false>(options?: Options<DataVaultSummaryData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultSummaryResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/summary',
        ...options
    });
};

/**
 * An orders metric over time
 * Units, revenue or distinct orders per day, week or month, per currency.
 */
export const dataVaultOrdersTrend = <ThrowOnError extends boolean = false>(options?: Options<DataVaultOrdersTrendData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultOrdersTrendResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/orders/trend',
        ...options
    });
};

/**
 * List products
 * One page of products; sortable by any column, filterable by drr, max_price, mfn_shipping_price, min_price, regular_price, sale_price, stock, vat_rate.
 */
export const dataVaultListProducts = <ThrowOnError extends boolean = false>(options?: Options<DataVaultListProductsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultListProductsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/products',
        ...options
    });
};

/**
 * Propose edits to products
 * Writes nothing: raises a T16 approval ticket with each row's before and after values.
 */
export const dataVaultEditProducts = <ThrowOnError extends boolean = false>(options: Options<DataVaultEditProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DataVaultEditProductsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/products',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Export products as .xlsx
 * The same filters as the list, every matching row, capped at 50,000.
 */
export const dataVaultExportProducts = <ThrowOnError extends boolean = false>(options?: Options<DataVaultExportProductsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/data-vault/products/export',
        ...options
    });
};

/**
 * Distinct values of a products column
 * For the column's filter list: searched, paged by cursor, 50 at a time, under every other filter of the list (the column's own is left out).
 */
export const dataVaultValuesProducts = <ThrowOnError extends boolean = false>(options: Options<DataVaultValuesProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultValuesProductsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/products/values',
        ...options
    });
};

/**
 * Roll products up by SKU, brand, category or subcategory
 * Rows missing the level's key are grouped as Unassigned. At most 500 rows.
 */
export const dataVaultAggregateProducts = <ThrowOnError extends boolean = false>(options: Options<DataVaultAggregateProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultAggregateProductsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/products/aggregate',
        ...options
    });
};

/**
 * List internal-skus
 * One page of internal-skus; sortable by any column, filterable by height_cm, length_cm, stores_count, weight_g, width_cm.
 */
export const dataVaultListInternalSkus = <ThrowOnError extends boolean = false>(options?: Options<DataVaultListInternalSkusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultListInternalSkusResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/internal-skus',
        ...options
    });
};

/**
 * Propose edits to internal-skus
 * Writes nothing: raises a T16 approval ticket with each row's before and after values.
 */
export const dataVaultEditInternalSkus = <ThrowOnError extends boolean = false>(options: Options<DataVaultEditInternalSkusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DataVaultEditInternalSkusResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/internal-skus',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Export internal-skus as .xlsx
 * The same filters as the list, every matching row, capped at 50,000.
 */
export const dataVaultExportInternalSkus = <ThrowOnError extends boolean = false>(options?: Options<DataVaultExportInternalSkusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/data-vault/internal-skus/export',
        ...options
    });
};

/**
 * Distinct values of a internal-skus column
 * For the column's filter list: searched, paged by cursor, 50 at a time, under every other filter of the list (the column's own is left out).
 */
export const dataVaultValuesInternalSkus = <ThrowOnError extends boolean = false>(options: Options<DataVaultValuesInternalSkusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultValuesInternalSkusResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/internal-skus/values',
        ...options
    });
};

/**
 * List costs
 * One page of costs; sortable by any column, filterable by additional_cost, purchase_cost, shipping_cost, vendor_rrp, vendor_vat_rate.
 */
export const dataVaultListCosts = <ThrowOnError extends boolean = false>(options?: Options<DataVaultListCostsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultListCostsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/costs',
        ...options
    });
};

/**
 * Propose edits to costs
 * Writes nothing: raises a T16 approval ticket with each row's before and after values.
 */
export const dataVaultEditCosts = <ThrowOnError extends boolean = false>(options: Options<DataVaultEditCostsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DataVaultEditCostsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/costs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Export costs as .xlsx
 * The same filters as the list, every matching row, capped at 50,000.
 */
export const dataVaultExportCosts = <ThrowOnError extends boolean = false>(options?: Options<DataVaultExportCostsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/data-vault/costs/export',
        ...options
    });
};

/**
 * Distinct values of a costs column
 * For the column's filter list: searched, paged by cursor, 50 at a time, under every other filter of the list (the column's own is left out).
 */
export const dataVaultValuesCosts = <ThrowOnError extends boolean = false>(options: Options<DataVaultValuesCostsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultValuesCostsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/costs/values',
        ...options
    });
};

/**
 * Roll costs up by SKU, brand, category or subcategory
 * Rows missing the level's key are grouped as Unassigned. At most 500 rows.
 */
export const dataVaultAggregateCosts = <ThrowOnError extends boolean = false>(options: Options<DataVaultAggregateCostsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultAggregateCostsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/costs/aggregate',
        ...options
    });
};

/**
 * List retailer-costs
 * One page of retailer-costs; sortable by any column, filterable by nlc, rrp, vat_rate.
 */
export const dataVaultListRetailerCosts = <ThrowOnError extends boolean = false>(options?: Options<DataVaultListRetailerCostsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultListRetailerCostsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/retailer-costs',
        ...options
    });
};

/**
 * Propose edits to retailer-costs
 * Writes nothing: raises a T16 approval ticket with each row's before and after values.
 */
export const dataVaultEditRetailerCosts = <ThrowOnError extends boolean = false>(options: Options<DataVaultEditRetailerCostsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DataVaultEditRetailerCostsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/retailer-costs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Export retailer-costs as .xlsx
 * The same filters as the list, every matching row, capped at 50,000.
 */
export const dataVaultExportRetailerCosts = <ThrowOnError extends boolean = false>(options?: Options<DataVaultExportRetailerCostsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/data-vault/retailer-costs/export',
        ...options
    });
};

/**
 * Distinct values of a retailer-costs column
 * For the column's filter list: searched, paged by cursor, 50 at a time, under every other filter of the list (the column's own is left out).
 */
export const dataVaultValuesRetailerCosts = <ThrowOnError extends boolean = false>(options: Options<DataVaultValuesRetailerCostsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultValuesRetailerCostsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/retailer-costs/values',
        ...options
    });
};

/**
 * List fees
 * One page of fees; sortable by any column, filterable by fee_fixed, fee_return_frac, fee_shipping, fee_variable_frac, selling_price, total_fee.
 */
export const dataVaultListFees = <ThrowOnError extends boolean = false>(options?: Options<DataVaultListFeesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultListFeesResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/fees',
        ...options
    });
};

/**
 * Propose edits to fees
 * Writes nothing: raises a T16 approval ticket with each row's before and after values.
 */
export const dataVaultEditFees = <ThrowOnError extends boolean = false>(options: Options<DataVaultEditFeesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DataVaultEditFeesResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/fees',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Export fees as .xlsx
 * The same filters as the list, every matching row, capped at 50,000.
 */
export const dataVaultExportFees = <ThrowOnError extends boolean = false>(options?: Options<DataVaultExportFeesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/data-vault/fees/export',
        ...options
    });
};

/**
 * Distinct values of a fees column
 * For the column's filter list: searched, paged by cursor, 50 at a time, under every other filter of the list (the column's own is left out).
 */
export const dataVaultValuesFees = <ThrowOnError extends boolean = false>(options: Options<DataVaultValuesFeesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultValuesFeesResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/fees/values',
        ...options
    });
};

/**
 * Roll fees up by SKU, brand, category or subcategory
 * Rows missing the level's key are grouped as Unassigned. At most 500 rows.
 */
export const dataVaultAggregateFees = <ThrowOnError extends boolean = false>(options: Options<DataVaultAggregateFeesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultAggregateFeesResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/fees/aggregate',
        ...options
    });
};

/**
 * List orders
 * One page of orders; sortable by any column, filterable by amount_discount, amount_shipping, amount_tax, buying_cost, import_cost, item_price, quantity_cancelled, quantity_ordered, quantity_shipped.
 */
export const dataVaultListOrders = <ThrowOnError extends boolean = false>(options?: Options<DataVaultListOrdersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultListOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/orders',
        ...options
    });
};

/**
 * Propose edits to orders
 * Writes nothing: raises a T16 approval ticket with each row's before and after values.
 */
export const dataVaultEditOrders = <ThrowOnError extends boolean = false>(options: Options<DataVaultEditOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DataVaultEditOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/orders',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Export orders as .xlsx
 * The same filters as the list, every matching row, capped at 50,000.
 */
export const dataVaultExportOrders = <ThrowOnError extends boolean = false>(options?: Options<DataVaultExportOrdersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/data-vault/orders/export',
        ...options
    });
};

/**
 * Distinct values of a orders column
 * For the column's filter list: searched, paged by cursor, 50 at a time, under every other filter of the list (the column's own is left out).
 */
export const dataVaultValuesOrders = <ThrowOnError extends boolean = false>(options: Options<DataVaultValuesOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultValuesOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/orders/values',
        ...options
    });
};

/**
 * Roll orders up by SKU, brand, category or subcategory
 * Rows missing the level's key are grouped as Unassigned. At most 500 rows.
 */
export const dataVaultAggregateOrders = <ThrowOnError extends boolean = false>(options: Options<DataVaultAggregateOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultAggregateOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/orders/aggregate',
        ...options
    });
};

/**
 * List returns
 * One page of returns; sortable by any column, filterable by item_price, quantity, refund_amount.
 */
export const dataVaultListReturns = <ThrowOnError extends boolean = false>(options?: Options<DataVaultListReturnsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultListReturnsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/returns',
        ...options
    });
};

/**
 * Propose edits to returns
 * Writes nothing: raises a T16 approval ticket with each row's before and after values.
 */
export const dataVaultEditReturns = <ThrowOnError extends boolean = false>(options: Options<DataVaultEditReturnsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DataVaultEditReturnsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/returns',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Export returns as .xlsx
 * The same filters as the list, every matching row, capped at 50,000.
 */
export const dataVaultExportReturns = <ThrowOnError extends boolean = false>(options?: Options<DataVaultExportReturnsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/data-vault/returns/export',
        ...options
    });
};

/**
 * Distinct values of a returns column
 * For the column's filter list: searched, paged by cursor, 50 at a time, under every other filter of the list (the column's own is left out).
 */
export const dataVaultValuesReturns = <ThrowOnError extends boolean = false>(options: Options<DataVaultValuesReturnsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultValuesReturnsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/returns/values',
        ...options
    });
};

/**
 * Roll returns up by SKU, brand, category or subcategory
 * Rows missing the level's key are grouped as Unassigned. At most 500 rows.
 */
export const dataVaultAggregateReturns = <ThrowOnError extends boolean = false>(options: Options<DataVaultAggregateReturnsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultAggregateReturnsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/returns/aggregate',
        ...options
    });
};

/**
 * List settlements
 * One page of settlements; sortable by any column, filterable by amount, settlement_total.
 */
export const dataVaultListSettlements = <ThrowOnError extends boolean = false>(options?: Options<DataVaultListSettlementsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultListSettlementsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/settlements',
        ...options
    });
};

/**
 * Propose edits to settlements
 * Writes nothing: raises a T16 approval ticket with each row's before and after values.
 */
export const dataVaultEditSettlements = <ThrowOnError extends boolean = false>(options: Options<DataVaultEditSettlementsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DataVaultEditSettlementsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/settlements',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Export settlements as .xlsx
 * The same filters as the list, every matching row, capped at 50,000.
 */
export const dataVaultExportSettlements = <ThrowOnError extends boolean = false>(options?: Options<DataVaultExportSettlementsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/data-vault/settlements/export',
        ...options
    });
};

/**
 * Distinct values of a settlements column
 * For the column's filter list: searched, paged by cursor, 50 at a time, under every other filter of the list (the column's own is left out).
 */
export const dataVaultValuesSettlements = <ThrowOnError extends boolean = false>(options: Options<DataVaultValuesSettlementsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultValuesSettlementsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/settlements/values',
        ...options
    });
};

/**
 * Roll settlements up by SKU, brand, category or subcategory
 * Rows missing the level's key are grouped as Unassigned. At most 500 rows.
 */
export const dataVaultAggregateSettlements = <ThrowOnError extends boolean = false>(options: Options<DataVaultAggregateSettlementsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultAggregateSettlementsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/settlements/aggregate',
        ...options
    });
};

/**
 * List ticket-exceptions
 * One page of ticket-exceptions; sortable by any column, filterable by no numeric column.
 */
export const dataVaultListTicketExceptions = <ThrowOnError extends boolean = false>(options?: Options<DataVaultListTicketExceptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultListTicketExceptionsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/ticket-exceptions',
        ...options
    });
};

/**
 * Propose edits to ticket-exceptions
 * Writes nothing: raises a T16 approval ticket with each row's before and after values.
 */
export const dataVaultEditTicketExceptions = <ThrowOnError extends boolean = false>(options: Options<DataVaultEditTicketExceptionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DataVaultEditTicketExceptionsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/ticket-exceptions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Export ticket-exceptions as .xlsx
 * The same filters as the list, every matching row, capped at 50,000.
 */
export const dataVaultExportTicketExceptions = <ThrowOnError extends boolean = false>(options?: Options<DataVaultExportTicketExceptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/data-vault/ticket-exceptions/export',
        ...options
    });
};

/**
 * Distinct values of a ticket-exceptions column
 * For the column's filter list: searched, paged by cursor, 50 at a time, under every other filter of the list (the column's own is left out).
 */
export const dataVaultValuesTicketExceptions = <ThrowOnError extends boolean = false>(options: Options<DataVaultValuesTicketExceptionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultValuesTicketExceptionsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/ticket-exceptions/values',
        ...options
    });
};

/**
 * List mail-exceptions
 * One page of mail-exceptions; sortable by any column, filterable by no numeric column.
 */
export const dataVaultListMailExceptions = <ThrowOnError extends boolean = false>(options?: Options<DataVaultListMailExceptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultListMailExceptionsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/mail-exceptions',
        ...options
    });
};

/**
 * Propose edits to mail-exceptions
 * Writes nothing: raises a T16 approval ticket with each row's before and after values.
 */
export const dataVaultEditMailExceptions = <ThrowOnError extends boolean = false>(options: Options<DataVaultEditMailExceptionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<DataVaultEditMailExceptionsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/mail-exceptions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Export mail-exceptions as .xlsx
 * The same filters as the list, every matching row, capped at 50,000.
 */
export const dataVaultExportMailExceptions = <ThrowOnError extends boolean = false>(options?: Options<DataVaultExportMailExceptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/data-vault/mail-exceptions/export',
        ...options
    });
};

/**
 * Distinct values of a mail-exceptions column
 * For the column's filter list: searched, paged by cursor, 50 at a time, under every other filter of the list (the column's own is left out).
 */
export const dataVaultValuesMailExceptions = <ThrowOnError extends boolean = false>(options: Options<DataVaultValuesMailExceptionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DataVaultValuesMailExceptionsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/mail-exceptions/values',
        ...options
    });
};

/**
 * The columns an edit of products may change
 */
export const dataVaultEditableProducts = <ThrowOnError extends boolean = false>(options?: Options<DataVaultEditableProductsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultEditableProductsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/products/editable',
        ...options
    });
};

/**
 * Propose deleting a row of products
 * Writes nothing: raises a T16 approval ticket carrying the row.
 */
export const dataVaultDeleteProducts = <ThrowOnError extends boolean = false>(options: Options<DataVaultDeleteProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DataVaultDeleteProductsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/products/{row_id}',
        ...options
    });
};

/**
 * The columns an edit of internal-skus may change
 */
export const dataVaultEditableInternalSkus = <ThrowOnError extends boolean = false>(options?: Options<DataVaultEditableInternalSkusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultEditableInternalSkusResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/internal-skus/editable',
        ...options
    });
};

/**
 * Propose deleting a row of internal-skus
 * Writes nothing: raises a T16 approval ticket carrying the row.
 */
export const dataVaultDeleteInternalSkus = <ThrowOnError extends boolean = false>(options: Options<DataVaultDeleteInternalSkusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DataVaultDeleteInternalSkusResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/internal-skus/{row_id}',
        ...options
    });
};

/**
 * The columns an edit of costs may change
 */
export const dataVaultEditableCosts = <ThrowOnError extends boolean = false>(options?: Options<DataVaultEditableCostsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultEditableCostsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/costs/editable',
        ...options
    });
};

/**
 * Propose deleting a row of costs
 * Writes nothing: raises a T16 approval ticket carrying the row.
 */
export const dataVaultDeleteCosts = <ThrowOnError extends boolean = false>(options: Options<DataVaultDeleteCostsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DataVaultDeleteCostsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/costs/{row_id}',
        ...options
    });
};

/**
 * The columns an edit of retailer-costs may change
 */
export const dataVaultEditableRetailerCosts = <ThrowOnError extends boolean = false>(options?: Options<DataVaultEditableRetailerCostsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultEditableRetailerCostsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/retailer-costs/editable',
        ...options
    });
};

/**
 * Propose deleting a row of retailer-costs
 * Writes nothing: raises a T16 approval ticket carrying the row.
 */
export const dataVaultDeleteRetailerCosts = <ThrowOnError extends boolean = false>(options: Options<DataVaultDeleteRetailerCostsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DataVaultDeleteRetailerCostsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/retailer-costs/{row_id}',
        ...options
    });
};

/**
 * The columns an edit of orders may change
 */
export const dataVaultEditableOrders = <ThrowOnError extends boolean = false>(options?: Options<DataVaultEditableOrdersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultEditableOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/orders/editable',
        ...options
    });
};

/**
 * Propose deleting a row of orders
 * Writes nothing: raises a T16 approval ticket carrying the row.
 */
export const dataVaultDeleteOrders = <ThrowOnError extends boolean = false>(options: Options<DataVaultDeleteOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DataVaultDeleteOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/orders/{row_id}',
        ...options
    });
};

/**
 * The columns an edit of returns may change
 */
export const dataVaultEditableReturns = <ThrowOnError extends boolean = false>(options?: Options<DataVaultEditableReturnsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultEditableReturnsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/returns/editable',
        ...options
    });
};

/**
 * Propose deleting a row of returns
 * Writes nothing: raises a T16 approval ticket carrying the row.
 */
export const dataVaultDeleteReturns = <ThrowOnError extends boolean = false>(options: Options<DataVaultDeleteReturnsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DataVaultDeleteReturnsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/returns/{row_id}',
        ...options
    });
};

/**
 * The columns an edit of settlements may change
 */
export const dataVaultEditableSettlements = <ThrowOnError extends boolean = false>(options?: Options<DataVaultEditableSettlementsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultEditableSettlementsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/settlements/editable',
        ...options
    });
};

/**
 * Propose deleting a row of settlements
 * Writes nothing: raises a T16 approval ticket carrying the row.
 */
export const dataVaultDeleteSettlements = <ThrowOnError extends boolean = false>(options: Options<DataVaultDeleteSettlementsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DataVaultDeleteSettlementsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/settlements/{row_id}',
        ...options
    });
};

/**
 * The columns an edit of fees may change
 */
export const dataVaultEditableFees = <ThrowOnError extends boolean = false>(options?: Options<DataVaultEditableFeesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultEditableFeesResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/fees/editable',
        ...options
    });
};

/**
 * Propose deleting a row of fees
 * Writes nothing: raises a T16 approval ticket carrying the row.
 */
export const dataVaultDeleteFees = <ThrowOnError extends boolean = false>(options: Options<DataVaultDeleteFeesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DataVaultDeleteFeesResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/fees/{row_id}',
        ...options
    });
};

/**
 * The columns an edit of ticket-exceptions may change
 */
export const dataVaultEditableTicketExceptions = <ThrowOnError extends boolean = false>(options?: Options<DataVaultEditableTicketExceptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultEditableTicketExceptionsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/ticket-exceptions/editable',
        ...options
    });
};

/**
 * Propose deleting a row of ticket-exceptions
 * Writes nothing: raises a T16 approval ticket carrying the row.
 */
export const dataVaultDeleteTicketExceptions = <ThrowOnError extends boolean = false>(options: Options<DataVaultDeleteTicketExceptionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DataVaultDeleteTicketExceptionsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/ticket-exceptions/{row_id}',
        ...options
    });
};

/**
 * The columns an edit of mail-exceptions may change
 */
export const dataVaultEditableMailExceptions = <ThrowOnError extends boolean = false>(options?: Options<DataVaultEditableMailExceptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<DataVaultEditableMailExceptionsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/mail-exceptions/editable',
        ...options
    });
};

/**
 * Propose deleting a row of mail-exceptions
 * Writes nothing: raises a T16 approval ticket carrying the row.
 */
export const dataVaultDeleteMailExceptions = <ThrowOnError extends boolean = false>(options: Options<DataVaultDeleteMailExceptionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DataVaultDeleteMailExceptionsResponse, unknown, ThrowOnError>({
        url: '/v1/data-vault/mail-exceptions/{row_id}',
        ...options
    });
};

/**
 * List warehouses the caller may filter by
 * Granted warehouses, by name.
 */
export const lookupWarehouses = <ThrowOnError extends boolean = false>(options?: Options<LookupWarehousesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LookupWarehousesResponse, unknown, ThrowOnError>({
        url: '/v1/lookups/warehouses',
        ...options
    });
};

/**
 * List marketplaces the caller may filter by
 * Granted marketplaces, by name; a store grant reaches its marketplace.
 */
export const lookupMarketplaces = <ThrowOnError extends boolean = false>(options?: Options<LookupMarketplacesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LookupMarketplacesResponse, unknown, ThrowOnError>({
        url: '/v1/lookups/marketplaces',
        ...options
    });
};

/**
 * List stores the caller may filter by
 * Granted stores, by name, with their marketplace.
 */
export const lookupStores = <ThrowOnError extends boolean = false>(options?: Options<LookupStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LookupStoresResponse, unknown, ThrowOnError>({
        url: '/v1/lookups/stores',
        ...options
    });
};

/**
 * List brands the caller may filter by
 * Granted brands, by name.
 */
export const lookupBrands = <ThrowOnError extends boolean = false>(options?: Options<LookupBrandsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LookupBrandsResponse, unknown, ThrowOnError>({
        url: '/v1/lookups/brands',
        ...options
    });
};

/**
 * List categories with their subcategories
 * Distinct categories of the granted SKUs, each with its subcategories.
 */
export const lookupCategories = <ThrowOnError extends boolean = false>(options?: Options<LookupCategoriesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LookupCategoriesResponse, unknown, ThrowOnError>({
        url: '/v1/lookups/categories',
        ...options
    });
};

/**
 * List vendors
 * Granted active vendors, by name, from this service's own database.
 */
export const lookupVendors = <ThrowOnError extends boolean = false>(options?: Options<LookupVendorsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LookupVendorsResponse, unknown, ThrowOnError>({
        url: '/v1/lookups/vendors',
        ...options
    });
};

/**
 * List retailers
 * Granted retailers, by name.
 */
export const lookupRetailers = <ThrowOnError extends boolean = false>(options?: Options<LookupRetailersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LookupRetailersResponse, unknown, ThrowOnError>({
        url: '/v1/lookups/retailers',
        ...options
    });
};

/**
 * List stores
 * Return a page of this organization's stores, by name.
 */
export const listCatalogueStores = <ThrowOnError extends boolean = false>(options?: Options<ListCatalogueStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListCatalogueStoresResponse, unknown, ThrowOnError>({
        url: '/v1/catalogue/stores',
        ...options
    });
};

/**
 * List a store's listings
 * Return a page of one store's listings, ordered by `sort`.
 */
export const listCatalogueListings = <ThrowOnError extends boolean = false>(options: Options<ListCatalogueListingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListCatalogueListingsResponse, unknown, ThrowOnError>({
        url: '/v1/catalogue/listings',
        ...options
    });
};

/**
 * Download a store's listings as Excel
 * Every listing the list view would page through — same search, same order.
 */
export const exportCatalogueListings = <ThrowOnError extends boolean = false>(options: Options<ExportCatalogueListingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ExportCatalogueListingsResponse, unknown, ThrowOnError>({
        url: '/v1/catalogue/listings/export',
        ...options
    });
};

/**
 * List stores a job can run against
 * This tenant's stores that are enabled for Amazon Selling Partner API.
 *
 * Only stores with all three credentials and a live marketplace are listed:
 * the same definition the ingestion connectors use, so a store that can
 * fetch orders can fetch a listing.
 */
export const listAiListingStores = <ThrowOnError extends boolean = false>(options?: Options<ListAiListingStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAiListingStoresResponse, unknown, ThrowOnError>({
        url: '/v1/ai-listing/stores',
        ...options
    });
};

/**
 * List listing jobs
 * This tenant's jobs, newest first.
 */
export const listAiListingJobs = <ThrowOnError extends boolean = false>(options?: Options<ListAiListingJobsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAiListingJobsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-listing/jobs',
        ...options
    });
};

/**
 * Start a listing job
 * Fetch an ASIN's listing and generate new copy and images for it.
 *
 * Spends one of today's runs. Send an ``Idempotency-Key`` header and a retry
 * after a timeout replays the first response instead of paying for a
 * second run.
 */
export const createAiListingJob = <ThrowOnError extends boolean = false>(options: Options<CreateAiListingJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateAiListingJobResponse, unknown, ThrowOnError>({
        url: '/v1/ai-listing/jobs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fetch a listing job
 * One job in full — poll this while it runs.
 *
 * Image URLs are presigned for an hour and differ on every call; watch each
 * image's ``version`` to know a re-roll has landed.
 */
export const getAiListingJob = <ThrowOnError extends boolean = false>(options: Options<GetAiListingJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAiListingJobResponse, unknown, ThrowOnError>({
        url: '/v1/ai-listing/jobs/{job_id}',
        ...options
    });
};

/**
 * Save what the seller kept
 * Store the seller's choices, replacing what was saved before.
 */
export const saveAiListingSelections = <ThrowOnError extends boolean = false>(options: Options<SaveAiListingSelectionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SaveAiListingSelectionsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-listing/jobs/{job_id}/selections',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Re-roll one image
 * Queue a re-roll of one image, optionally from the seller's description.
 *
 * Spends one of today's regenerations. The job must have completed.
 */
export const regenerateAiListingImage = <ThrowOnError extends boolean = false>(options: Options<RegenerateAiListingImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RegenerateAiListingImageResponse, unknown, ThrowOnError>({
        url: '/v1/ai-listing/jobs/{job_id}/images/{image_id}/regenerate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Re-roll one tab of images
 * Queue a re-roll of every image in one tab.
 *
 * Spends one of today's regenerations, however many images the tab holds.
 */
export const regenerateAiListingCategory = <ThrowOnError extends boolean = false>(options: Options<RegenerateAiListingCategoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RegenerateAiListingCategoryResponse, unknown, ThrowOnError>({
        url: '/v1/ai-listing/jobs/{job_id}/categories/{category}/regenerate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Today's allowances
 * How many runs and regenerations the caller has left today.
 */
export const getAiListingUsage = <ThrowOnError extends boolean = false>(options?: Options<GetAiListingUsageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAiListingUsageResponse, unknown, ThrowOnError>({
        url: '/v1/ai-listing/usage',
        ...options
    });
};

/**
 * Fetch a listing image through the API
 * Stream a listing image back on this origin.
 *
 * For the ZIP export: neither Amazon's CDN nor the S3 bucket sends CORS
 * headers, so a browser cannot read the bytes itself. Only hosts that serve
 * listing imagery are fetched.
 */
export const proxyAiListingImage = <ThrowOnError extends boolean = false>(options: Options<ProxyAiListingImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/ai-listing/image-proxy',
        ...options
    });
};

/**
 * What the caller may do with the AI Analyst
 * Whether to show the analyst, company memory controls, Debug and the review console.
 *
 * Needs no permission: a caller who may not use the analyst learns exactly
 * that. Hiding a control is UX, not authorization; every route checks again.
 */
export const readMyAnalystAccess = <ThrowOnError extends boolean = false>(options?: Options<ReadMyAnalystAccessData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReadMyAnalystAccessResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/me',
        ...options
    });
};

/**
 * The caller's conversations
 * Conversations with at least one message, pinned first then most recently active.
 *
 * A message-text match comes with ``match_snippet``, matched words in ``<<...>>``.
 */
export const listConversations = <ThrowOnError extends boolean = false>(options?: Options<ListConversationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListConversationsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/conversations',
        ...options
    });
};

/**
 * Start a conversation
 * An empty conversation; the first question can also start one.
 */
export const createConversation = <ThrowOnError extends boolean = false>(options: Options<CreateConversationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateConversationResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/conversations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Remove several conversations
 * Remove several of the caller's conversations; ids that are not theirs are ignored.
 */
export const bulkDeleteConversations = <ThrowOnError extends boolean = false>(options: Options<BulkDeleteConversationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BulkDeleteConversationsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/conversations/bulk-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Remove a conversation
 * Remove one of the caller's conversations from their history.
 */
export const deleteConversation = <ThrowOnError extends boolean = false>(options: Options<DeleteConversationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteConversationResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/conversations/{conversation_id}',
        ...options
    });
};

/**
 * Rename, pin, share, tag or re-pin
 * Change one of the caller's conversations; an omitted field is unchanged.
 */
export const updateConversation = <ThrowOnError extends boolean = false>(options: Options<UpdateConversationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateConversationResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/conversations/{conversation_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A conversation's messages
 * Messages for rendering a conversation; ``active_run_id`` tells the client to re-attach.
 */
export const readConversationMessages = <ThrowOnError extends boolean = false>(options: Options<ReadConversationMessagesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReadConversationMessagesResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/conversations/{conversation_id}/messages',
        ...options
    });
};

/**
 * Export a conversation
 * The whole conversation (questions, answers, tables, insights) as Markdown or Word.
 */
export const exportConversation = <ThrowOnError extends boolean = false>(options: Options<ExportConversationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/conversations/{conversation_id}/export',
        ...options
    });
};

/**
 * Re-attach to the answer in progress
 * The conversation's answer in progress, replayed from its start; 204 when there is none.
 *
 * What ``useChat({resume: true})`` calls on page load: it knows the
 * conversation, not the run.
 */
export const resumeConversationStream = <ThrowOnError extends boolean = false>(options: Options<ResumeConversationStreamData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ResumeConversationStreamResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/conversations/{conversation_id}/stream',
        ...options
    });
};

/**
 * Read a shared conversation
 * A conversation someone shared in this organization, read-only; 404 when it is not shared.
 */
export const readSharedConversation = <ThrowOnError extends boolean = false>(options: Options<ReadSharedConversationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReadSharedConversationResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/shared/{conversation_id}',
        ...options
    });
};

/**
 * Ask a question and stream the answer
 * Queue a run for the question and stream its answer.
 *
 * ``X-Conversation-Id`` names the conversation and ``X-Run-Id`` the run.
 * Snapshots always run deep; ``debug`` is dropped for anyone but a reviewer.
 */
export const chat = <ThrowOnError extends boolean = false>(options: Options<ChatData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, ChatError, ThrowOnError>({
        url: '/v1/ai-analyst/chat/stream',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Re-attach to a run's stream
 * One of the caller's runs, replayed from its start; 204 once its stream has expired.
 */
export const resumeRunStream = <ThrowOnError extends boolean = false>(options: Options<ResumeRunStreamData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ResumeRunStreamResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/runs/{run_id}/stream',
        ...options
    });
};

/**
 * Stop an answer
 * Ask one of the caller's answers to stop; it stops at its next step.
 */
export const cancelRun = <ThrowOnError extends boolean = false>(options: Options<CancelRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelRunResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/runs/{run_id}/cancel',
        ...options
    });
};

/**
 * Rate an answer
 * 1 helpful, -1 not helpful (opens a review flag), 0 clears the rating.
 */
export const rateAnswer = <ThrowOnError extends boolean = false>(options: Options<RateAnswerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RateAnswerResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/runs/{run_id}/feedback',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Record an implicit signal
 * Dig deeper, copied or shared: what the browser sees about an answer.
 */
export const recordAnswerSignal = <ThrowOnError extends boolean = false>(options: Options<RecordAnswerSignalData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RecordAnswerSignalResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/runs/{run_id}/signal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A stored result
 * The evidence behind an answer, at most 200 rows; the export has the rest.
 */
export const readResult = <ThrowOnError extends boolean = false>(options: Options<ReadResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReadResultResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/results/{result_id}',
        ...options
    });
};

/**
 * Export a stored result
 * A stored result as CSV or Excel, with human-readable headers.
 */
export const exportResult = <ThrowOnError extends boolean = false>(options: Options<ExportResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/results/{result_id}/export',
        ...options
    });
};

/**
 * How long answers usually take
 * Typical duration and cost of recent fast, deep and snapshot answers.
 */
export const readTiming = <ThrowOnError extends boolean = false>(options?: Options<ReadTimingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReadTimingResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/timing',
        ...options
    });
};

/**
 * What the caller may pin
 * Stores, brands and warehouses the caller may pin, from their own access.
 */
export const readScopeOptions = <ThrowOnError extends boolean = false>(options?: Options<ReadScopeOptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReadScopeOptionsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/scope-options',
        ...options
    });
};

/**
 * Today's allowance used
 * How much of today's allowance is used; ``percent`` 100 refuses the next question.
 */
export const readUsage = <ThrowOnError extends boolean = false>(options?: Options<ReadUsageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReadUsageResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/usage',
        ...options
    });
};

/**
 * What the analyst remembers
 * The organization's memories and the caller's own, newest first.
 */
export const listMemory = <ThrowOnError extends boolean = false>(options?: Options<ListMemoryData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMemoryResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/memory',
        ...options
    });
};

/**
 * Remember something
 * For the caller, or (``ai_analyst:edit``) for everyone in the organization.
 */
export const addMemory = <ThrowOnError extends boolean = false>(options: Options<AddMemoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddMemoryResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/memory',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Forget a memory
 * The caller's own memory, or (``ai_analyst:edit``) a company one.
 */
export const deleteMemory = <ThrowOnError extends boolean = false>(options: Options<DeleteMemoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMemoryResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/memory/{memory_id}',
        ...options
    });
};

/**
 * The caller's saved reports
 * Saved snapshots, newest first, without their data.
 */
export const listReports = <ThrowOnError extends boolean = false>(options?: Options<ListReportsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListReportsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/reports',
        ...options
    });
};

/**
 * Save a snapshot
 * Save the snapshot in one of the caller's answers; 404 when it has none.
 */
export const saveReport = <ThrowOnError extends boolean = false>(options: Options<SaveReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveReportResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/reports',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Two saved reports side by side
 * Two of the caller's reports with their snapshots, the insights matched by area.
 *
 * 404 when either is not the caller's; 422 unless exactly two ids are named.
 */
export const compareReports = <ThrowOnError extends boolean = false>(options: Options<CompareReportsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CompareReportsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/reports/compare',
        ...options
    });
};

/**
 * Delete a report
 * Remove one of the caller's reports.
 */
export const deleteReport = <ThrowOnError extends boolean = false>(options: Options<DeleteReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteReportResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/reports/{report_id}',
        ...options
    });
};

/**
 * One saved report
 * One of the caller's reports, with its snapshot.
 */
export const readReport = <ThrowOnError extends boolean = false>(options: Options<ReadReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReadReportResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/reports/{report_id}',
        ...options
    });
};

/**
 * The question log
 * Every run in the tenant, newest first; a flag or feedback filter keeps runs with one.
 */
export const adminListQuestions = <ThrowOnError extends boolean = false>(options?: Options<AdminListQuestionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminListQuestionsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/questions',
        ...options
    });
};

/**
 * One run's full trace
 * The question, the answer as streamed, every step with its SQL, the models and usage.
 */
export const adminReadRunTrace = <ThrowOnError extends boolean = false>(options: Options<AdminReadRunTraceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AdminReadRunTraceResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/runs/{run_id}',
        ...options
    });
};

/**
 * Resolve, reopen or annotate a flag
 * Set a flag's status, note and fix reference; the response is its new state.
 */
export const adminUpdateFlag = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateFlagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AdminUpdateFlagResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/flags/{flag_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Usage per person
 * Each person's usage over the last ``days`` budget days, costliest first, with limits.
 */
export const adminListUsage = <ThrowOnError extends boolean = false>(options?: Options<AdminListUsageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminListUsageResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/usage',
        ...options
    });
};

/**
 * Restore a person's default limits
 * Drop their own limits ("Use defaults").
 */
export const adminResetBudget = <ThrowOnError extends boolean = false>(options: Options<AdminResetBudgetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AdminResetBudgetResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/budgets/{principal_id}',
        ...options
    });
};

/**
 * A person's daily limits
 * Their own limits; nulls when the defaults apply.
 */
export const adminReadBudget = <ThrowOnError extends boolean = false>(options: Options<AdminReadBudgetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AdminReadBudgetResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/budgets/{principal_id}',
        ...options
    });
};

/**
 * Set a person's daily limits
 * Set their limits; both limits null restores the defaults.
 */
export const adminSetBudget = <ThrowOnError extends boolean = false>(options: Options<AdminSetBudgetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AdminSetBudgetResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/budgets/{principal_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Model providers on cool-down
 * Providers every run skips after a billing, auth or configuration failure.
 */
export const adminListProviderCooldowns = <ThrowOnError extends boolean = false>(options?: Options<AdminListProviderCooldownsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminListProviderCooldownsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/providers/cooldowns',
        ...options
    });
};

/**
 * End a provider's cool-down
 * The next run tries the provider again (and restarts the cool-down if it still fails).
 */
export const adminEndProviderCooldown = <ThrowOnError extends boolean = false>(options: Options<AdminEndProviderCooldownData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AdminEndProviderCooldownResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/providers/{provider}/cooldown',
        ...options
    });
};

/**
 * Health and quality
 * Outcomes, latency, cost, feedback, flags, sweeps, per-domain pass rates and backlog.
 */
export const adminReadOverview = <ThrowOnError extends boolean = false>(options?: Options<AdminReadOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminReadOverviewResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/overview',
        ...options
    });
};

/**
 * The most frequent failures
 * Failed query and endpoint steps, grouped by their normalised error.
 */
export const adminMineFailures = <ThrowOnError extends boolean = false>(options?: Options<AdminMineFailuresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminMineFailuresResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/mining/failures',
        ...options
    });
};

/**
 * What free SQL read
 * Datasets free SQL read, most used first, and whether a query method covers each.
 */
export const adminMineSqlTopics = <ThrowOnError extends boolean = false>(options?: Options<AdminMineSqlTopicsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminMineSqlTopicsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/mining/sql-topics',
        ...options
    });
};

/**
 * Words the analyst does not know
 * Words in questions no alias, dataset or measure knows, with an example each.
 */
export const adminMineUnmatchedTerms = <ThrowOnError extends boolean = false>(options?: Options<AdminMineUnmatchedTermsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminMineUnmatchedTermsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/mining/unmatched-terms',
        ...options
    });
};

/**
 * Turn a run into an eval question
 * A regression question from a reviewed run; 409 when the slug is taken.
 */
export const adminPromoteRun = <ThrowOnError extends boolean = false>(options: Options<AdminPromoteRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AdminPromoteRunResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/runs/{run_id}/promote',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Draft a fix for a run
 * The change a model thinks would fix the run; nothing is stored or applied.
 */
export const adminSuggestFix = <ThrowOnError extends boolean = false>(options: Options<AdminSuggestFixData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AdminSuggestFixResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/runs/{run_id}/suggest-fix',
        ...options
    });
};

/**
 * Promoted eval questions
 * Questions promoted from review, newest first.
 */
export const adminListEvalQuestions = <ThrowOnError extends boolean = false>(options?: Options<AdminListEvalQuestionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminListEvalQuestionsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/evals/questions',
        ...options
    });
};

/**
 * Remove an eval question
 * Remove a promoted question.
 */
export const adminDeleteEvalQuestion = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteEvalQuestionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AdminDeleteEvalQuestionResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/evals/questions/{question_id}',
        ...options
    });
};

/**
 * Include or exclude an eval question
 * Whether the sweeps ask it.
 */
export const adminSetEvalQuestionActive = <ThrowOnError extends boolean = false>(options: Options<AdminSetEvalQuestionActiveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AdminSetEvalQuestionActiveResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/evals/questions/{question_id}',
        ...options
    });
};

/**
 * Eval sweeps
 * Scheduled and manual sweeps, newest first, with their reports.
 */
export const adminListEvalRuns = <ThrowOnError extends boolean = false>(options?: Options<AdminListEvalRunsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminListEvalRunsResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/evals/runs',
        ...options
    });
};

/**
 * Verified answers
 * Every verified answer, most recently changed first.
 */
export const adminListVerified = <ThrowOnError extends boolean = false>(options?: Options<AdminListVerifiedData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminListVerifiedResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/verified',
        ...options
    });
};

/**
 * Approve a verified answer
 * Saved only if its ``query_data`` request compiles; dates are refused (422).
 */
export const adminCreateVerified = <ThrowOnError extends boolean = false>(options: Options<AdminCreateVerifiedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AdminCreateVerifiedResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/verified',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Remove a verified answer
 * No run is prompted with it any more.
 */
export const adminDeleteVerified = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteVerifiedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AdminDeleteVerifiedResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/verified/{verified_id}',
        ...options
    });
};

/**
 * Change a verified answer
 * Replace it; the new method must compile.
 */
export const adminUpdateVerified = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateVerifiedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AdminUpdateVerifiedResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/verified/{verified_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Glossary aliases
 * Every alias, alphabetically.
 */
export const adminListAliases = <ThrowOnError extends boolean = false>(options?: Options<AdminListAliasesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AdminListAliasesResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/aliases',
        ...options
    });
};

/**
 * Add a glossary alias
 * What a word people use here means; 409 when the term has a meaning already.
 */
export const adminCreateAlias = <ThrowOnError extends boolean = false>(options: Options<AdminCreateAliasData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AdminCreateAliasResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/aliases',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Remove an alias
 * No run is prompted with it any more.
 */
export const adminDeleteAlias = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteAliasData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AdminDeleteAliasResponse, unknown, ThrowOnError>({
        url: '/v1/ai-analyst/admin/aliases/{alias_id}',
        ...options
    });
};

/**
 * List the stores whose stock can be pushed
 * The caller's stores on a marketplace that has a stock push.
 */
export const listStockPushStores = <ThrowOnError extends boolean = false>(options?: Options<ListStockPushStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListStockPushStoresResponse, unknown, ThrowOnError>({
        url: '/v1/stock-push/stores',
        ...options
    });
};

/**
 * Push a store's stock now
 * Queue a push of the store's own stock, as its schedule would send it.
 */
export const pushStoreStock = <ThrowOnError extends boolean = false>(options: Options<PushStoreStockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PushStoreStockResponse, unknown, ThrowOnError>({
        url: '/v1/stock-push/stores/{store_id}/push',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Push an uploaded stock sheet
 * Set listings to a sheet's quantities, matched by SKU code.
 *
 * The sheet's numbers are sent as typed — the store's buffer does not apply
 * to a number a person chose. Any problem refuses the whole sheet.
 */
export const pushStockSheet = <ThrowOnError extends boolean = false>(options: Options<PushStockSheetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PushStockSheetResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/stock-push/stores/{store_id}/sheet',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Download an empty stock sheet
 * The sheet to fill in: ``SKU Code`` and ``Quantity``.
 */
export const downloadStockSheetTemplate = <ThrowOnError extends boolean = false>(options?: Options<DownloadStockSheetTemplateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/stock-push/sheet-template',
        ...options
    });
};

/**
 * List a store's stock push runs
 * The store's requested pushes and its channel's scheduled ones, newest first.
 */
export const listStockPushRuns = <ThrowOnError extends boolean = false>(options: Options<ListStockPushRunsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStockPushRunsResponse, unknown, ThrowOnError>({
        url: '/v1/stock-push/stores/{store_id}/runs',
        ...options
    });
};

/**
 * Fetch a stock push run
 * What became of the store's listings in one run.
 */
export const getStockPushRun = <ThrowOnError extends boolean = false>(options: Options<GetStockPushRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStockPushRunResponse, unknown, ThrowOnError>({
        url: '/v1/stock-push/stores/{store_id}/runs/{run_id}',
        ...options
    });
};

/**
 * What goes in each column of the stock sheet
 * Each column: required or optional, what to put in it, and an example.
 */
export const stockSheetTemplateColumns = <ThrowOnError extends boolean = false>(options?: Options<StockSheetTemplateColumnsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StockSheetTemplateColumnsResponse, unknown, ThrowOnError>({
        url: '/v1/stock-push/sheet-template/columns',
        ...options
    });
};

/**
 * List the stores whose prices can be pushed
 * The stores the caller may see on a marketplace that has a price push.
 */
export const listPricePushStores = <ThrowOnError extends boolean = false>(options?: Options<ListPricePushStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPricePushStoresResponse, unknown, ThrowOnError>({
        url: '/v1/price-push/stores',
        ...options
    });
};

/**
 * Download an empty price sheet
 * The sheet to fill in: Sku, Current Price, New Price, Sale Start, Sale End, Currency.
 */
export const downloadPriceSheetTemplate = <ThrowOnError extends boolean = false>(options?: Options<DownloadPriceSheetTemplateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/price-push/sheet-template',
        ...options
    });
};

/**
 * Push an uploaded price sheet
 * Set a store's prices to a sheet's, matched by SKU.
 *
 * A New Price is a sale price for its Sale Start to Sale End, both days
 * whole. Any problem refuses the whole sheet.
 */
export const pushPriceSheet = <ThrowOnError extends boolean = false>(options: Options<PushPriceSheetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PushPriceSheetResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/price-push/stores/{store_id}/sheet',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * List a store's price push runs
 * The store's price pushes, newest first; the last 25 at most.
 */
export const listPricePushRuns = <ThrowOnError extends boolean = false>(options: Options<ListPricePushRunsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListPricePushRunsResponse, unknown, ThrowOnError>({
        url: '/v1/price-push/stores/{store_id}/runs',
        ...options
    });
};

/**
 * Fetch a price push run
 * What became of the sheet's SKUs in one run.
 */
export const getPricePushRun = <ThrowOnError extends boolean = false>(options: Options<GetPricePushRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPricePushRunResponse, unknown, ThrowOnError>({
        url: '/v1/price-push/stores/{store_id}/runs/{run_id}',
        ...options
    });
};

/**
 * List the Shopify stores that can be synced
 * The Shopify stores the caller may see, by name.
 */
export const listShopifySyncStores = <ThrowOnError extends boolean = false>(options?: Options<ListShopifySyncStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListShopifySyncStoresResponse, unknown, ThrowOnError>({
        url: '/v1/shopify-sync/stores',
        ...options
    });
};

/**
 * Start a Shopify products or orders sync
 * Read one store's variants, or its orders created in a range, into VentaWiz.
 *
 * Read-only on Shopify. The sync runs in the background; its run appears
 * under ``GET …/runs?request_id=``.
 */
export const startShopifySync = <ThrowOnError extends boolean = false>(options: Options<StartShopifySyncData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<StartShopifySyncResponse, unknown, ThrowOnError>({
        url: '/v1/shopify-sync/stores/{store_id}/syncs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List a store's Shopify syncs
 * The store's syncs, newest first; the last 25 at most.
 */
export const listShopifySyncRuns = <ThrowOnError extends boolean = false>(options: Options<ListShopifySyncRunsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListShopifySyncRunsResponse, unknown, ThrowOnError>({
        url: '/v1/shopify-sync/stores/{store_id}/runs',
        ...options
    });
};

/**
 * Fetch a Shopify sync
 * What one sync read from Shopify, and what was kept aside.
 */
export const getShopifySyncRun = <ThrowOnError extends boolean = false>(options: Options<GetShopifySyncRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetShopifySyncRunResponse, unknown, ThrowOnError>({
        url: '/v1/shopify-sync/stores/{store_id}/runs/{run_id}',
        ...options
    });
};

/**
 * List the stores whose orders MCF can fulfil
 * Source stores (Shopify, TikTok) with an enabled MCF config the caller may see.
 */
export const listMcfStores = <ThrowOnError extends boolean = false>(options?: Options<ListMcfStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMcfStoresResponse, unknown, ThrowOnError>({
        url: '/v1/mcf/stores',
        ...options
    });
};

/**
 * Preview which orders would become MCF orders
 * The store's recent orders, each ready or skipped with its reason. Sends nothing.
 */
export const previewMcfOrders = <ThrowOnError extends boolean = false>(options: Options<PreviewMcfOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PreviewMcfOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/mcf/stores/{store_id}/preview',
        ...options
    });
};

/**
 * List a store's MCF orders
 * The MCF orders requested for the store, newest first, with lines and tracking.
 */
export const listMcfOrders = <ThrowOnError extends boolean = false>(options: Options<ListMcfOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListMcfOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/mcf/stores/{store_id}/orders',
        ...options
    });
};

/**
 * Create MCF orders for selected source orders
 * Queue MCF orders for source orders that are ready.
 *
 * **A live create ships real parcels from FBA stock.** ``confirm`` must be
 * true, and the create is a dry run unless ``dry_run`` is false. Any order
 * that is not ready refuses the whole request.
 */
export const createMcfOrders = <ThrowOnError extends boolean = false>(options: Options<CreateMcfOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMcfOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/mcf/stores/{store_id}/orders',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ask Amazon for the status and tracking of awaiting MCF orders
 * Queue a read of the store's accepted and processing orders. Writes nothing to Amazon.
 */
export const syncMcfStatus = <ThrowOnError extends boolean = false>(options: Options<SyncMcfStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SyncMcfStatusResponse, unknown, ThrowOnError>({
        url: '/v1/mcf/stores/{store_id}/status-sync',
        ...options
    });
};

/**
 * Download a store's MCF orders
 * Every MCF order of the store (newest 10,000), one row per line.
 */
export const exportMcfOrders = <ThrowOnError extends boolean = false>(options: Options<ExportMcfOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/mcf/stores/{store_id}/orders/export',
        ...options
    });
};

/**
 * List a store's MCF runs
 * The store's create and status runs, newest first; the last 25 at most.
 */
export const listMcfRuns = <ThrowOnError extends boolean = false>(options: Options<ListMcfRunsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListMcfRunsResponse, unknown, ThrowOnError>({
        url: '/v1/mcf/stores/{store_id}/runs',
        ...options
    });
};

/**
 * Fetch an MCF run
 * What became of each order in one run.
 */
export const getMcfRun = <ThrowOnError extends boolean = false>(options: Options<GetMcfRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMcfRunResponse, unknown, ThrowOnError>({
        url: '/v1/mcf/stores/{store_id}/runs/{run_id}',
        ...options
    });
};

/**
 * List the TikTok Shop stores that can be synced
 * The caller's TikTok Shop stores, by name.
 */
export const listTiktokStores = <ThrowOnError extends boolean = false>(options?: Options<ListTiktokStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListTiktokStoresResponse, unknown, ThrowOnError>({
        url: '/v1/tiktok-sync/stores',
        ...options
    });
};

/**
 * Pull a TikTok store's products
 * Queue a pull of every active product, one row per SKU. Read-only on TikTok.
 */
export const syncTiktokProducts = <ThrowOnError extends boolean = false>(options: Options<SyncTiktokProductsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SyncTiktokProductsResponse, unknown, ThrowOnError>({
        url: '/v1/tiktok-sync/stores/{store_id}/products-sync',
        ...options
    });
};

/**
 * Pull a TikTok store's orders updated in a window
 * Queue a pull of the orders whose last update falls in the window. Read-only on TikTok.
 */
export const syncTiktokOrders = <ThrowOnError extends boolean = false>(options: Options<SyncTiktokOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SyncTiktokOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/tiktok-sync/stores/{store_id}/orders-sync',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Correct the tracking number TikTok carries for one order
 * Replace one order's tracking number on TikTok — a dry run unless ``confirm`` is true.
 *
 * The run reads the order first and reports its status and current numbers;
 * only a confirmed request writes to the customer's order.
 */
export const correctTiktokTracking = <ThrowOnError extends boolean = false>(options: Options<CorrectTiktokTrackingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CorrectTiktokTrackingResponse, unknown, ThrowOnError>({
        url: '/v1/tiktok-sync/stores/{store_id}/tracking-corrections',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List a TikTok store's sync runs
 * The store's TikTok runs, newest first; the last 25 at most.
 */
export const listTiktokRuns = <ThrowOnError extends boolean = false>(options: Options<ListTiktokRunsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListTiktokRunsResponse, unknown, ThrowOnError>({
        url: '/v1/tiktok-sync/stores/{store_id}/runs',
        ...options
    });
};

/**
 * Fetch a TikTok sync run
 * One run: a pull's counts, or a correction's outcome.
 */
export const getTiktokRun = <ThrowOnError extends boolean = false>(options: Options<GetTiktokRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTiktokRunResponse, unknown, ThrowOnError>({
        url: '/v1/tiktok-sync/stores/{store_id}/runs/{run_id}',
        ...options
    });
};

/**
 * What connecting each platform takes
 * Every channel family with a connector, with its surfaces and their fields.
 */
export const listConnectionSpecs = <ThrowOnError extends boolean = false>(options?: Options<ListConnectionSpecsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListConnectionSpecsResponse, unknown, ThrowOnError>({
        url: '/v1/connection-specs',
        ...options
    });
};

/**
 * What connecting each shipping carrier takes
 * Every carrier a store can hold credentials for, whatever its marketplace.
 *
 * Each is a surface with role ``carrier``. Connect, test and replace one
 * through the same endpoints as a marketplace's API, with its ``surface``
 * (``dhl``): ``POST /v1/stores/onboarding/verify`` (any marketplace id),
 * ``PUT``/``PATCH /v1/stores/{id}/connections/dhl`` and ``POST
 * .../connections/dhl/verify``. A write lock is the marketplace's only.
 */
export const listCarrierSpecs = <ThrowOnError extends boolean = false>(options?: Options<ListCarrierSpecsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListCarrierSpecsResponse, unknown, ThrowOnError>({
        url: '/v1/carrier-specs',
        ...options
    });
};

/**
 * What connecting a store on this marketplace takes
 * The spec of the marketplace's family; ``online: false`` when it has no connector.
 */
export const getMarketplaceConnectionSpec = <ThrowOnError extends boolean = false>(options: Options<GetMarketplaceConnectionSpecData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketplaceConnectionSpecResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{marketplace_id}/connection-spec',
        ...options
    });
};

/**
 * The real-time streams a store on this marketplace can receive
 * The streams of the marketplace's platform; ``streams`` is empty when it has none.
 */
export const getMarketplaceStreamSpec = <ThrowOnError extends boolean = false>(options: Options<GetMarketplaceStreamSpecData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketplaceStreamSpecResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{marketplace_id}/stream-spec',
        ...options
    });
};

/**
 * Find the real-time subscriptions a platform already has
 * Ask the platform, through VentaWiz-Ingest, what it already sends for these credentials.
 *
 * Nothing is stored. A subscription pointing somewhere else (v1 VentaHub)
 * is listed with ``ours: false`` and an ``owner_hint``.
 */
export const discoverOnboardingStreams = <ThrowOnError extends boolean = false>(options: Options<DiscoverOnboardingStreamsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DiscoverOnboardingStreamsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/onboarding/streams/discover',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Test credentials before onboarding
 * Test pasted credentials through VentaWiz-Ingest. Nothing is stored.
 *
 * Wrong credentials are a 200 with ``ok: false`` and the platform's reason;
 * only a probe that could not run is an error (502 ``probe_unavailable``).
 * ``existing`` lists this organization's stores already keyed on the account.
 */
export const verifyOnboardingCredentials = <ThrowOnError extends boolean = false>(options: Options<VerifyOnboardingCredentialsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<VerifyOnboardingCredentialsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/onboarding/verify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Create connected stores
 * Create one or more stores with their connections, atomically.
 *
 * An online request re-tests every connection first and refuses with 422
 * ``verification_failed`` (``error.context.surface`` names which) if any
 * fails. Send an ``Idempotency-Key`` and a retry replays the first response.
 */
export const onboardStores = <ThrowOnError extends boolean = false>(options: Options<OnboardStoresData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OnboardStoresResponse, unknown, ThrowOnError>({
        url: '/v1/stores/onboarding',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Stores a new one would collide with
 * This organization's stores - live, retired or deleted - that a new store collides with.
 *
 * ``same_account_marketplace`` and ``tombstoned_code`` would be refused by
 * onboarding; ``same_seller_other_marketplace`` and ``same_credentials``
 * are for the person to judge. Nothing is stored.
 */
export const findOnboardingDuplicates = <ThrowOnError extends boolean = false>(options: Options<FindOnboardingDuplicatesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FindOnboardingDuplicatesResponse, unknown, ThrowOnError>({
        url: '/v1/stores/onboarding/duplicates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * The store table
 * This organization's stores with every API's state, ordered by code.
 */
export const listStoreOverview = <ThrowOnError extends boolean = false>(options?: Options<ListStoreOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListStoreOverviewResponse, unknown, ThrowOnError>({
        url: '/v1/store-overview',
        ...options
    });
};

/**
 * How many stores each platform has
 * One entry per channel family this organization has a store on.
 */
export const listStorePlatforms = <ThrowOnError extends boolean = false>(options?: Options<ListStorePlatformsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListStorePlatformsResponse, unknown, ThrowOnError>({
        url: '/v1/store-platforms',
        ...options
    });
};

/**
 * One store, as the drawer shows it
 * One store with every API's state.
 */
export const getStoreOverview = <ThrowOnError extends boolean = false>(options: Options<GetStoreOverviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreOverviewResponse, unknown, ThrowOnError>({
        url: '/v1/store-overview/{store_id}',
        ...options
    });
};

/**
 * Deactivate a store
 * Stop every pull, push, write and real-time stream for this store and hide it from pickers.
 *
 * Its history stays in reports, and every grant scoped to it is kept, so
 * reactivating restores it as it was. Idempotent: deactivating an inactive
 * store returns it unchanged and records nothing. ``streams`` is what
 * VentaWiz-Ingest did to its streams, ``{"error": ...}`` if it could not be
 * asked, or ``null`` for a store with none.
 */
export const deactivateStore = <ThrowOnError extends boolean = false>(options: Options<DeactivateStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeactivateStoreResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/deactivate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reactivate a store
 * Bring a deactivated store back into use, streams included. Idempotent.
 */
export const reactivateStore = <ThrowOnError extends boolean = false>(options: Options<ReactivateStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReactivateStoreResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/reactivate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * What deleting a store would remove
 * Rows per table grouped by domain, the streams to unsubscribe, and what is kept.
 *
 * Needs ``registry:delete`` across the whole organization.
 */
export const getStoreDeletionPreview = <ThrowOnError extends boolean = false>(options: Options<GetStoreDeletionPreviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreDeletionPreviewResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/deletion-preview',
        ...options
    });
};

/**
 * Delete a store for good
 * Accept a confirmed deletion and queue the job that carries it out.
 *
 * ``confirm_code`` must be the store's code exactly, and
 * ``confirmation_token`` a dv-auth confirmation (``POST
 * /v1/session/reauth``) for ``store.delete`` on ``store:<id>`` by this
 * caller, unexpired and never used. Answers 202 at once; follow
 * ``GET /v1/stores/deletions/{deletion_id}``. Send an ``Idempotency-Key``
 * and a retry replays the first answer rather than spending another
 * confirmation.
 */
export const startStoreDeletion = <ThrowOnError extends boolean = false>(options: Options<StartStoreDeletionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<StartStoreDeletionResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/deletion',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A store deletion's progress
 * Each step's status, detail and counts; readable after the store is gone.
 */
export const getStoreDeletion = <ThrowOnError extends boolean = false>(options: Options<GetStoreDeletionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreDeletionResponse, unknown, ThrowOnError>({
        url: '/v1/stores/deletions/{deletion_id}',
        ...options
    });
};

/**
 * A store's real-time streams
 * Every stream the store's platform offers: switched on or not, and what the platform has.
 *
 * ``status`` is ``not_subscribed`` where VentaWiz-Ingest has recorded nothing.
 */
export const listStoreStreams = <ThrowOnError extends boolean = false>(options: Options<ListStoreStreamsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStoreStreamsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/streams',
        ...options
    });
};

/**
 * Switch a store's real-time streams
 * Save the streams sent, then ask VentaWiz-Ingest to make the platform match.
 *
 * Streams not sent are left as they are. The change is saved even when
 * ingest cannot be asked: ``reconcile`` is then ``{"error":
 * "probe_unavailable"}`` and ingest's daily run converges it.
 */
export const updateStoreStreams = <ThrowOnError extends boolean = false>(options: Options<UpdateStoreStreamsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateStoreStreamsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/streams',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Re-sync a store's real-time streams
 * Ask VentaWiz-Ingest to make the platform match the store's streams now.
 */
export const reconcileStoreStreams = <ThrowOnError extends boolean = false>(options: Options<ReconcileStoreStreamsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReconcileStoreStreamsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/streams/reconcile',
        ...options
    });
};

/**
 * Switch an API or fix its expiry
 * Apply only the fields sent; returns the store as the drawer shows it.
 */
export const updateStoreConnection = <ThrowOnError extends boolean = false>(options: Options<UpdateStoreConnectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateStoreConnectionResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/connections/{surface}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Rotate credentials
 * Test new credentials and write them to this store, or to every store sharing the app.
 *
 * Also how an API never connected gets its first credentials: they are
 * stored and the API is switched on.
 */
export const rotateStoreConnection = <ThrowOnError extends boolean = false>(options: Options<RotateStoreConnectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<RotateStoreConnectionResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/connections/{surface}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Stores sharing this API's application
 * The other stores in this organization whose credentials are for the same application.
 *
 * The store itself is not listed; ``count`` is how many others there are.
 */
export const listConnectionSiblings = <ThrowOnError extends boolean = false>(options: Options<ListConnectionSiblingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListConnectionSiblingsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/connections/{surface}/siblings',
        ...options
    });
};

/**
 * Re-test stored credentials
 * Probe the stored grant through VentaWiz-Ingest and record the outcome.
 */
export const verifyStoreConnection = <ThrowOnError extends boolean = false>(options: Options<VerifyStoreConnectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<VerifyStoreConnectionResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/connections/{surface}/verify',
        ...options
    });
};

/**
 * Lock or unlock writes
 * Refuse or allow writes to the platform for this API. A reason is required to lock.
 */
export const setStoreWriteLock = <ThrowOnError extends boolean = false>(options: Options<SetStoreWriteLockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetStoreWriteLockResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/write-locks/{surface}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A store's history
 * Registry, connection, lock and freeze events for this store, newest first.
 *
 * ``from`` and ``to`` are UTC calendar days, both inclusive.
 */
export const listStoreActivity = <ThrowOnError extends boolean = false>(options: Options<ListStoreActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStoreActivityResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/activity',
        ...options
    });
};

/**
 * A store's write history
 * Every write VentaWiz-Ingest attempted on this store's accounts, newest first.
 *
 * ``actor`` is the person's name where this service knows it, else their
 * principal id; ``system:<job>`` for scheduled writes. ``from`` and ``to``
 * are UTC calendar days, both inclusive.
 */
export const listStoreWrites = <ThrowOnError extends boolean = false>(options: Options<ListStoreWritesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStoreWritesResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/writes',
        ...options
    });
};

/**
 * A store's write freezes
 * Scheduled, active, ended and cancelled freezes, latest start first.
 */
export const listStoreWriteFreezes = <ThrowOnError extends boolean = false>(options: Options<ListStoreWriteFreezesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStoreWriteFreezesResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/write-freezes',
        ...options
    });
};

/**
 * Schedule a write freeze
 * Lock writes to these APIs from ``starts_at`` to ``ends_at``.
 *
 * A start already past means now: the lock goes on at once. At the end only
 * the locks the freeze itself set come off; a surface already locked by
 * hand stays locked.
 */
export const createStoreWriteFreeze = <ThrowOnError extends boolean = false>(options: Options<CreateStoreWriteFreezeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateStoreWriteFreezeResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/write-freezes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Cancel a write freeze
 * Call a freeze off; if it is on, the locks it set come off now. Idempotent.
 */
export const cancelStoreWriteFreeze = <ThrowOnError extends boolean = false>(options: Options<CancelStoreWriteFreezeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<CancelStoreWriteFreezeResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/write-freezes/{freeze_id}',
        ...options
    });
};

/**
 * What needs attention
 * Expiring, expired and failing credentials, paused calls and stale data; critical first.
 */
export const listAlerts = <ThrowOnError extends boolean = false>(options?: Options<ListAlertsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAlertsResponse, unknown, ThrowOnError>({
        url: '/v1/alerts',
        ...options
    });
};

/**
 * Alert routes
 * Where alerts go besides the default recipients. Slack webhooks are never returned.
 */
export const listAlertRoutes = <ThrowOnError extends boolean = false>(options?: Options<ListAlertRoutesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAlertRoutesResponse, unknown, ThrowOnError>({
        url: '/v1/alert-routes',
        ...options
    });
};

/**
 * Replace the alert routes
 * Make the routes exactly these: a route without ``id`` is new, one not sent is removed.
 *
 * A Slack route sent without ``slack_webhook_url`` keeps its stored webhook.
 * Needs ``registry:edit`` across the whole organization.
 */
export const replaceAlertRoutes = <ThrowOnError extends boolean = false>(options: Options<ReplaceAlertRoutesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceAlertRoutesResponse, unknown, ThrowOnError>({
        url: '/v1/alert-routes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Alert settings
 * Who is emailed, and whether Amazon rotations apply themselves.
 */
export const getAlertSettings = <ThrowOnError extends boolean = false>(options?: Options<GetAlertSettingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAlertSettingsResponse, unknown, ThrowOnError>({
        url: '/v1/settings/alerts',
        ...options
    });
};

/**
 * Change alert settings
 * Replace the settings. Needs ``registry:edit`` across the whole organization.
 */
export const updateAlertSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateAlertSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateAlertSettingsResponse, unknown, ThrowOnError>({
        url: '/v1/settings/alerts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A store's settings
 * Everything on the store page's Settings tab, section by section.
 *
 * ``features`` lists every feature, ``enabled: true`` unless switched off.
 * ``targets.currency`` is the marketplace's until a goal currency is saved.
 */
export const getStoreSettings = <ThrowOnError extends boolean = false>(options: Options<GetStoreSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreSettingsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/settings',
        ...options
    });
};

/**
 * Change a store's settings
 * Apply the sections sent; sections left out are untouched.
 *
 * ``details`` and ``targets`` apply only the fields sent; ``warehouses``,
 * ``users``, ``tags``, ``groups`` and ``contacts`` replace the store's list;
 * ``features`` switches only the features sent. One
 * ``store.settings.changed`` event per section. Switching
 * ``real_time_streams`` asks VentaWiz-Ingest to reconcile the store's
 * streams; ``streams`` is its answer.
 */
export const updateStoreSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateStoreSettingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateStoreSettingsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * The Ads profiles a store can use
 * Probe the store's stored Ads credentials through VentaWiz-Ingest and list its profiles.
 *
 * ``best_match`` is the profile whose account and country fit the store,
 * when exactly one does. Nothing is saved: choosing one is a settings
 * PATCH of ``ads.profile_id``.
 */
export const listStoreAdsProfiles = <ThrowOnError extends boolean = false>(options: Options<ListStoreAdsProfilesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ListStoreAdsProfilesResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/ads/profiles',
        ...options
    });
};

/**
 * Refresh the Ads account behind a store's profile
 * Record the Ads account of the store's profile in ``marketplace_meta.amazon``.
 *
 * Stored under v1 VentaHub's keys (``account_id``, ``account_name``,
 * ``account_type``); the write lock and every other key are kept. 422
 * ``verification_failed`` when Amazon refuses the stored credentials,
 * ``validation_failed`` when the store has no profile or its credentials
 * do not reach it.
 */
export const refreshStoreAccountMetadata = <ThrowOnError extends boolean = false>(options: Options<RefreshStoreAccountMetadataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RefreshStoreAccountMetadataResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/account-metadata/refresh',
        ...options
    });
};

/**
 * Notes on a store
 * The store's notes, newest first.
 */
export const listStoreNotes = <ThrowOnError extends boolean = false>(options: Options<ListStoreNotesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStoreNotesResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/notes',
        ...options
    });
};

/**
 * Add a note
 * Write a note on a store as the caller. Needs only ``registry:view``.
 */
export const createStoreNote = <ThrowOnError extends boolean = false>(options: Options<CreateStoreNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateStoreNoteResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a note
 * Remove a note from the store page. Its author, or anyone with ``registry:edit``.
 */
export const deleteStoreNote = <ThrowOnError extends boolean = false>(options: Options<DeleteStoreNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteStoreNoteResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/notes/{note_id}',
        ...options
    });
};

/**
 * Edit a note
 * Replace a note's text. Its author, or anyone with ``registry:edit``.
 */
export const updateStoreNote = <ThrowOnError extends boolean = false>(options: Options<UpdateStoreNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateStoreNoteResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/notes/{note_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Store groups
 * This organization's regions and business units, by kind then name.
 */
export const listStoreGroups = <ThrowOnError extends boolean = false>(options?: Options<ListStoreGroupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListStoreGroupsResponse, unknown, ThrowOnError>({
        url: '/v1/store-groups',
        ...options
    });
};

/**
 * Create a store group
 * Create a region or business unit. Needs ``registry:edit`` across the organization.
 */
export const createStoreGroup = <ThrowOnError extends boolean = false>(options: Options<CreateStoreGroupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateStoreGroupResponse, unknown, ThrowOnError>({
        url: '/v1/store-groups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A store's health score
 * The store's health, 0-100, and each part it is weighted from.
 *
 * Parts: ``credentials`` 25, ``freshness`` 20, ``circuits`` 15, ``streams``
 * 10, ``alerts`` 10, ``write_locks`` 10, ``onboarding`` 10 (the share of the
 * setup checklist done).
 * When VentaWiz-Ingest cannot be asked, ``freshness`` has detail
 * ``unknown`` and weight 0 and the score is still answered.
 */
export const getStoreHealth = <ThrowOnError extends boolean = false>(options: Options<GetStoreHealthData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreHealthResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/health',
        ...options
    });
};

/**
 * How fresh a store's data is
 * Per entity the store is pulled for: its cadence, last success and state.
 */
export const getStoreFreshness = <ThrowOnError extends boolean = false>(options: Options<GetStoreFreshnessData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreFreshnessResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/health/freshness',
        ...options
    });
};

/**
 * A store's recent ingestion runs
 * The store's run steps, newest first. ``error_detail`` is always null.
 */
export const listStoreRuns = <ThrowOnError extends boolean = false>(options: Options<ListStoreRunsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStoreRunsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/health/runs',
        ...options
    });
};

/**
 * Sync a store now
 * Pull today's data for the store: every entity, or the one named. Recorded on the store.
 */
export const syncStore = <ThrowOnError extends boolean = false>(options: Options<SyncStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SyncStoreResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/health/sync',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Backfill one entity for a store
 * Re-pull one entity over ``from``..``to``, inclusive, through Dagster.
 *
 * Recorded on the store.
 */
export const backfillStore = <ThrowOnError extends boolean = false>(options: Options<BackfillStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BackfillStoreResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/health/backfill',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A store's circuit breakers
 * Per connector: whether calls are paused, failures, the last error and rate headroom.
 */
export const listStoreCircuits = <ThrowOnError extends boolean = false>(options: Options<ListStoreCircuitsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStoreCircuitsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/health/circuits',
        ...options
    });
};

/**
 * Close a store's circuit
 * Close the connector's circuit now so calls resume. Recorded on the store.
 */
export const resetStoreCircuit = <ThrowOnError extends boolean = false>(options: Options<ResetStoreCircuitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResetStoreCircuitResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/health/circuits/{connector}/reset',
        ...options
    });
};

/**
 * What a store's data export can hold
 * The store's data by domain and table, with the rows each holds now. Changes nothing.
 */
export const getStoreExportDomains = <ThrowOnError extends boolean = false>(options: Options<GetStoreExportDomainsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreExportDomainsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/export-domains',
        ...options
    });
};

/**
 * A store's data exports
 * The store's exports, newest first, each with a fresh download link while ready.
 */
export const listStoreExports = <ThrowOnError extends boolean = false>(options: Options<ListStoreExportsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStoreExportsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/exports',
        ...options
    });
};

/**
 * Export a store's data
 * Queue a zip of CSVs, one per table, of the domains named - or of every domain.
 *
 * Secrets are never written: no credential, ciphertext, webhook or client-id
 * fingerprint. Follow ``GET /v1/exports/{export_id}``; the tenant's alert
 * recipients are emailed when it is ready. Needs ``registry:edit``.
 */
export const startStoreExport = <ThrowOnError extends boolean = false>(options: Options<StartStoreExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<StartStoreExportResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/exports',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A data export's progress
 * Its status, rows written per table and, while ready, a link that works ten minutes.
 *
 * Fetch it again just before downloading rather than keeping an old link.
 */
export const getStoreExport = <ThrowOnError extends boolean = false>(options: Options<GetStoreExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreExportResponse, unknown, ThrowOnError>({
        url: '/v1/exports/{export_id}',
        ...options
    });
};

/**
 * Download a data export
 * The export's zip. **Public by design:** the signed ``token`` is the authorization.
 *
 * A browser follows ``download_url`` without a bearer token, so the link
 * itself is signed for this export and tenant and works ten minutes. It
 * serves the file, or redirects to the stored object.
 */
export const downloadStoreExport = <ThrowOnError extends boolean = false>(options: Options<DownloadStoreExportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadStoreExportResponse, unknown, ThrowOnError>({
        url: '/v1/exports/{export_id}/download',
        ...options
    });
};

/**
 * A store's audit trail as CSV
 * The store's events and writes between two UTC days, oldest first, as one sheet.
 *
 * Columns: ``at, kind (event|write), id, type, actor, connector, outcome,
 * platform_status, receipt_id, trace_id, targets, detail``. Named
 * ``<code>-audit-<from>-<to>.csv``.
 */
export const exportStoreAudit = <ThrowOnError extends boolean = false>(options: Options<ExportStoreAuditData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/audit-export',
        ...options
    });
};

/**
 * A new store's prefill, from this one
 * What a store created from this one copies. Never a credential.
 *
 * ``credential_reuse`` says which application each API is on (the last
 * four characters of its client id) and every store sharing it. Send the
 * rest back as ``clone`` in ``POST /v1/stores/onboarding``.
 */
export const getStoreCloneTemplate = <ThrowOnError extends boolean = false>(options: Options<GetStoreCloneTemplateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreCloneTemplateResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/clone-template',
        ...options
    });
};

/**
 * What a store still needs to be set up
 * The setup steps that apply to the store, each done or not, with where to fix it.
 */
export const getStoreChecklist = <ThrowOnError extends boolean = false>(options: Options<GetStoreChecklistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreChecklistResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/checklist',
        ...options
    });
};

/**
 * The brand list
 * This organization's brands by name, with tags, store and SKU counts.
 *
 * ``search`` matches the code or the name.
 */
export const listBrandOverview = <ThrowOnError extends boolean = false>(options?: Options<ListBrandOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListBrandOverviewResponse, unknown, ThrowOnError>({
        url: '/v1/brand-overview',
        ...options
    });
};

/**
 * The brand list's counts
 * How many brands, managed and not, and SKU brand names to clean up.
 */
export const getBrandOverviewSummary = <ThrowOnError extends boolean = false>(options?: Options<GetBrandOverviewSummaryData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetBrandOverviewSummaryResponse, unknown, ThrowOnError>({
        url: '/v1/brand-overview/summary',
        ...options
    });
};

/**
 * One row of the brand list
 * One brand with its tags, store and SKU counts, for the drawer and the full page.
 */
export const getBrandOverviewItem = <ThrowOnError extends boolean = false>(options: Options<GetBrandOverviewItemData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBrandOverviewItemResponse, unknown, ThrowOnError>({
        url: '/v1/brand-overview/{brand_id}',
        ...options
    });
};

/**
 * SKU brand names to clean up
 * Brand names SKUs carry while linked to no brand, most unlinked SKUs first.
 *
 * Each with a few SKU codes and the brand it most likely is.
 */
export const listUnmatchedSkuNames = <ThrowOnError extends boolean = false>(options?: Options<ListUnmatchedSkuNamesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListUnmatchedSkuNamesResponse, unknown, ThrowOnError>({
        url: '/v1/brands/unmatched-sku-names',
        ...options
    });
};

/**
 * Create a brand from a SKU brand name
 * Create a brand named after a SKU brand name, and link the SKUs carrying it.
 *
 * Needs ``registry:edit`` and ``catalogue:edit``.
 */
export const createBrandFromSkuName = <ThrowOnError extends boolean = false>(options: Options<CreateBrandFromSkuNameData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateBrandFromSkuNameResponse, unknown, ThrowOnError>({
        url: '/v1/brands/from-sku-name',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Link SKUs to a brand by name
 * Link the live SKUs carrying these brand names, and no brand, to this brand.
 *
 * Names match ignoring case and surrounding spaces. Needs ``registry:edit``
 * and ``catalogue:edit``; the brand must be active.
 */
export const linkBrandSkuNames = <ThrowOnError extends boolean = false>(options: Options<LinkBrandSkuNamesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LinkBrandSkuNamesResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{brand_id}/link-sku-names',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * What a merge would do
 * What merging this brand into ``into`` would move, by domain, and drop.
 */
export const getBrandMergePreview = <ThrowOnError extends boolean = false>(options: Options<GetBrandMergePreviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBrandMergePreviewResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{brand_id}/merge-preview',
        ...options
    });
};

/**
 * Merge a brand into another
 * Move everything referring to this brand onto another, and retire it.
 *
 * ``confirm_code`` must be this brand's code. Needs ``registry:edit`` and
 * ``catalogue:edit`` across the organization.
 */
export const mergeBrand = <ThrowOnError extends boolean = false>(options: Options<MergeBrandData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MergeBrandResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{brand_id}/merge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Pages to scrape
 * Return a page of the focused SKUs to scrape for these stores.
 *
 * One item per product page, carrying every listing it answers for.
 */
export const listReviewQueries = <ThrowOnError extends boolean = false>(options: Options<ListReviewQueriesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListReviewQueriesResponse, unknown, ThrowOnError>({
        url: '/v1/scrapper/review-queries',
        ...options
    });
};

/**
 * Record a scraped page
 * Store what a scraper read off one product page, for each listing it covers.
 *
 * Replaces the listings' previous rating rather than adding a row, so
 * re-posting the same result is harmless.
 */
export const recordReview = <ThrowOnError extends boolean = false>(options: Options<RecordReviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RecordReviewResponse, unknown, ThrowOnError>({
        url: '/v1/scrapper/reviews',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Searches to run
 * Return a page of the tracked search terms not yet scraped today for these stores.
 */
export const listSearchTermQueries = <ThrowOnError extends boolean = false>(options: Options<ListSearchTermQueriesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListSearchTermQueriesResponse, unknown, ThrowOnError>({
        url: '/v1/scrapper/search-term-queries',
        ...options
    });
};

/**
 * Record a search
 * Store what one search showed: up to five sponsored and five organic results.
 *
 * One per store, term and day. A second post the same day is refused with
 * 409, which a retrying scraper should treat as success.
 */
export const recordSearchTermResult = <ThrowOnError extends boolean = false>(options: Options<RecordSearchTermResultData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RecordSearchTermResultResponse, unknown, ThrowOnError>({
        url: '/v1/scrapper/search-term-results',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * An agent starts a cycle
 * Register or refresh an agent and return the scrapers to run this cycle.
 *
 * Ads in even two-hour blocks of UTC time, reviews in odd ones, unless an
 * administrator pinned the device's scrapers or took it out of service.
 */
export const checkIn = <ThrowOnError extends boolean = false>(options: Options<CheckInData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckInResponse, unknown, ThrowOnError>({
        url: '/v1/scrapper/checkin',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * An agent reports a run
 * Store how one scraper run went. A repeat for the same cycle is not stored twice.
 */
export const recordRun = <ThrowOnError extends boolean = false>(options: Options<RecordRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RecordRunResponse, unknown, ThrowOnError>({
        url: '/v1/scrapper/runs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Scraped data filters
 * The marketplaces and the caller's stores the Scraped data page filters by.
 */
export const getScrapedDataFilters = <ThrowOnError extends boolean = false>(options?: Options<GetScrapedDataFiltersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetScrapedDataFiltersResponse, unknown, ThrowOnError>({
        url: '/v1/scraped-data/filters',
        ...options
    });
};

/**
 * Scraped product pages
 * The latest scraped rating, A+, delivery and critical reviews of each focused listing.
 */
export const listScrapedReviews = <ThrowOnError extends boolean = false>(options?: Options<ListScrapedReviewsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListScrapedReviewsResponse, unknown, ThrowOnError>({
        url: '/v1/scraped-data/reviews',
        ...options
    });
};

/**
 * Scraped searches
 * What each tracked search term showed: five sponsored and five organic results.
 */
export const listScrapedSearches = <ThrowOnError extends boolean = false>(options?: Options<ListScrapedSearchesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListScrapedSearchesResponse, unknown, ThrowOnError>({
        url: '/v1/scraped-data/ads',
        ...options
    });
};

/**
 * Export scraped product pages
 * The listings the reviews filters match, as a workbook: every page, not one.
 */
export const exportScrapedReviews = <ThrowOnError extends boolean = false>(options?: Options<ExportScrapedReviewsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/scraped-data/reviews/export',
        ...options
    });
};

/**
 * Export scraped searches
 * The searches the ads filters match, one row per sponsored or organic result.
 */
export const exportScrapedSearches = <ThrowOnError extends boolean = false>(options?: Options<ExportScrapedSearchesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/scraped-data/ads/export',
        ...options
    });
};

/**
 * Scrapers and the schedule
 * Every scraper the agents can run, and which kind the schedule runs right now.
 */
export const getFleetCatalog = <ThrowOnError extends boolean = false>(options?: Options<GetFleetCatalogData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetFleetCatalogResponse, unknown, ThrowOnError>({
        url: '/v1/scrapper/admin/catalog',
        ...options
    });
};

/**
 * Scraper agents
 * Every installed agent, most recently seen first, with its last run.
 */
export const listFleetDevices = <ThrowOnError extends boolean = false>(options?: Options<ListFleetDevicesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFleetDevicesResponse, unknown, ThrowOnError>({
        url: '/v1/scrapper/admin/devices',
        ...options
    });
};

/**
 * One agent
 * One agent, with what it would run if it checked in now.
 */
export const getFleetDevice = <ThrowOnError extends boolean = false>(options: Options<GetFleetDeviceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFleetDeviceResponse, unknown, ThrowOnError>({
        url: '/v1/scrapper/admin/devices/{device_id}',
        ...options
    });
};

/**
 * Change an agent
 * Take an agent out of service or back in, pin its scrapers, or note something.
 *
 * Takes effect at its next check-in.
 */
export const updateFleetDevice = <ThrowOnError extends boolean = false>(options: Options<UpdateFleetDeviceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateFleetDeviceResponse, unknown, ThrowOnError>({
        url: '/v1/scrapper/admin/devices/{device_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Scraper run history
 * Every run the agents reported, newest first, with errors and log lines.
 */
export const listFleetRuns = <ThrowOnError extends boolean = false>(options?: Options<ListFleetRunsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFleetRunsResponse, unknown, ThrowOnError>({
        url: '/v1/scrapper/admin/runs',
        ...options
    });
};

/**
 * List marketplaces
 * Return a page of this organization's marketplaces, ordered by code.
 *
 * Both live and retired rows by default. A picker wants ``is_active=true``;
 * a report attributing an old record to a closed marketplace needs the closed
 * one listed.
 */
export const listMarketplaces = <ThrowOnError extends boolean = false>(options?: Options<ListMarketplacesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMarketplacesResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces',
        ...options
    });
};

/**
 * Create a marketplace
 * Create one marketplace.
 *
 * Send an ``Idempotency-Key`` header and a retry after a timeout replays the
 * first attempt's response instead of creating a second row — which here
 * would burn a code that can never be reused.
 */
export const createMarketplace = <ThrowOnError extends boolean = false>(options: Options<CreateMarketplaceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMarketplaceResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fetch a marketplace
 * Return one marketplace by id.
 */
export const getMarketplace = <ThrowOnError extends boolean = false>(options: Options<GetMarketplaceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketplaceResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}',
        ...options
    });
};

/**
 * Update a marketplace
 * Apply a partial update.
 *
 * Only fields actually sent are applied. ``code`` is not in the schema at
 * all, so sending one is a 422 naming the field rather than a silent no-op —
 * a code is the handle every integration already holds.
 */
export const updateMarketplace = <ThrowOnError extends boolean = false>(options: Options<UpdateMarketplaceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateMarketplaceResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retire a marketplace
 * Stop offering this marketplace without removing it.
 *
 * Idempotent: retiring something already retired returns it unchanged and
 * records nothing, so a retry costs nothing and leaves no second event. A
 * ``reason``, when sent, is recorded on the event.
 */
export const retireMarketplace = <ThrowOnError extends boolean = false>(options: Options<RetireMarketplaceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetireMarketplaceResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/retire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reinstate a marketplace
 * Bring a retired marketplace back into use. A ``reason`` is recorded on the event.
 */
export const reinstateMarketplace = <ThrowOnError extends boolean = false>(options: Options<ReinstateMarketplaceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReinstateMarketplaceResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/reinstate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A marketplace's history
 * This organization's events about this marketplace, newest first.
 *
 * ``from`` and ``to`` are UTC calendar days, both inclusive.
 */
export const listMarketplaceActivity = <ThrowOnError extends boolean = false>(options: Options<ListMarketplaceActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListMarketplaceActivityResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/activity',
        ...options
    });
};

/**
 * What refers to a marketplace
 * This organization's rows referring to the marketplace, by domain.
 *
 * Only tables with rows are listed. Soft-deleted rows do not count.
 */
export const getMarketplaceUsage = <ThrowOnError extends boolean = false>(options: Options<GetMarketplaceUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketplaceUsageResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/usage',
        ...options
    });
};

/**
 * List brands
 * Return a page of this organization's brands, ordered by code.
 *
 * Both live and retired rows by default. A picker wants ``is_active=true``;
 * a report attributing an old record to a closed brand needs the closed
 * one listed.
 */
export const listBrands = <ThrowOnError extends boolean = false>(options?: Options<ListBrandsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListBrandsResponse, unknown, ThrowOnError>({
        url: '/v1/brands',
        ...options
    });
};

/**
 * Create a brand
 * Create one brand.
 *
 * Send an ``Idempotency-Key`` header and a retry after a timeout replays the
 * first attempt's response instead of creating a second row — which here
 * would burn a code that can never be reused.
 */
export const createBrand = <ThrowOnError extends boolean = false>(options: Options<CreateBrandData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateBrandResponse, unknown, ThrowOnError>({
        url: '/v1/brands',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fetch a brand
 * Return one brand by id.
 */
export const getBrand = <ThrowOnError extends boolean = false>(options: Options<GetBrandData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBrandResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}',
        ...options
    });
};

/**
 * Update a brand
 * Apply a partial update.
 *
 * Only fields actually sent are applied. ``code`` is not in the schema at
 * all, so sending one is a 422 naming the field rather than a silent no-op —
 * a code is the handle every integration already holds.
 */
export const updateBrand = <ThrowOnError extends boolean = false>(options: Options<UpdateBrandData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateBrandResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retire a brand
 * Stop offering this brand without removing it.
 *
 * Idempotent: retiring something already retired returns it unchanged and
 * records nothing, so a retry costs nothing and leaves no second event. A
 * ``reason``, when sent, is recorded on the event.
 */
export const retireBrand = <ThrowOnError extends boolean = false>(options: Options<RetireBrandData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetireBrandResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/retire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reinstate a brand
 * Bring a retired brand back into use. A ``reason`` is recorded on the event.
 */
export const reinstateBrand = <ThrowOnError extends boolean = false>(options: Options<ReinstateBrandData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReinstateBrandResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/reinstate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A brand's history
 * This organization's events about this brand, newest first.
 *
 * ``from`` and ``to`` are UTC calendar days, both inclusive.
 */
export const listBrandActivity = <ThrowOnError extends boolean = false>(options: Options<ListBrandActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListBrandActivityResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/activity',
        ...options
    });
};

/**
 * What refers to a brand
 * This organization's rows referring to the brand, by domain.
 *
 * Only tables with rows are listed. Soft-deleted rows do not count.
 */
export const getBrandUsage = <ThrowOnError extends boolean = false>(options: Options<GetBrandUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBrandUsageResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/usage',
        ...options
    });
};

/**
 * What retiring a brand would do
 * What to acknowledge before retiring the brand, and its usage. A brand never blocks.
 *
 * Warns on the active stores selling it and the live SKUs carrying it.
 */
export const getBrandRetirePreview = <ThrowOnError extends boolean = false>(options: Options<GetBrandRetirePreviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBrandRetirePreviewResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/retire-preview',
        ...options
    });
};

/**
 * List stores
 * Return a page of this organization's stores, ordered by code.
 *
 * Both live and retired rows by default. A picker wants ``is_active=true``;
 * a report attributing an old record to a closed store needs the closed
 * one listed.
 */
export const listStores = <ThrowOnError extends boolean = false>(options?: Options<ListStoresData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListStoresResponse, unknown, ThrowOnError>({
        url: '/v1/stores',
        ...options
    });
};

/**
 * Create a store
 * Create one store.
 *
 * Send an ``Idempotency-Key`` header and a retry after a timeout replays the
 * first attempt's response instead of creating a second row — which here
 * would burn a code that can never be reused.
 */
export const createStore = <ThrowOnError extends boolean = false>(options: Options<CreateStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateStoreResponse, unknown, ThrowOnError>({
        url: '/v1/stores',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fetch a store
 * Return one store by id.
 */
export const getStore = <ThrowOnError extends boolean = false>(options: Options<GetStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{entity_id}',
        ...options
    });
};

/**
 * Update a store
 * Apply a partial update.
 *
 * Only fields actually sent are applied. ``code`` is not in the schema at
 * all, so sending one is a 422 naming the field rather than a silent no-op —
 * a code is the handle every integration already holds.
 */
export const updateStore = <ThrowOnError extends boolean = false>(options: Options<UpdateStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateStoreResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{entity_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retire a store
 * Stop offering this store without removing it.
 *
 * Idempotent: retiring something already retired returns it unchanged and
 * records nothing, so a retry costs nothing and leaves no second event. A
 * ``reason``, when sent, is recorded on the event.
 */
export const retireStore = <ThrowOnError extends boolean = false>(options: Options<RetireStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetireStoreResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{entity_id}/retire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reinstate a store
 * Bring a retired store back into use. A ``reason`` is recorded on the event.
 */
export const reinstateStore = <ThrowOnError extends boolean = false>(options: Options<ReinstateStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReinstateStoreResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{entity_id}/reinstate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List warehouses
 * Return a page of this organization's warehouses, ordered by code.
 *
 * Both live and retired rows by default. A picker wants ``is_active=true``;
 * a report attributing an old record to a closed warehouse needs the closed
 * one listed.
 */
export const listWarehouses = <ThrowOnError extends boolean = false>(options?: Options<ListWarehousesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListWarehousesResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses',
        ...options
    });
};

/**
 * Create a warehouse
 * Create one warehouse.
 *
 * Send an ``Idempotency-Key`` header and a retry after a timeout replays the
 * first attempt's response instead of creating a second row — which here
 * would burn a code that can never be reused.
 */
export const createWarehouse = <ThrowOnError extends boolean = false>(options: Options<CreateWarehouseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateWarehouseResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fetch a warehouse
 * Return one warehouse by id.
 */
export const getWarehouse = <ThrowOnError extends boolean = false>(options: Options<GetWarehouseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWarehouseResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}',
        ...options
    });
};

/**
 * Update a warehouse
 * Apply a partial update.
 *
 * Only fields actually sent are applied. ``code`` is not in the schema at
 * all, so sending one is a 422 naming the field rather than a silent no-op —
 * a code is the handle every integration already holds.
 */
export const updateWarehouse = <ThrowOnError extends boolean = false>(options: Options<UpdateWarehouseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateWarehouseResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retire a warehouse
 * Stop offering this warehouse without removing it.
 *
 * Idempotent: retiring something already retired returns it unchanged and
 * records nothing, so a retry costs nothing and leaves no second event. A
 * ``reason``, when sent, is recorded on the event. 409 ``retire_blocked``,
 * with ``context.blocking`` as ``/retire-preview`` lists it, while the
 * warehouse is the first-priority warehouse of an active store.
 */
export const retireWarehouse = <ThrowOnError extends boolean = false>(options: Options<RetireWarehouseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetireWarehouseResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/retire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reinstate a warehouse
 * Bring a retired warehouse back into use. A ``reason`` is recorded on the event.
 */
export const reinstateWarehouse = <ThrowOnError extends boolean = false>(options: Options<ReinstateWarehouseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReinstateWarehouseResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/reinstate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A warehouse's history
 * This organization's events about this warehouse, newest first.
 *
 * ``from`` and ``to`` are UTC calendar days, both inclusive.
 */
export const listWarehouseActivity = <ThrowOnError extends boolean = false>(options: Options<ListWarehouseActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListWarehouseActivityResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/activity',
        ...options
    });
};

/**
 * What refers to a warehouse
 * This organization's rows referring to the warehouse, by domain.
 *
 * Only tables with rows are listed. Soft-deleted rows do not count.
 */
export const getWarehouseUsage = <ThrowOnError extends boolean = false>(options: Options<GetWarehouseUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWarehouseUsageResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/usage',
        ...options
    });
};

/**
 * What retiring a warehouse would do
 * What blocks retiring the warehouse, what to acknowledge, and its usage.
 *
 * Blocked while it is the first-priority warehouse of an active store
 * (``primary_for_active_store``); warns on lower-priority links to active
 * stores, stock rows naming it, and retailers using it as their default.
 */
export const getWarehouseRetirePreview = <ThrowOnError extends boolean = false>(options: Options<GetWarehouseRetirePreviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWarehouseRetirePreviewResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/retire-preview',
        ...options
    });
};

/**
 * List retailers
 * Return a page of this organization's retailers, ordered by code.
 *
 * Both live and retired rows by default. A picker wants ``is_active=true``;
 * a report attributing an old record to a closed retailer needs the closed
 * one listed.
 */
export const listRetailers = <ThrowOnError extends boolean = false>(options?: Options<ListRetailersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListRetailersResponse, unknown, ThrowOnError>({
        url: '/v1/retailers',
        ...options
    });
};

/**
 * Create a retailer
 * Create one retailer.
 *
 * Send an ``Idempotency-Key`` header and a retry after a timeout replays the
 * first attempt's response instead of creating a second row — which here
 * would burn a code that can never be reused.
 */
export const createRetailer = <ThrowOnError extends boolean = false>(options: Options<CreateRetailerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateRetailerResponse, unknown, ThrowOnError>({
        url: '/v1/retailers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fetch a retailer
 * Return one retailer by id.
 */
export const getRetailer = <ThrowOnError extends boolean = false>(options: Options<GetRetailerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRetailerResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}',
        ...options
    });
};

/**
 * Update a retailer
 * Apply a partial update.
 *
 * Only fields actually sent are applied. ``code`` is not in the schema at
 * all, so sending one is a 422 naming the field rather than a silent no-op —
 * a code is the handle every integration already holds.
 */
export const updateRetailer = <ThrowOnError extends boolean = false>(options: Options<UpdateRetailerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRetailerResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retire a retailer
 * Stop offering this retailer without removing it.
 *
 * Idempotent: retiring something already retired returns it unchanged and
 * records nothing, so a retry costs nothing and leaves no second event. A
 * ``reason``, when sent, is recorded on the event.
 */
export const retireRetailer = <ThrowOnError extends boolean = false>(options: Options<RetireRetailerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetireRetailerResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/retire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reinstate a retailer
 * Bring a retired retailer back into use. A ``reason`` is recorded on the event.
 */
export const reinstateRetailer = <ThrowOnError extends boolean = false>(options: Options<ReinstateRetailerData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReinstateRetailerResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/reinstate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A retailer's history
 * This organization's events about this retailer, newest first.
 *
 * ``from`` and ``to`` are UTC calendar days, both inclusive.
 */
export const listRetailerActivity = <ThrowOnError extends boolean = false>(options: Options<ListRetailerActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListRetailerActivityResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/activity',
        ...options
    });
};

/**
 * What refers to a retailer
 * This organization's rows referring to the retailer, by domain.
 *
 * Only tables with rows are listed. Soft-deleted rows do not count.
 */
export const getRetailerUsage = <ThrowOnError extends boolean = false>(options: Options<GetRetailerUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRetailerUsageResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/usage',
        ...options
    });
};

/**
 * List service providers
 * Return a page of this organization's service providers, ordered by code.
 *
 * Both live and retired rows by default. A picker wants ``is_active=true``;
 * a report attributing an old record to a closed service provider needs the closed
 * one listed.
 */
export const listServiceProviders = <ThrowOnError extends boolean = false>(options?: Options<ListServiceProvidersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListServiceProvidersResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers',
        ...options
    });
};

/**
 * Create a service provider
 * Create one service provider.
 *
 * Send an ``Idempotency-Key`` header and a retry after a timeout replays the
 * first attempt's response instead of creating a second row — which here
 * would burn a code that can never be reused.
 */
export const createServiceProvider = <ThrowOnError extends boolean = false>(options: Options<CreateServiceProviderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateServiceProviderResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fetch a service provider
 * Return one service provider by id.
 */
export const getServiceProvider = <ThrowOnError extends boolean = false>(options: Options<GetServiceProviderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetServiceProviderResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}',
        ...options
    });
};

/**
 * Update a service provider
 * Apply a partial update.
 *
 * Only fields actually sent are applied. ``code`` is not in the schema at
 * all, so sending one is a 422 naming the field rather than a silent no-op —
 * a code is the handle every integration already holds.
 */
export const updateServiceProvider = <ThrowOnError extends boolean = false>(options: Options<UpdateServiceProviderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateServiceProviderResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retire a service provider
 * Stop offering this service provider without removing it.
 *
 * Idempotent: retiring something already retired returns it unchanged and
 * records nothing, so a retry costs nothing and leaves no second event. A
 * ``reason``, when sent, is recorded on the event.
 */
export const retireServiceProvider = <ThrowOnError extends boolean = false>(options: Options<RetireServiceProviderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetireServiceProviderResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/retire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reinstate a service provider
 * Bring a retired service provider back into use. A ``reason`` is recorded on the event.
 */
export const reinstateServiceProvider = <ThrowOnError extends boolean = false>(options: Options<ReinstateServiceProviderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReinstateServiceProviderResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/reinstate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A service provider's history
 * This organization's events about this service provider, newest first.
 *
 * ``from`` and ``to`` are UTC calendar days, both inclusive.
 */
export const listServiceProviderActivity = <ThrowOnError extends boolean = false>(options: Options<ListServiceProviderActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListServiceProviderActivityResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/activity',
        ...options
    });
};

/**
 * What refers to a service provider
 * This organization's rows referring to the service provider, by domain.
 *
 * Only tables with rows are listed. Soft-deleted rows do not count.
 */
export const getServiceProviderUsage = <ThrowOnError extends boolean = false>(options: Options<GetServiceProviderUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetServiceProviderUsageResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/usage',
        ...options
    });
};

/**
 * Notes on a warehouse
 * This organization's notes on the entity, newest first.
 */
export const listWarehouseNotes = <ThrowOnError extends boolean = false>(options: Options<ListWarehouseNotesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListWarehouseNotesResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/notes',
        ...options
    });
};

/**
 * Add a note to a warehouse
 * Write a note as the caller. Needs only ``registry:view``.
 */
export const createWarehouseNote = <ThrowOnError extends boolean = false>(options: Options<CreateWarehouseNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateWarehouseNoteResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a note on a warehouse
 * Remove a note, softly. Its author, or anyone with ``registry:edit``.
 */
export const deleteWarehouseNote = <ThrowOnError extends boolean = false>(options: Options<DeleteWarehouseNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteWarehouseNoteResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/notes/{note_id}',
        ...options
    });
};

/**
 * Edit a note on a warehouse
 * Replace a note's text. Its author, or anyone with ``registry:edit``.
 */
export const updateWarehouseNote = <ThrowOnError extends boolean = false>(options: Options<UpdateWarehouseNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateWarehouseNoteResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/notes/{note_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A warehouse's tags
 * This organization's tags on the entity, alphabetically, ignoring case.
 */
export const getWarehouseTags = <ThrowOnError extends boolean = false>(options: Options<GetWarehouseTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWarehouseTagsResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/tags',
        ...options
    });
};

/**
 * Replace a warehouse's tags
 * Replace the whole set. Needs ``registry:edit``.
 */
export const replaceWarehouseTags = <ThrowOnError extends boolean = false>(options: Options<ReplaceWarehouseTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceWarehouseTagsResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A warehouse's contacts
 * This organization's contacts for the entity, in saved order.
 */
export const getWarehouseContacts = <ThrowOnError extends boolean = false>(options: Options<GetWarehouseContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetWarehouseContactsResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/contacts',
        ...options
    });
};

/**
 * Replace a warehouse's contacts
 * Replace the whole list. Needs ``registry:edit``.
 */
export const replaceWarehouseContacts = <ThrowOnError extends boolean = false>(options: Options<ReplaceWarehouseContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceWarehouseContactsResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/contacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Notes on a brand
 * This organization's notes on the entity, newest first.
 */
export const listBrandNotes = <ThrowOnError extends boolean = false>(options: Options<ListBrandNotesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListBrandNotesResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/notes',
        ...options
    });
};

/**
 * Add a note to a brand
 * Write a note as the caller. Needs only ``registry:view``.
 */
export const createBrandNote = <ThrowOnError extends boolean = false>(options: Options<CreateBrandNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateBrandNoteResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a note on a brand
 * Remove a note, softly. Its author, or anyone with ``registry:edit``.
 */
export const deleteBrandNote = <ThrowOnError extends boolean = false>(options: Options<DeleteBrandNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteBrandNoteResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/notes/{note_id}',
        ...options
    });
};

/**
 * Edit a note on a brand
 * Replace a note's text. Its author, or anyone with ``registry:edit``.
 */
export const updateBrandNote = <ThrowOnError extends boolean = false>(options: Options<UpdateBrandNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateBrandNoteResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/notes/{note_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A brand's tags
 * This organization's tags on the entity, alphabetically, ignoring case.
 */
export const getBrandTags = <ThrowOnError extends boolean = false>(options: Options<GetBrandTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBrandTagsResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/tags',
        ...options
    });
};

/**
 * Replace a brand's tags
 * Replace the whole set. Needs ``registry:edit``.
 */
export const replaceBrandTags = <ThrowOnError extends boolean = false>(options: Options<ReplaceBrandTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceBrandTagsResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A brand's contacts
 * This organization's contacts for the entity, in saved order.
 */
export const getBrandContacts = <ThrowOnError extends boolean = false>(options: Options<GetBrandContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBrandContactsResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/contacts',
        ...options
    });
};

/**
 * Replace a brand's contacts
 * Replace the whole list. Needs ``registry:edit``.
 */
export const replaceBrandContacts = <ThrowOnError extends boolean = false>(options: Options<ReplaceBrandContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceBrandContactsResponse, unknown, ThrowOnError>({
        url: '/v1/brands/{entity_id}/contacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Notes on a marketplace
 * This organization's notes on the entity, newest first.
 */
export const listMarketplaceNotes = <ThrowOnError extends boolean = false>(options: Options<ListMarketplaceNotesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListMarketplaceNotesResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/notes',
        ...options
    });
};

/**
 * Add a note to a marketplace
 * Write a note as the caller. Needs only ``registry:view``.
 */
export const createMarketplaceNote = <ThrowOnError extends boolean = false>(options: Options<CreateMarketplaceNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateMarketplaceNoteResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a note on a marketplace
 * Remove a note, softly. Its author, or anyone with ``registry:edit``.
 */
export const deleteMarketplaceNote = <ThrowOnError extends boolean = false>(options: Options<DeleteMarketplaceNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteMarketplaceNoteResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/notes/{note_id}',
        ...options
    });
};

/**
 * Edit a note on a marketplace
 * Replace a note's text. Its author, or anyone with ``registry:edit``.
 */
export const updateMarketplaceNote = <ThrowOnError extends boolean = false>(options: Options<UpdateMarketplaceNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateMarketplaceNoteResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/notes/{note_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A marketplace's tags
 * This organization's tags on the entity, alphabetically, ignoring case.
 */
export const getMarketplaceTags = <ThrowOnError extends boolean = false>(options: Options<GetMarketplaceTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketplaceTagsResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/tags',
        ...options
    });
};

/**
 * Replace a marketplace's tags
 * Replace the whole set. Needs ``registry:view``.
 */
export const replaceMarketplaceTags = <ThrowOnError extends boolean = false>(options: Options<ReplaceMarketplaceTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceMarketplaceTagsResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A marketplace's contacts
 * This organization's contacts for the entity, in saved order.
 */
export const getMarketplaceContacts = <ThrowOnError extends boolean = false>(options: Options<GetMarketplaceContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketplaceContactsResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/contacts',
        ...options
    });
};

/**
 * Replace a marketplace's contacts
 * Replace the whole list. Needs ``registry:view``.
 */
export const replaceMarketplaceContacts = <ThrowOnError extends boolean = false>(options: Options<ReplaceMarketplaceContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceMarketplaceContactsResponse, unknown, ThrowOnError>({
        url: '/v1/marketplaces/{entity_id}/contacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Notes on a vendor
 * This organization's notes on the entity, newest first.
 */
export const listVendorNotes = <ThrowOnError extends boolean = false>(options: Options<ListVendorNotesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListVendorNotesResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{entity_id}/notes',
        ...options
    });
};

/**
 * Add a note to a vendor
 * Write a note as the caller. Needs only ``registry:view``.
 */
export const createVendorNote = <ThrowOnError extends boolean = false>(options: Options<CreateVendorNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateVendorNoteResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{entity_id}/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a note on a vendor
 * Remove a note, softly. Its author, or anyone with ``registry:edit``.
 */
export const deleteVendorNote = <ThrowOnError extends boolean = false>(options: Options<DeleteVendorNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteVendorNoteResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{entity_id}/notes/{note_id}',
        ...options
    });
};

/**
 * Edit a note on a vendor
 * Replace a note's text. Its author, or anyone with ``registry:edit``.
 */
export const updateVendorNote = <ThrowOnError extends boolean = false>(options: Options<UpdateVendorNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateVendorNoteResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{entity_id}/notes/{note_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A vendor's tags
 * This organization's tags on the entity, alphabetically, ignoring case.
 */
export const getVendorTags = <ThrowOnError extends boolean = false>(options: Options<GetVendorTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVendorTagsResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{entity_id}/tags',
        ...options
    });
};

/**
 * Replace a vendor's tags
 * Replace the whole set. Needs ``operations:edit``.
 */
export const replaceVendorTags = <ThrowOnError extends boolean = false>(options: Options<ReplaceVendorTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceVendorTagsResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{entity_id}/tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A vendor's contacts
 * This organization's contacts for the entity, in saved order.
 */
export const getVendorContacts = <ThrowOnError extends boolean = false>(options: Options<GetVendorContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVendorContactsResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{entity_id}/contacts',
        ...options
    });
};

/**
 * Replace a vendor's contacts
 * Replace the whole list. Needs ``operations:edit``.
 */
export const replaceVendorContacts = <ThrowOnError extends boolean = false>(options: Options<ReplaceVendorContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceVendorContactsResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{entity_id}/contacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Notes on a retailer
 * This organization's notes on the entity, newest first.
 */
export const listRetailerNotes = <ThrowOnError extends boolean = false>(options: Options<ListRetailerNotesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListRetailerNotesResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/notes',
        ...options
    });
};

/**
 * Add a note to a retailer
 * Write a note as the caller. Needs only ``registry:view``.
 */
export const createRetailerNote = <ThrowOnError extends boolean = false>(options: Options<CreateRetailerNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateRetailerNoteResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a note on a retailer
 * Remove a note, softly. Its author, or anyone with ``registry:edit``.
 */
export const deleteRetailerNote = <ThrowOnError extends boolean = false>(options: Options<DeleteRetailerNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteRetailerNoteResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/notes/{note_id}',
        ...options
    });
};

/**
 * Edit a note on a retailer
 * Replace a note's text. Its author, or anyone with ``registry:edit``.
 */
export const updateRetailerNote = <ThrowOnError extends boolean = false>(options: Options<UpdateRetailerNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRetailerNoteResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/notes/{note_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A retailer's tags
 * This organization's tags on the entity, alphabetically, ignoring case.
 */
export const getRetailerTags = <ThrowOnError extends boolean = false>(options: Options<GetRetailerTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRetailerTagsResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/tags',
        ...options
    });
};

/**
 * Replace a retailer's tags
 * Replace the whole set. Needs ``registry:edit``.
 */
export const replaceRetailerTags = <ThrowOnError extends boolean = false>(options: Options<ReplaceRetailerTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceRetailerTagsResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A retailer's contacts
 * This organization's contacts for the entity, in saved order.
 */
export const getRetailerContacts = <ThrowOnError extends boolean = false>(options: Options<GetRetailerContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRetailerContactsResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/contacts',
        ...options
    });
};

/**
 * Replace a retailer's contacts
 * Replace the whole list. Needs ``registry:edit``.
 */
export const replaceRetailerContacts = <ThrowOnError extends boolean = false>(options: Options<ReplaceRetailerContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceRetailerContactsResponse, unknown, ThrowOnError>({
        url: '/v1/retailers/{entity_id}/contacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Notes on a service provider
 * This organization's notes on the entity, newest first.
 */
export const listServiceProviderNotes = <ThrowOnError extends boolean = false>(options: Options<ListServiceProviderNotesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListServiceProviderNotesResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/notes',
        ...options
    });
};

/**
 * Add a note to a service provider
 * Write a note as the caller. Needs only ``registry:view``.
 */
export const createServiceProviderNote = <ThrowOnError extends boolean = false>(options: Options<CreateServiceProviderNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateServiceProviderNoteResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a note on a service provider
 * Remove a note, softly. Its author, or anyone with ``registry:edit``.
 */
export const deleteServiceProviderNote = <ThrowOnError extends boolean = false>(options: Options<DeleteServiceProviderNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteServiceProviderNoteResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/notes/{note_id}',
        ...options
    });
};

/**
 * Edit a note on a service provider
 * Replace a note's text. Its author, or anyone with ``registry:edit``.
 */
export const updateServiceProviderNote = <ThrowOnError extends boolean = false>(options: Options<UpdateServiceProviderNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateServiceProviderNoteResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/notes/{note_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A service provider's tags
 * This organization's tags on the entity, alphabetically, ignoring case.
 */
export const getServiceProviderTags = <ThrowOnError extends boolean = false>(options: Options<GetServiceProviderTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetServiceProviderTagsResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/tags',
        ...options
    });
};

/**
 * Replace a service provider's tags
 * Replace the whole set. Needs ``registry:edit``.
 */
export const replaceServiceProviderTags = <ThrowOnError extends boolean = false>(options: Options<ReplaceServiceProviderTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceServiceProviderTagsResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A service provider's contacts
 * This organization's contacts for the entity, in saved order.
 */
export const getServiceProviderContacts = <ThrowOnError extends boolean = false>(options: Options<GetServiceProviderContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetServiceProviderContactsResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/contacts',
        ...options
    });
};

/**
 * Replace a service provider's contacts
 * Replace the whole list. Needs ``registry:edit``.
 */
export const replaceServiceProviderContacts = <ThrowOnError extends boolean = false>(options: Options<ReplaceServiceProviderContactsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceServiceProviderContactsResponse, unknown, ThrowOnError>({
        url: '/v1/service-providers/{entity_id}/contacts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Tags in use on one kind of entity
 * Every tag this organization uses on one kind of entity, most used first.
 *
 * Tags differing only in case are counted as one.
 */
export const listRegistryTags = <ThrowOnError extends boolean = false>(options: Options<ListRegistryTagsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListRegistryTagsResponse, unknown, ThrowOnError>({
        url: '/v1/registry-tags',
        ...options
    });
};

/**
 * The marketplace catalogue
 * Every marketplace, by family and then code, with this organization's stores and tags.
 *
 * Store counts and tags are this organization's own; another's never
 * reach them.
 */
export const listMarketplaceCatalogue = <ThrowOnError extends boolean = false>(options?: Options<ListMarketplaceCatalogueData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMarketplaceCatalogueResponse, unknown, ThrowOnError>({
        url: '/v1/marketplace-catalogue',
        ...options
    });
};

/**
 * One marketplace, as the catalogue shows it
 * One marketplace with this organization's store counts and tags on it.
 */
export const getMarketplaceCatalogueItem = <ThrowOnError extends boolean = false>(options: Options<GetMarketplaceCatalogueItemData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMarketplaceCatalogueItemResponse, unknown, ThrowOnError>({
        url: '/v1/marketplace-catalogue/{marketplace_id}',
        ...options
    });
};

/**
 * The catalogue's platform tabs
 * One entry per channel family, with how many of its marketplaces this organization uses.
 */
export const listMarketplaceFamilies = <ThrowOnError extends boolean = false>(options?: Options<ListMarketplaceFamiliesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMarketplaceFamiliesResponse, unknown, ThrowOnError>({
        url: '/v1/marketplace-families',
        ...options
    });
};

/**
 * The warehouse list
 * This organization's warehouses by name, with provider, tags and store counts.
 */
export const listWarehouseOverview = <ThrowOnError extends boolean = false>(options?: Options<ListWarehouseOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListWarehouseOverviewResponse, unknown, ThrowOnError>({
        url: '/v1/warehouse-overview',
        ...options
    });
};

/**
 * Warehouses by kind
 * How many warehouses of each kind, every kind listed, for the list's tabs.
 */
export const listWarehouseKinds = <ThrowOnError extends boolean = false>(options?: Options<ListWarehouseKindsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListWarehouseKindsResponse, unknown, ThrowOnError>({
        url: '/v1/warehouse-kinds',
        ...options
    });
};

/**
 * A warehouse's stores
 * The stores linked to the warehouse, by its priority in each, then code.
 */
export const listWarehouseStores = <ThrowOnError extends boolean = false>(options: Options<ListWarehouseStoresData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListWarehouseStoresResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/stores',
        ...options
    });
};

/**
 * Change a warehouse's stores
 * Link exactly these stores, each with the warehouse at the position sent.
 *
 * A store left out is unlinked; each store's list is renumbered 1..n.
 * Warnings name stores left with no warehouse, stores whose first
 * warehouse is now marketplace-fulfilled, and stores still on a retired
 * warehouse. Needs ``registry:edit``.
 */
export const replaceWarehouseStores = <ThrowOnError extends boolean = false>(options: Options<ReplaceWarehouseStoresData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceWarehouseStoresResponse, unknown, ThrowOnError>({
        url: '/v1/warehouses/{entity_id}/stores',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Carrier settings from the store's warehouse
 * DHL sender fields from the store's first-priority warehouse, to prefill a form.
 *
 * Nothing is saved. The country is ISO alpha-3; a field the warehouse lacks
 * is ``null``.
 */
export const getStoreCarrierDefaults = <ThrowOnError extends boolean = false>(options: Options<GetStoreCarrierDefaultsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStoreCarrierDefaultsResponse, unknown, ThrowOnError>({
        url: '/v1/stores/{store_id}/carrier-defaults',
        ...options
    });
};

/**
 * The vendor list
 * The vendors the caller can see, by name, with tags and counts.
 *
 * Counts: warehouses with live terms, open orders (stock in transit) and
 * the newest order's date - at the caller's warehouses only, when their
 * grant is pinned to some.
 */
export const listVendorOverview = <ThrowOnError extends boolean = false>(options?: Options<ListVendorOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListVendorOverviewResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-overview',
        ...options
    });
};

/**
 * One row of the vendor list
 * One vendor with its tags and counts, for the drawer and the full page.
 */
export const getVendorOverviewItem = <ThrowOnError extends boolean = false>(options: Options<GetVendorOverviewItemData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVendorOverviewItemResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-overview/{vendor_id}',
        ...options
    });
};

/**
 * List vendors
 * The vendors the caller can see, by name. Live and retired unless ``is_active`` says.
 */
export const listVendors = <ThrowOnError extends boolean = false>(options?: Options<ListVendorsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListVendorsResponse, unknown, ThrowOnError>({
        url: '/v1/vendors',
        ...options
    });
};

/**
 * Create a vendor
 * Create one vendor. Needs ``operations:edit`` across the organization.
 *
 * ``code`` left out gives ``vnd-<id>``. Send an ``Idempotency-Key`` and a
 * retry replays the first response rather than spending a second code.
 */
export const createVendor = <ThrowOnError extends boolean = false>(options: Options<CreateVendorData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateVendorResponse, unknown, ThrowOnError>({
        url: '/v1/vendors',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fetch a vendor
 * One vendor by id.
 */
export const getVendor = <ThrowOnError extends boolean = false>(options: Options<GetVendorData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVendorResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{vendor_id}',
        ...options
    });
};

/**
 * Update a vendor
 * Apply the fields sent. ``code`` is not a field: a code is permanent.
 *
 * Needs ``operations:edit`` across the organization.
 */
export const updateVendor = <ThrowOnError extends boolean = false>(options: Options<UpdateVendorData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateVendorResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{vendor_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retire a vendor
 * Stop offering the vendor without removing it. Idempotent; never blocked.
 *
 * A ``reason``, when sent, is recorded on the event. ``/retire-preview``
 * lists what to acknowledge first.
 */
export const retireVendor = <ThrowOnError extends boolean = false>(options: Options<RetireVendorData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetireVendorResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{vendor_id}/retire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reinstate a vendor
 * Bring a retired vendor back; 409 while an active vendor has taken its name.
 */
export const reinstateVendor = <ThrowOnError extends boolean = false>(options: Options<ReinstateVendorData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReinstateVendorResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{vendor_id}/reinstate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * What retiring a vendor would do
 * Never blocking; warns on open orders (``has_open_vendor_orders``), with its usage.
 */
export const getVendorRetirePreview = <ThrowOnError extends boolean = false>(options: Options<GetVendorRetirePreviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVendorRetirePreviewResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{vendor_id}/retire-preview',
        ...options
    });
};

/**
 * What refers to a vendor
 * This organization's rows referring to the vendor, by domain.
 */
export const getVendorUsage = <ThrowOnError extends boolean = false>(options: Options<GetVendorUsageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVendorUsageResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{vendor_id}/usage',
        ...options
    });
};

/**
 * A vendor's history
 * The vendor's events, newest first. ``from`` and ``to`` are UTC days, inclusive.
 */
export const listVendorActivity = <ThrowOnError extends boolean = false>(options: Options<ListVendorActivityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListVendorActivityResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{vendor_id}/activity',
        ...options
    });
};

/**
 * A vendor's terms at each warehouse
 * Its terms at the warehouses the caller can see, by warehouse name.
 *
 * Days are days; ``*_pct`` are percents, ``5`` being 5%.
 */
export const getVendorWarehouses = <ThrowOnError extends boolean = false>(options: Options<GetVendorWarehousesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVendorWarehousesResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{vendor_id}/warehouses',
        ...options
    });
};

/**
 * Change a vendor's terms
 * Make its terms exactly these; a warehouse left out has its terms removed.
 *
 * Needs ``operations:edit`` at every warehouse added, changed or removed; a
 * caller pinned to some warehouses replaces the terms at those only. A
 * returns rate needs its returns allowed.
 */
export const replaceVendorWarehouses = <ThrowOnError extends boolean = false>(options: Options<ReplaceVendorWarehousesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceVendorWarehousesResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{vendor_id}/warehouses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * A vendor's tax numbers
 * Its GST, VAT, EIN and other numbers, in saved order.
 */
export const getVendorTaxIds = <ThrowOnError extends boolean = false>(options: Options<GetVendorTaxIdsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVendorTaxIdsResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{vendor_id}/tax-ids',
        ...options
    });
};

/**
 * Replace a vendor's tax numbers
 * The whole list. Needs ``operations:edit`` across the organization.
 */
export const replaceVendorTaxIds = <ThrowOnError extends boolean = false>(options: Options<ReplaceVendorTaxIdsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceVendorTaxIdsResponse, unknown, ThrowOnError>({
        url: '/v1/vendors/{vendor_id}/tax-ids',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * What the filters can be chosen from
 * Warehouses for the filter.
 */
export const blockStockLookups = <ThrowOnError extends boolean = false>(options?: Options<BlockStockLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<BlockStockLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/block-stock/lookups',
        ...options
    });
};

/**
 * List blocks
 * Blocks, newest first, with units and SKU counts.
 */
export const listBlockStock = <ThrowOnError extends boolean = false>(options?: Options<ListBlockStockData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListBlockStockResponse, unknown, ThrowOnError>({
        url: '/v1/block-stock',
        ...options
    });
};

/**
 * Block stock
 * Block stock in inward boxes against a PO code.
 *
 * All or nothing: every line is checked first and every problem is listed.
 * Send an ``Idempotency-Key`` header and a retry replays the first response.
 */
export const createBlockStock = <ThrowOnError extends boolean = false>(options: Options<CreateBlockStockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateBlockStockResponse, unknown, ThrowOnError>({
        url: '/v1/block-stock',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Download the block list
 * Every block the list's filters select, all pages, as a spreadsheet.
 */
export const exportBlockStock = <ThrowOnError extends boolean = false>(options?: Options<ExportBlockStockData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/block-stock/export',
        ...options
    });
};

/**
 * What one block reserves
 * Each reserved SKU with its box and expiry.
 */
export const blockStockLines = <ThrowOnError extends boolean = false>(options: Options<BlockStockLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BlockStockLinesResponse, unknown, ThrowOnError>({
        url: '/v1/block-stock/{block_id}/lines',
        ...options
    });
};

/**
 * Add to block
 * Block more units under an existing block. The lines are added, not a new total.
 */
export const addBlockStockLines = <ThrowOnError extends boolean = false>(options: Options<AddBlockStockLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddBlockStockLinesResponse, unknown, ThrowOnError>({
        url: '/v1/block-stock/{block_id}/lines',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Download what one block reserves
 * The block's lines with the retailer's own code for each SKU, as a spreadsheet.
 */
export const exportBlockStockLines = <ThrowOnError extends boolean = false>(options: Options<ExportBlockStockLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/block-stock/{block_id}/lines/export',
        ...options
    });
};

/**
 * Check availability
 * Which boxes could cover these requirements now, earliest expiry first.
 *
 * Nothing is blocked; this only answers what blocking would take.
 */
export const blockStockAvailability = <ThrowOnError extends boolean = false>(options: Options<BlockStockAvailabilityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BlockStockAvailabilityResponse, unknown, ThrowOnError>({
        url: '/v1/block-stock/availability',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Check availability from a file
 * The availability check over an uploaded .xlsx or .csv, answered like the lines are.
 *
 * Read-only: nothing is stored, blocked or sent to VentaWiz-Ingest.
 */
export const uploadBlockStockAvailability = <ThrowOnError extends boolean = false>(options: Options<UploadBlockStockAvailabilityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UploadBlockStockAvailabilityResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/block-stock/availability/upload',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Download the availability template
 * The file to fill in: PO Code, Retailer SKU, Quantity.
 */
export const blockStockAvailabilityTemplate = <ThrowOnError extends boolean = false>(options?: Options<BlockStockAvailabilityTemplateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/block-stock/availability/template',
        ...options
    });
};

/**
 * Download an availability check
 * The same lines as Check availability, answered as a spreadsheet.
 */
export const exportBlockStockAvailability = <ThrowOnError extends boolean = false>(options: Options<ExportBlockStockAvailabilityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/v1/block-stock/availability/export',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Mail to packing team
 * Queue the block's lines to the packing team as an .xlsx attachment.
 *
 * Send an ``Idempotency-Key`` header and a retry replays the first response
 * rather than mailing twice.
 */
export const mailBlockStockPacking = <ThrowOnError extends boolean = false>(options: Options<MailBlockStockPackingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MailBlockStockPackingResponse, unknown, ThrowOnError>({
        url: '/v1/block-stock/{block_id}/mail-packing',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Unblock
 * Free every unit the block holds. Its lines are kept as a record.
 */
export const unblockBlockStock = <ThrowOnError extends boolean = false>(options: Options<UnblockBlockStockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnblockBlockStockResponse, unknown, ThrowOnError>({
        url: '/v1/block-stock/{block_id}/unblock',
        ...options
    });
};

/**
 * Shift stock
 * Move units between boxes in one warehouse: Shift Stock and Transfer SKU Stock.
 *
 * The same SKU on both sides shifts it; a different one transfers the units to
 * that SKU. A destination box that does not exist is created on the shelf. All
 * or nothing: every line is checked first and every problem is listed. Send an
 * ``Idempotency-Key`` header and a retry replays the first response.
 */
export const shiftStock = <ThrowOnError extends boolean = false>(options: Options<ShiftStockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShiftStockResponse, unknown, ThrowOnError>({
        url: '/v1/block-stock/shift',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Shift stock by retailer SKU
 * Move units of one SKU between boxes, the SKU named by a retailer's product code.
 *
 * Our own SKU code is accepted too; a code that could be either, with both in
 * the box, is refused rather than guessed. Otherwise as Shift stock.
 */
export const shiftStockByRetailerSku = <ThrowOnError extends boolean = false>(options: Options<ShiftStockByRetailerSkuData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShiftStockByRetailerSkuResponse, unknown, ThrowOnError>({
        url: '/v1/block-stock/shift-by-retailer-sku',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Unblock and shift
 * Release a block whole and move the units it held to other boxes.
 *
 * The lines must be everything the block holds. Nothing is released when the
 * move is refused.
 */
export const unblockAndShiftStock = <ThrowOnError extends boolean = false>(options: Options<UnblockAndShiftStockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnblockAndShiftStockResponse, unknown, ThrowOnError>({
        url: '/v1/block-stock/unblock-and-shift',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * The box ledger for a warehouse and window
 * Inward, outward and shift movements. A window is required.
 */
export const boxHistory = <ThrowOnError extends boolean = false>(options: Options<BoxHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BoxHistoryResponse, unknown, ThrowOnError>({
        url: '/v1/box-history',
        ...options
    });
};

/**
 * Download the inward history
 * The inward section under the ledger's filters: vendor invoices and credit notes.
 */
export const exportBoxHistoryInward = <ThrowOnError extends boolean = false>(options: Options<ExportBoxHistoryInwardData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/box-history/export/inward',
        ...options
    });
};

/**
 * Download the outward history
 * The outward section under the ledger's filters: sales invoices and debit notes.
 */
export const exportBoxHistoryOutward = <ThrowOnError extends boolean = false>(options: Options<ExportBoxHistoryOutwardData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/box-history/export/outward',
        ...options
    });
};

/**
 * Download the shift history
 * The shift section under the ledger's filters: moves between boxes.
 */
export const exportBoxHistoryShift = <ThrowOnError extends boolean = false>(options: Options<ExportBoxHistoryShiftData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/box-history/export/shift',
        ...options
    });
};

/**
 * Validate a transfer
 * Whether each box can move now, why not, and what it holds. Nothing is written.
 */
export const validateWarehouseTransfer = <ThrowOnError extends boolean = false>(options: Options<ValidateWarehouseTransferData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ValidateWarehouseTransferResponse, unknown, ThrowOnError>({
        url: '/v1/warehouse-transfer/validate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Transfer boxes
 * Move every mapped box into a new box in the destination, or none.
 *
 * Every check is run again with the boxes locked; any refused line refuses
 * the whole request, every problem listed. Send an ``Idempotency-Key``
 * header and a retry replays the first response.
 */
export const transferWarehouseStock = <ThrowOnError extends boolean = false>(options: Options<TransferWarehouseStockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TransferWarehouseStockResponse, unknown, ThrowOnError>({
        url: '/v1/warehouse-transfer',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Warehouses to choose from
 * The warehouses the box list can be asked about.
 */
export const boxLookups = <ThrowOnError extends boolean = false>(options?: Options<BoxLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<BoxLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/boxes/lookups',
        ...options
    });
};

/**
 * What a warehouse's boxes can be narrowed by
 * Vendors and retailers, and the documents and currencies on the window's boxes.
 */
export const boxFilterChoices = <ThrowOnError extends boolean = false>(options: Options<BoxFilterChoicesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BoxFilterChoicesResponse, unknown, ThrowOnError>({
        url: '/v1/boxes/filters',
        ...options
    });
};

/**
 * List boxes in a warehouse
 * Boxes, ordered by code, each with quantities and the documents that touch it.
 *
 * Placeholder boxes (code starting ``000``) are hidden unless named in
 * ``box_code``. ``exclude_blocked`` takes what valid blocks hold out of each
 * box's quantity, SKU by SKU and floored at zero; it keeps the box.
 */
export const listBoxes = <ThrowOnError extends boolean = false>(options: Options<ListBoxesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListBoxesResponse, unknown, ThrowOnError>({
        url: '/v1/boxes',
        ...options
    });
};

/**
 * Download the box list
 * Every box the list's filters select, all pages, as a spreadsheet.
 */
export const exportBoxes = <ThrowOnError extends boolean = false>(options: Options<ExportBoxesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/boxes/export',
        ...options
    });
};

/**
 * The SKUs inside some boxes
 * Each SKU in each box, with how much of it is blocked.
 */
export const boxContents = <ThrowOnError extends boolean = false>(options: Options<BoxContentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BoxContentsResponse, unknown, ThrowOnError>({
        url: '/v1/boxes/contents',
        ...options
    });
};

/**
 * What the filters can be chosen from
 * Warehouses, retailers, vendors and service providers for the filters.
 */
export const cashflowLookups = <ThrowOnError extends boolean = false>(options?: Options<CashflowLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CashflowLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/cashflow/lookups',
        ...options
    });
};

/**
 * Projected cashflow by week
 * Unsettled sales invoices in, unpaid vendor and SP invoices out, per week due.
 *
 * Money already past due at the start of the window is one row with no week.
 * Currencies are reported separately, never added together. Each row carries
 * the running balance in its currency, starting from the opening balance.
 */
export const getCashflow = <ThrowOnError extends boolean = false>(options?: Options<GetCashflowData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCashflowResponse, unknown, ThrowOnError>({
        url: '/v1/cashflow',
        ...options
    });
};

/**
 * The invoices behind one cashflow row
 * Every unsettled invoice counted in that row, earliest due first.
 *
 * Takes the same window and filters as the projection, so the amounts listed
 * always add up to the row.
 */
export const listCashflowDocuments = <ThrowOnError extends boolean = false>(options: Options<ListCashflowDocumentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListCashflowDocumentsResponse, unknown, ThrowOnError>({
        url: '/v1/cashflow/documents',
        ...options
    });
};

/**
 * What the filters can be chosen from
 * Warehouses and parties for the filters.
 */
export const creditDebitNotesLookups = <ThrowOnError extends boolean = false>(options?: Options<CreditDebitNotesLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CreditDebitNotesLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/credit-debit-notes/lookups',
        ...options
    });
};

/**
 * List credit / debit notes
 * Credit / debit notes, newest first. Voided rows are left out unless asked for.
 */
export const listCreditDebitNotes = <ThrowOnError extends boolean = false>(options?: Options<ListCreditDebitNotesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListCreditDebitNotesResponse, unknown, ThrowOnError>({
        url: '/v1/credit-debit-notes',
        ...options
    });
};

/**
 * Raise a credit / debit note
 * Save a note, move its stock, and apply it to the linked document.
 *
 * All or nothing: every line is checked first and every problem is listed.
 * Send an ``Idempotency-Key`` header and a retry replays the first response.
 */
export const createCreditDebitNote = <ThrowOnError extends boolean = false>(options: Options<CreateCreditDebitNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateCreditDebitNoteResponse, unknown, ThrowOnError>({
        url: '/v1/credit-debit-notes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * The lines of one document
 * Each line with its SKU and box.
 */
export const creditDebitNoteLines = <ThrowOnError extends boolean = false>(options: Options<CreditDebitNoteLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CreditDebitNoteLinesResponse, unknown, ThrowOnError>({
        url: '/v1/credit-debit-notes/{header_id}/lines',
        ...options
    });
};

/**
 * Check a note before saving it
 * Every problem saving this note would hit. Nothing is written.
 */
export const checkCreditDebitNote = <ThrowOnError extends boolean = false>(options: Options<CheckCreditDebitNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckCreditDebitNoteResponse, unknown, ThrowOnError>({
        url: '/v1/credit-debit-notes/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * One credit / debit note
 * A note and its lines.
 */
export const getCreditDebitNote = <ThrowOnError extends boolean = false>(options: Options<GetCreditDebitNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCreditDebitNoteResponse, unknown, ThrowOnError>({
        url: '/v1/credit-debit-notes/{note_id}',
        ...options
    });
};

/**
 * Edit a credit / debit note
 * Change the number, date, comment or prices. Fields left out keep their value.
 *
 * Type, stock mode, link, quantities and boxes are fixed once saved; void the
 * note and raise a new one to change them.
 */
export const editCreditDebitNote = <ThrowOnError extends boolean = false>(options: Options<EditCreditDebitNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<EditCreditDebitNoteResponse, unknown, ThrowOnError>({
        url: '/v1/credit-debit-notes/{note_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Download one credit / debit note
 * Each line with its box, codes, price and GST, then a TOTAL row.
 */
export const exportCreditDebitNote = <ThrowOnError extends boolean = false>(options: Options<ExportCreditDebitNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/credit-debit-notes/{note_id}/export',
        ...options
    });
};

/**
 * Void
 * Undo the note's stock move and its effect on the linked document. The record is kept.
 */
export const voidCreditDebitNote = <ThrowOnError extends boolean = false>(options: Options<VoidCreditDebitNoteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<VoidCreditDebitNoteResponse, unknown, ThrowOnError>({
        url: '/v1/credit-debit-notes/{note_id}/void',
        ...options
    });
};

/**
 * What the filters can be chosen from
 * Warehouses and parties for the filters.
 */
export const globalShipmentsLookups = <ThrowOnError extends boolean = false>(options?: Options<GlobalShipmentsLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GlobalShipmentsLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/global-shipments/lookups',
        ...options
    });
};

/**
 * List global shipments
 * Global shipments, latest dispatch first.
 */
export const listGlobalShipments = <ThrowOnError extends boolean = false>(options?: Options<ListGlobalShipmentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListGlobalShipmentsResponse, unknown, ThrowOnError>({
        url: '/v1/global-shipments',
        ...options
    });
};

/**
 * Raise a global shipment
 * Carry a vendor order at the import warehouse to a purchase order at the export one.
 *
 * Send an ``Idempotency-Key`` header and a retry replays the first response.
 */
export const createGlobalShipment = <ThrowOnError extends boolean = false>(options: Options<CreateGlobalShipmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateGlobalShipmentResponse, unknown, ThrowOnError>({
        url: '/v1/global-shipments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * One global shipment and its progress
 * The shipment, and how far its vendor order / purchase order pair has got.
 */
export const getGlobalShipment = <ThrowOnError extends boolean = false>(options: Options<GetGlobalShipmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetGlobalShipmentResponse, unknown, ThrowOnError>({
        url: '/v1/global-shipments/{shipment_id}',
        ...options
    });
};

/**
 * Edit a global shipment
 * Change the name, freight or tracking. Fields left out keep their value.
 */
export const editGlobalShipment = <ThrowOnError extends boolean = false>(options: Options<EditGlobalShipmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<EditGlobalShipmentResponse, unknown, ThrowOnError>({
        url: '/v1/global-shipments/{shipment_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete
 * Delete the shipment. Its vendor and purchase orders are untouched.
 */
export const deleteGlobalShipment = <ThrowOnError extends boolean = false>(options: Options<DeleteGlobalShipmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteGlobalShipmentResponse, unknown, ThrowOnError>({
        url: '/v1/global-shipments/{shipment_id}/delete',
        ...options
    });
};

/**
 * What the filters can be chosen from
 * Warehouses for the filter.
 */
export const replenLookups = <ThrowOnError extends boolean = false>(options?: Options<ReplenLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReplenLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/replen/lookups',
        ...options
    });
};

/**
 * Each SKU's replen class and focus at a warehouse
 * One row per SKU with a valid vendor cost here, by code; filtered, then paged.
 */
export const listReplenSkus = <ThrowOnError extends boolean = false>(options: Options<ListReplenSkusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListReplenSkusResponse, unknown, ThrowOnError>({
        url: '/v1/replen/skus',
        ...options
    });
};

/**
 * Why searched SKU codes are not on the grid
 * Our SKUs with no vendor cost here, and codes that are not SKUs.
 */
export const checkReplenSkus = <ThrowOnError extends boolean = false>(options: Options<CheckReplenSkusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckReplenSkusResponse, unknown, ThrowOnError>({
        url: '/v1/replen/sku-check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Save replen class and focus changes
 * Checked all or none, then applied, except changes taking a SKU off N.
 *
 * Those raise a T16 approval ticket and are written when someone else
 * accepts it; the response names them and the ticket. Focus stays on while
 * the SKU has stock here.
 */
export const applyReplenChanges = <ThrowOnError extends boolean = false>(options: Options<ApplyReplenChangesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApplyReplenChangesResponse, unknown, ThrowOnError>({
        url: '/v1/replen/changes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List purchase orders
 * Return a page of this organization's purchase orders.
 */
export const listPurchaseOrders = <ThrowOnError extends boolean = false>(options?: Options<ListPurchaseOrdersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPurchaseOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders',
        ...options
    });
};

/**
 * Create a purchase order
 * Create a PO with its lines.
 *
 * Send an ``Idempotency-Key`` header and a retry after a timeout replays the
 * first attempt's response instead of creating a second PO.
 */
export const createPurchaseOrder = <ThrowOnError extends boolean = false>(options: Options<CreatePurchaseOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreatePurchaseOrderResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Warehouses and retailers to choose from
 * The two short lists every PO filter and the create form pick from.
 */
export const purchaseOrderLookups = <ThrowOnError extends boolean = false>(options?: Options<PurchaseOrderLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PurchaseOrderLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/lookups',
        ...options
    });
};

/**
 * List PO codes for a picker
 * Every live PO in a warehouse: id, code, retailer and currency.
 */
export const listPurchaseOrderCodes = <ThrowOnError extends boolean = false>(options: Options<ListPurchaseOrderCodesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListPurchaseOrderCodesResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/codes',
        ...options
    });
};

/**
 * Check a purchase order without saving it
 * Run every validation create would, and return all the problems.
 *
 * Always 200, and never writes. ``ok`` says whether the same body would be
 * accepted.
 */
export const checkPurchaseOrder = <ThrowOnError extends boolean = false>(options: Options<CheckPurchaseOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckPurchaseOrderResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a purchase order
 * Soft-delete a PO. Refused while stock, an invoice or a vendor order refers to it.
 */
export const deletePurchaseOrder = <ThrowOnError extends boolean = false>(options: Options<DeletePurchaseOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeletePurchaseOrderResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/{po_id}',
        ...options
    });
};

/**
 * Fetch a purchase order
 * Return one PO with its lines and what has been committed against each.
 */
export const getPurchaseOrder = <ThrowOnError extends boolean = false>(options: Options<GetPurchaseOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPurchaseOrderResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/{po_id}',
        ...options
    });
};

/**
 * Update a purchase order's header
 * Change the header fields that were sent; the rest are left alone.
 */
export const updatePurchaseOrder = <ThrowOnError extends boolean = false>(options: Options<UpdatePurchaseOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdatePurchaseOrderResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/{po_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Download a purchase order's lines
 * SKU code, retailer SKU, quantity and cost of every live line, as VentaHub's download.
 */
export const exportPurchaseOrderLines = <ThrowOnError extends boolean = false>(options: Options<ExportPurchaseOrderLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/{po_id}/export',
        ...options
    });
};

/**
 * Replace a purchase order's lines
 * Replace the whole line set. Lines for a SKU already on the PO keep their id.
 */
export const replacePurchaseOrderLines = <ThrowOnError extends boolean = false>(options: Options<ReplacePurchaseOrderLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplacePurchaseOrderLinesResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/{po_id}/lines',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Set or clear the delivery appointment
 * Set the appointment date, or send ``null`` to clear it.
 */
export const setPurchaseOrderAppointment = <ThrowOnError extends boolean = false>(options: Options<SetPurchaseOrderAppointmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetPurchaseOrderAppointmentResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/{po_id}/appointment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Stock available for each line
 * For each line, how much of what was ordered the warehouse can cover now.
 */
export const purchaseOrderStockAvailability = <ThrowOnError extends boolean = false>(options: Options<PurchaseOrderStockAvailabilityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PurchaseOrderStockAvailabilityResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/{po_id}/stock-availability',
        ...options
    });
};

/**
 * Boxes allotted to a purchase order
 * The allotted boxes, and each line against what is allotted, blocked and invoiced.
 */
export const purchaseOrderAllotment = <ThrowOnError extends boolean = false>(options: Options<PurchaseOrderAllotmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PurchaseOrderAllotmentResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/{po_id}/allotment',
        ...options
    });
};

/**
 * Set the boxes allotted to a purchase order
 * The whole set: boxes allotted now and left out are released to the shelf.
 */
export const allotPurchaseOrderBoxes = <ThrowOnError extends boolean = false>(options: Options<AllotPurchaseOrderBoxesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AllotPurchaseOrderBoxesResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/{po_id}/allotment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Merge other purchase orders into this one
 * Fold their lines into this PO and delete them. Same warehouse, retailer and currency.
 */
export const mergePurchaseOrders = <ThrowOnError extends boolean = false>(options: Options<MergePurchaseOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MergePurchaseOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/purchase-orders/{po_id}/merge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * What the filters can be chosen from
 * Warehouses and parties for the filters.
 */
export const retailerReceiptsLookups = <ThrowOnError extends boolean = false>(options?: Options<RetailerReceiptsLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<RetailerReceiptsLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/retailer-receipts/lookups',
        ...options
    });
};

/**
 * List retailer receipts
 * Retailer receipts, newest first. Voided rows are left out unless asked for.
 */
export const listRetailerReceipts = <ThrowOnError extends boolean = false>(options?: Options<ListRetailerReceiptsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListRetailerReceiptsResponse, unknown, ThrowOnError>({
        url: '/v1/retailer-receipts',
        ...options
    });
};

/**
 * Record a receipt
 * Record money received against a sales invoice, by its number in a warehouse.
 *
 * Send an ``Idempotency-Key`` header and a retry replays the first response.
 */
export const recordRetailerReceipt = <ThrowOnError extends boolean = false>(options: Options<RecordRetailerReceiptData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RecordRetailerReceiptResponse, unknown, ThrowOnError>({
        url: '/v1/retailer-receipts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Void
 * Void it and take it back off the invoice's received total. The record is kept.
 */
export const voidRetailerReceipt = <ThrowOnError extends boolean = false>(options: Options<VoidRetailerReceiptData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<VoidRetailerReceiptResponse, unknown, ThrowOnError>({
        url: '/v1/retailer-receipts/{retailer_receipt_id}/void',
        ...options
    });
};

/**
 * Documents waiting for review
 * A warehouse's valid documents of one kind not yet approved, newest first.
 */
export const listReviewDocuments = <ThrowOnError extends boolean = false>(options: Options<ListReviewDocumentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListReviewDocumentsResponse, unknown, ThrowOnError>({
        url: '/v1/review/documents',
        ...options
    });
};

/**
 * One document to review
 * The header, its review state and its lines with the context a decision needs.
 */
export const getReviewDocument = <ThrowOnError extends boolean = false>(options: Options<GetReviewDocumentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetReviewDocumentResponse, unknown, ThrowOnError>({
        url: '/v1/review/documents/{entity_type}/{entity_id}',
        ...options
    });
};

/**
 * Download one document's lines
 * The lines and their decision context, the same figures the review panel shows.
 */
export const exportReviewDocument = <ThrowOnError extends boolean = false>(options: Options<ExportReviewDocumentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/review/documents/{entity_type}/{entity_id}/export',
        ...options
    });
};

/**
 * Approve or reject a document
 * Approving stamps the reviewer, and on a vendor invoice sets landed cost.
 *
 * Rejecting changes nothing on the document. Either way the creator is mailed
 * when their address is known. Nobody may decide a document they raised.
 */
export const decideReview = <ThrowOnError extends boolean = false>(options: Options<DecideReviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DecideReviewResponse, unknown, ThrowOnError>({
        url: '/v1/review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ask for a review by mail
 * Queue a mail to the warehouse's reviewers, the lines attached.
 */
export const requestReview = <ThrowOnError extends boolean = false>(options: Options<RequestReviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RequestReviewResponse, unknown, ThrowOnError>({
        url: '/v1/review/request',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * What the filters can be chosen from
 * Warehouses and parties for the filters.
 */
export const salesInvoicesLookups = <ThrowOnError extends boolean = false>(options?: Options<SalesInvoicesLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SalesInvoicesLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/lookups',
        ...options
    });
};

/**
 * List sales invoices
 * Sales invoices, newest first. Voided rows are left out unless asked for.
 */
export const listSalesInvoices = <ThrowOnError extends boolean = false>(options?: Options<ListSalesInvoicesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListSalesInvoicesResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices',
        ...options
    });
};

/**
 * Raise a sales invoice
 * Bill boxes to a retailer: priced lines, boxes marked billed, totals from the lines.
 *
 * Send an ``Idempotency-Key`` header and a retry replays the first response.
 */
export const createSalesInvoice = <ThrowOnError extends boolean = false>(options: Options<CreateSalesInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateSalesInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * The lines of one document
 * Each line with its SKU and box.
 */
export const salesInvoiceLines = <ThrowOnError extends boolean = false>(options: Options<SalesInvoiceLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SalesInvoiceLinesResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{header_id}/lines',
        ...options
    });
};

/**
 * Preview the lines some boxes would bill
 * Each SKU in the boxes with the retailer's price, or none where one must be typed.
 */
export const previewSalesInvoice = <ThrowOnError extends boolean = false>(options: Options<PreviewSalesInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreviewSalesInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/preview',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Check an invoice without raising it
 * Every problem raising it would hit. Nothing is written.
 */
export const checkSalesInvoice = <ThrowOnError extends boolean = false>(options: Options<CheckSalesInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckSalesInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Dispatch several invoices
 * Each stands alone: one that cannot be dispatched is reported, the rest are.
 */
export const dispatchSalesInvoices = <ThrowOnError extends boolean = false>(options: Options<DispatchSalesInvoicesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DispatchSalesInvoicesResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/dispatch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Deliver several invoices
 * Each stands alone: one that cannot be delivered is reported, the rest are.
 */
export const deliverSalesInvoices = <ThrowOnError extends boolean = false>(options: Options<DeliverSalesInvoicesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeliverSalesInvoicesResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/deliver',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * One sales invoice
 * The invoice, its lines, its boxes, and whether it has been reviewed.
 */
export const getSalesInvoice = <ThrowOnError extends boolean = false>(options: Options<GetSalesInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSalesInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{invoice_id}',
        ...options
    });
};

/**
 * Edit a sales invoice
 * Change the header or prices; totals are re-derived. Fields left out keep their value.
 */
export const editSalesInvoice = <ThrowOnError extends boolean = false>(options: Options<EditSalesInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<EditSalesInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{invoice_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete
 * Delete an invoice with no boxes left on it. The record is kept.
 */
export const deleteSalesInvoice = <ThrowOnError extends boolean = false>(options: Options<DeleteSalesInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteSalesInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{invoice_id}/delete',
        ...options
    });
};

/**
 * Bill another box onto an invoice
 * Under the same rules as raising the invoice.
 */
export const addSalesInvoiceBox = <ThrowOnError extends boolean = false>(options: Options<AddSalesInvoiceBoxData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddSalesInvoiceBoxResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{invoice_id}/boxes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Take a box off an invoice
 * Its lines go and it goes back on the shelf. Not once dispatched.
 */
export const removeSalesInvoiceBox = <ThrowOnError extends boolean = false>(options: Options<RemoveSalesInvoiceBoxData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RemoveSalesInvoiceBoxResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{invoice_id}/boxes/remove',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Boxes that could be added
 * On the shelf, or allotted to the invoice's PO; not billed, not blocked.
 */
export const salesInvoiceMappableBoxes = <ThrowOnError extends boolean = false>(options: Options<SalesInvoiceMappableBoxesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SalesInvoiceMappableBoxesResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{invoice_id}/mappable-boxes',
        ...options
    });
};

/**
 * The packing list
 * Every SKU in each box, with the retailer's code.
 */
export const salesInvoicePacking = <ThrowOnError extends boolean = false>(options: Options<SalesInvoicePackingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SalesInvoicePackingResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{invoice_id}/packing',
        ...options
    });
};

/**
 * Download the packing list
 * The invoice's boxes and what is in each, with the retailer's codes.
 */
export const exportSalesInvoicePacking = <ThrowOnError extends boolean = false>(options: Options<ExportSalesInvoicePackingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{invoice_id}/packing/export',
        ...options
    });
};

/**
 * Download the customer's copy
 * The invoice as the retailer receives it: parties, priced lines, totals. No costs.
 */
export const exportSalesInvoice = <ThrowOnError extends boolean = false>(options: Options<ExportSalesInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{invoice_id}/export',
        ...options
    });
};

/**
 * Dispatch an invoice
 * It must have been reviewed.
 */
export const dispatchSalesInvoice = <ThrowOnError extends boolean = false>(options: Options<DispatchSalesInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DispatchSalesInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{invoice_id}/dispatch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Deliver an invoice
 * It must have been dispatched, on or before this date.
 */
export const deliverSalesInvoice = <ThrowOnError extends boolean = false>(options: Options<DeliverSalesInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeliverSalesInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/sales-invoices/{invoice_id}/deliver',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * What the filters can be chosen from
 * The warehouses. Stores depend on the warehouse chosen.
 */
export const sellerFlexLookups = <ThrowOnError extends boolean = false>(options?: Options<SellerFlexLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SellerFlexLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/seller-flex/lookups',
        ...options
    });
};

/**
 * Stores served from a warehouse
 * The stores a count in this warehouse can be filed against, by name.
 */
export const sellerFlexStores = <ThrowOnError extends boolean = false>(options: Options<SellerFlexStoresData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SellerFlexStoresResponse, unknown, ThrowOnError>({
        url: '/v1/seller-flex/stores',
        ...options
    });
};

/**
 * List SellerFlex counts
 * Live counts, by store then SKU code, each with its age in days.
 */
export const listSellerFlexCounts = <ThrowOnError extends boolean = false>(options?: Options<ListSellerFlexCountsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListSellerFlexCountsResponse, unknown, ThrowOnError>({
        url: '/v1/seller-flex',
        ...options
    });
};

/**
 * Download the filtered SellerFlex counts
 * Every count the list's filters select, every page: store, SKU, quantity, date.
 */
export const exportSellerFlexCounts = <ThrowOnError extends boolean = false>(options?: Options<ExportSellerFlexCountsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/seller-flex/export',
        ...options
    });
};

/**
 * The filtered SellerFlex counts at a glance
 * How many counts, their units, and the newest and oldest count dates.
 */
export const sellerFlexSummary = <ThrowOnError extends boolean = false>(options?: Options<SellerFlexSummaryData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SellerFlexSummaryResponse, unknown, ThrowOnError>({
        url: '/v1/seller-flex/summary',
        ...options
    });
};

/**
 * Delete one count
 * Retire one count. Its units stop coming off the marketplace's reading.
 */
export const deleteSellerFlexCount = <ThrowOnError extends boolean = false>(options: Options<DeleteSellerFlexCountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteSellerFlexCountResponse, unknown, ThrowOnError>({
        url: '/v1/seller-flex/{count_id}/delete',
        ...options
    });
};

/**
 * Read the start of a sheet before uploading it
 * Headers as written and folded, the first rows, how many rows it has, and any asked for.
 */
export const previewSheet = <ThrowOnError extends boolean = false>(options: Options<PreviewSheetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreviewSheetResponse, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/sheets/preview',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * The sheet back, with each problem beside its row
 * For fixing a sheet in place: problem rows tinted, a Problems column, and a list.
 */
export const markSheetProblems = <ThrowOnError extends boolean = false>(options: Options<MarkSheetProblemsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/v1/sheets/marked',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * What the filters can be chosen from
 * Warehouses, service providers and the invoice types.
 */
export const spInvoicesLookups = <ThrowOnError extends boolean = false>(options?: Options<SpInvoicesLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SpInvoicesLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/sp-invoices/lookups',
        ...options
    });
};

/**
 * List sp invoices
 * SP invoices, newest first. Voided rows are left out unless asked for.
 */
export const listSpInvoices = <ThrowOnError extends boolean = false>(options?: Options<ListSpInvoicesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListSpInvoicesResponse, unknown, ThrowOnError>({
        url: '/v1/sp-invoices',
        ...options
    });
};

/**
 * Record an SP invoice
 * Record a service provider's bill. A retry with the same ``Idempotency-Key`` replays.
 */
export const createSpInvoice = <ThrowOnError extends boolean = false>(options: Options<CreateSpInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateSpInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/sp-invoices',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Edit an SP invoice
 * Replace its details. What has been paid stays, and the amount cannot fall below it.
 */
export const editSpInvoice = <ThrowOnError extends boolean = false>(options: Options<EditSpInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<EditSpInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/sp-invoices/{invoice_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete an SP invoice
 * Delete one nothing has been paid against.
 */
export const deleteSpInvoice = <ThrowOnError extends boolean = false>(options: Options<DeleteSpInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteSpInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/sp-invoices/{invoice_id}/delete',
        ...options
    });
};

/**
 * What the filters can be chosen from
 * Warehouses and parties for the filters.
 */
export const spPaymentsLookups = <ThrowOnError extends boolean = false>(options?: Options<SpPaymentsLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SpPaymentsLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/sp-payments/lookups',
        ...options
    });
};

/**
 * List sp payments
 * SP payments, newest first. Voided rows are left out unless asked for.
 */
export const listSpPayments = <ThrowOnError extends boolean = false>(options?: Options<ListSpPaymentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListSpPaymentsResponse, unknown, ThrowOnError>({
        url: '/v1/sp-payments',
        ...options
    });
};

/**
 * Record a payment
 * Record money paid against a service provider invoice, by its number in a warehouse.
 *
 * Send an ``Idempotency-Key`` header and a retry replays the first response.
 */
export const recordSpPayment = <ThrowOnError extends boolean = false>(options: Options<RecordSpPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RecordSpPaymentResponse, unknown, ThrowOnError>({
        url: '/v1/sp-payments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Void
 * Void it and take it back off the invoice's paid total. The record is kept.
 */
export const voidSpPayment = <ThrowOnError extends boolean = false>(options: Options<VoidSpPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<VoidSpPaymentResponse, unknown, ThrowOnError>({
        url: '/v1/sp-payments/{sp_payment_id}/void',
        ...options
    });
};

/**
 * Warehouses to choose from
 * The warehouses the position can be asked about.
 */
export const stockLookups = <ThrowOnError extends boolean = false>(options?: Options<StockLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StockLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/stock/lookups',
        ...options
    });
};

/**
 * What a warehouse's stock can be narrowed by
 * Vendors and retailers that price a SKU here, and brands with stock here.
 */
export const stockFilters = <ThrowOnError extends boolean = false>(options: Options<StockFiltersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<StockFiltersResponse, unknown, ThrowOnError>({
        url: '/v1/stock/filters',
        ...options
    });
};

/**
 * Stock per SKU in a warehouse
 * Per SKU: box quantity, blocked, available and the cost in force.
 *
 * As of the stock mart's last build. Box quantity is inward boxes, plus
 * allotted when asked. Blocked is what valid blocks hold on inward boxes, each
 * block taken off its own box only. Placeholder boxes (code starting ``000``)
 * are never counted.
 */
export const getStock = <ThrowOnError extends boolean = false>(options: Options<GetStockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStockResponse, unknown, ThrowOnError>({
        url: '/v1/stock',
        ...options
    });
};

/**
 * Download stock per SKU
 * Every SKU the page's filters select, all pages, as a spreadsheet.
 */
export const exportStock = <ThrowOnError extends boolean = false>(options: Options<ExportStockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/stock/export',
        ...options
    });
};

/**
 * What the filters can be chosen from
 * Warehouses for the filter.
 */
export const stockAgeingLookups = <ThrowOnError extends boolean = false>(options?: Options<StockAgeingLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StockAgeingLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/stock-ageing/lookups',
        ...options
    });
};

/**
 * List a warehouse's stock by age
 * One row per SKU with stock, most units first; the age buckets add up to its units.
 */
export const listStockAgeing = <ThrowOnError extends boolean = false>(options: Options<ListStockAgeingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListStockAgeingResponse, unknown, ThrowOnError>({
        url: '/v1/stock-ageing',
        ...options
    });
};

/**
 * How much of a warehouse's stock can be dated
 * Units dated, pre-migration (age not known) and with no receipt.
 */
export const stockAgeingCoverage = <ThrowOnError extends boolean = false>(options: Options<StockAgeingCoverageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<StockAgeingCoverageResponse, unknown, ThrowOnError>({
        url: '/v1/stock-ageing/coverage',
        ...options
    });
};

/**
 * The boxes behind one SKU's ages
 * Each box holding the SKU, with the receipt that dated it, oldest first.
 */
export const stockAgeingBoxes = <ThrowOnError extends boolean = false>(options: Options<StockAgeingBoxesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<StockAgeingBoxesResponse, unknown, ThrowOnError>({
        url: '/v1/stock-ageing/boxes',
        ...options
    });
};

/**
 * Download a warehouse's stock ageing
 * The SKU grid, as filtered, as a spreadsheet.
 */
export const exportStockAgeing = <ThrowOnError extends boolean = false>(options: Options<ExportStockAgeingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/stock-ageing/export',
        ...options
    });
};

/**
 * What the filters can be chosen from
 * Warehouses and parties for the filters.
 */
export const vendorInvoicesLookups = <ThrowOnError extends boolean = false>(options?: Options<VendorInvoicesLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<VendorInvoicesLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-invoices/lookups',
        ...options
    });
};

/**
 * List vendor invoices
 * Vendor invoices, newest first. Voided rows are left out unless asked for.
 */
export const listVendorInvoices = <ThrowOnError extends boolean = false>(options?: Options<ListVendorInvoicesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListVendorInvoicesResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-invoices',
        ...options
    });
};

/**
 * Record a vendor invoice
 * Record it and receive its lines into boxes. A retried request replays.
 */
export const createVendorInvoice = <ThrowOnError extends boolean = false>(options: Options<CreateVendorInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateVendorInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-invoices',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * The lines of one document
 * Each line with its SKU and box.
 */
export const vendorInvoiceLines = <ThrowOnError extends boolean = false>(options: Options<VendorInvoiceLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<VendorInvoiceLinesResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-invoices/{header_id}/lines',
        ...options
    });
};

/**
 * Check a new vendor invoice without saving it
 * Every problem saving would refuse, by line, and what is only worth a look.
 */
export const checkVendorInvoice = <ThrowOnError extends boolean = false>(options: Options<CheckVendorInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckVendorInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-invoices/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * One vendor invoice
 * The invoice, its lines and the vendor order it fills.
 */
export const getVendorInvoice = <ThrowOnError extends boolean = false>(options: Options<GetVendorInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVendorInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-invoices/{invoice_id}',
        ...options
    });
};

/**
 * Edit a vendor invoice's header
 * Number, dates, currency, amount, costs and comment. Lines and order stay.
 */
export const editVendorInvoice = <ThrowOnError extends boolean = false>(options: Options<EditVendorInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<EditVendorInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-invoices/{invoice_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Download a vendor invoice's line items
 * The header on one sheet, the lines on ``Line Items`` in the upload template's columns.
 */
export const exportVendorInvoice = <ThrowOnError extends boolean = false>(options: Options<ExportVendorInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/vendor-invoices/{invoice_id}/export',
        ...options
    });
};

/**
 * Check new lines without saving them
 * What replacing the lines would refuse, and what is only worth a look.
 */
export const checkVendorInvoiceLines = <ThrowOnError extends boolean = false>(options: Options<CheckVendorInvoiceLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckVendorInvoiceLinesResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-invoices/{invoice_id}/lines/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Replace a vendor invoice's lines
 * The lines become these; only the difference moves stock.
 */
export const replaceVendorInvoiceLines = <ThrowOnError extends boolean = false>(options: Options<ReplaceVendorInvoiceLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceVendorInvoiceLinesResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-invoices/{invoice_id}/lines',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a vendor invoice
 * Its units go back out of their boxes. Refused once paid against.
 */
export const deleteVendorInvoice = <ThrowOnError extends boolean = false>(options: Options<DeleteVendorInvoiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeleteVendorInvoiceResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-invoices/{invoice_id}/delete',
        ...options
    });
};

/**
 * List vendor orders
 * Return a page of this organization's vendor orders.
 */
export const listVendorOrders = <ThrowOnError extends boolean = false>(options?: Options<ListVendorOrdersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListVendorOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-orders',
        ...options
    });
};

/**
 * Create a vendor order
 * Create an order with its lines.
 *
 * Send an ``Idempotency-Key`` header and a retry after a timeout replays the
 * first attempt's response instead of creating a second order.
 */
export const createVendorOrder = <ThrowOnError extends boolean = false>(options: Options<CreateVendorOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateVendorOrderResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-orders',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Warehouses and vendors to choose from
 * The two short lists every vendor-order filter and the create form pick from.
 */
export const vendorOrderLookups = <ThrowOnError extends boolean = false>(options?: Options<VendorOrderLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<VendorOrderLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-orders/lookups',
        ...options
    });
};

/**
 * List vendor-order codes for a picker
 * Every live order in a warehouse: id, code, vendor and currency.
 */
export const listVendorOrderCodes = <ThrowOnError extends boolean = false>(options: Options<ListVendorOrderCodesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListVendorOrderCodesResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-orders/codes',
        ...options
    });
};

/**
 * Check a vendor order without saving it
 * Run every validation create would, and return all the problems.
 *
 * Always 200, and never writes. ``ok`` says whether the same body would be
 * accepted.
 */
export const checkVendorOrder = <ThrowOnError extends boolean = false>(options: Options<CheckVendorOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckVendorOrderResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-orders/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete a vendor order
 * Soft-delete an order. Refused while a vendor invoice is mapped to it.
 */
export const deleteVendorOrder = <ThrowOnError extends boolean = false>(options: Options<DeleteVendorOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteVendorOrderResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-orders/{vo_id}',
        ...options
    });
};

/**
 * Fetch a vendor order
 * Return one order with its lines and cost warnings.
 */
export const getVendorOrder = <ThrowOnError extends boolean = false>(options: Options<GetVendorOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVendorOrderResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-orders/{vo_id}',
        ...options
    });
};

/**
 * Update a vendor order's header
 * Change the header fields that were sent; the rest are left alone.
 */
export const updateVendorOrder = <ThrowOnError extends boolean = false>(options: Options<UpdateVendorOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateVendorOrderResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-orders/{vo_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Move a vendor order to another warehouse or vendor
 * The order is deleted and reopened at the target with its code and lines.
 *
 * Refused while a vendor invoice is mapped to it. Its PO link and approval stay
 * behind.
 */
export const shiftVendorOrder = <ThrowOnError extends boolean = false>(options: Options<ShiftVendorOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ShiftVendorOrderResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-orders/{vo_id}/shift',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Fold other vendor orders into this one
 * Same warehouse, vendor and currency; each merged order is then deleted.
 */
export const mergeVendorOrders = <ThrowOnError extends boolean = false>(options: Options<MergeVendorOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MergeVendorOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-orders/{vo_id}/merge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Replace a vendor order's lines
 * Replace the whole line set. Lines for a SKU already on the order keep their id.
 */
export const replaceVendorOrderLines = <ThrowOnError extends boolean = false>(options: Options<ReplaceVendorOrderLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ReplaceVendorOrderLinesResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-orders/{vo_id}/lines',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Download an order's lines
 * The order's lines as an ``.xlsx``, in the shape the lines upload reads.
 */
export const exportVendorOrder = <ThrowOnError extends boolean = false>(options: Options<ExportVendorOrderData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/vendor-orders/{vo_id}/export',
        ...options
    });
};

/**
 * What the filters can be chosen from
 * Warehouses and parties for the filters.
 */
export const vendorPaymentsLookups = <ThrowOnError extends boolean = false>(options?: Options<VendorPaymentsLookupsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<VendorPaymentsLookupsResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-payments/lookups',
        ...options
    });
};

/**
 * List vendor payments
 * Vendor payments, newest first. Voided rows are left out unless asked for.
 */
export const listVendorPayments = <ThrowOnError extends boolean = false>(options?: Options<ListVendorPaymentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListVendorPaymentsResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-payments',
        ...options
    });
};

/**
 * Record a payment
 * Record money paid against a vendor invoice, by its number in a warehouse.
 *
 * Send an ``Idempotency-Key`` header and a retry replays the first response.
 */
export const recordVendorPayment = <ThrowOnError extends boolean = false>(options: Options<RecordVendorPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RecordVendorPaymentResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-payments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Void
 * Void it and take it back off the invoice's paid total. The record is kept.
 */
export const voidVendorPayment = <ThrowOnError extends boolean = false>(options: Options<VoidVendorPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<VoidVendorPaymentResponse, unknown, ThrowOnError>({
        url: '/v1/vendor-payments/{vendor_payment_id}/void',
        ...options
    });
};

/**
 * Report filter options
 * The ids every report filter takes, with their names.
 *
 * Warehouses, marketplaces, stores, retailers, brands, categories and
 * sub-categories. Needs any report's permission.
 */
export const reportOptions = <ThrowOnError extends boolean = false>(options?: Options<ReportOptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ReportOptionsResponse, unknown, ThrowOnError>({
        url: '/v1/reports/options',
        ...options
    });
};

/**
 * Marketplace sales
 * Marketplace order lines, grouped, with totals per currency.
 *
 * An order's day is its marketplace's own unless ``tz`` names another.
 * With ``convert_to``, every amount is in that currency and each group and
 * the totals are one row. Needs ``orders:view``.
 */
export const reportMpSales = <ThrowOnError extends boolean = false>(options: Options<ReportMpSalesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportMpSalesResponse, unknown, ThrowOnError>({
        url: '/v1/reports/mp-sales',
        ...options
    });
};

/**
 * Retailer sales
 * Invoice lines to retailers (DF, OF, VO), grouped, with totals per currency.
 *
 * Needs ``operations:view``.
 */
export const reportNonmpSales = <ThrowOnError extends boolean = false>(options: Options<ReportNonmpSalesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportNonmpSalesResponse, unknown, ThrowOnError>({
        url: '/v1/reports/nonmp-sales',
        ...options
    });
};

/**
 * Marketplace payments
 * Marketplace settlement lines, grouped, with totals per currency.
 *
 * A line is dated by the day it was paid, or with ``date_basis=order`` by
 * the day of the order it pays for. Copies, memo lines and lines held out
 * are counted and hold no money. Needs ``finance:view``.
 */
export const reportMpPayments = <ThrowOnError extends boolean = false>(options: Options<ReportMpPaymentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportMpPaymentsResponse, unknown, ThrowOnError>({
        url: '/v1/reports/mp-payments',
        ...options
    });
};

/**
 * Marketplace payouts
 * Marketplace payouts by the day paid, grouped, with totals per currency.
 *
 * A payout is the marketplace's own figure where it reports one, beside
 * the sum of its lines. Needs ``finance:view``.
 */
export const reportMpPayouts = <ThrowOnError extends boolean = false>(options: Options<ReportMpPayoutsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportMpPayoutsResponse, unknown, ThrowOnError>({
        url: '/v1/reports/mp-payouts',
        ...options
    });
};

/**
 * Retailer receipts
 * Money retailers paid on DF, OF and VO invoices, by the receipt's day, per currency.
 *
 * Needs ``finance:view``.
 */
export const reportNonmpReceipts = <ThrowOnError extends boolean = false>(options: Options<ReportNonmpReceiptsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportNonmpReceiptsResponse, unknown, ThrowOnError>({
        url: '/v1/reports/nonmp-receipts',
        ...options
    });
};

/**
 * Receivables
 * What retailers owe on DF, OF and VO invoices, grouped, with totals per currency.
 *
 * A snapshot taken at ``meta.as_of``: billed, received, outstanding and
 * overdue. Needs ``finance:view``.
 */
export const reportReceivables = <ThrowOnError extends boolean = false>(options: Options<ReportReceivablesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportReceivablesResponse, unknown, ThrowOnError>({
        url: '/v1/reports/receivables',
        ...options
    });
};

/**
 * Profit and loss
 * Sales, cost, PPP, ad spend, CP and its margin, grouped, per currency.
 *
 * Marketplace lines are dated by their order, invoices by their date and
 * ad spend by its day. ``loss_only`` keeps the loss-makers: the groups whose
 * CP is below zero. Needs ``finance:view``.
 */
export const reportPnl = <ThrowOnError extends boolean = false>(options: Options<ReportPnlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportPnlResponse, unknown, ThrowOnError>({
        url: '/v1/reports/pnl',
        ...options
    });
};

/**
 * SKU profitability
 * Each SKU at each store over the range, its profit and what it is made of.
 *
 * Units and sales by channel, the cost of goods, what the marketplace kept
 * and paid, advertising, profit and its markup, and the stock now with the
 * days it covers.
 *
 * Invoices (DF, OF, VO) count at the store their retailer sells through among
 * the stores linked to their warehouse. A loss-maker lost money, or made a
 * markup five points or more under its store's expected one. Amounts are in
 * the row's currency; the totals hold one entry per currency. Needs
 * ``finance:view``.
 */
export const reportSkuProfitability = <ThrowOnError extends boolean = false>(options: Options<ReportSkuProfitabilityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportSkuProfitabilityResponse, unknown, ThrowOnError>({
        url: '/v1/reports/sku-profitability',
        ...options
    });
};

/**
 * The order lines behind a SKU row
 * Every marketplace order line of the SKU at the store over the range, newest first.
 *
 * Each with what was paid on it: the payouts that settled it, or none while
 * it awaits payout. The totals cover every line and equal the SKU row of
 * ``/sku-profitability`` for the same store, SKU, currency and range; the
 * row's advertising is stated beside them, since no order line owns it.
 * Needs ``finance:view``.
 */
export const reportSkuOrders = <ThrowOnError extends boolean = false>(options: Options<ReportSkuOrdersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportSkuOrdersResponse, unknown, ThrowOnError>({
        url: '/v1/reports/sku-orders',
        ...options
    });
};

/**
 * The invoice lines behind a SKU row
 * Every DF, OF and VO invoice line of the SKU counted at the store, newest first.
 *
 * An invoice counts at the store its retailer sells through among the
 * stores linked to its warehouse, as on the SKU row. Each line carries its
 * invoice's balance, which is the whole invoice's and so is not totalled.
 * Needs ``finance:view``.
 */
export const reportSkuInvoiceLines = <ThrowOnError extends boolean = false>(options: Options<ReportSkuInvoiceLinesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportSkuInvoiceLinesResponse, unknown, ThrowOnError>({
        url: '/v1/reports/sku-invoice-lines',
        ...options
    });
};

/**
 * Warehouse stock
 * Stock in our warehouses by (box, SKU) position, with its age, grouped.
 *
 * ``search`` matches a SKU code or a box code. Needs ``inventory:view``.
 */
export const reportWhStock = <ThrowOnError extends boolean = false>(options: Options<ReportWhStockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportWhStockResponse, unknown, ThrowOnError>({
        url: '/v1/reports/wh-stock',
        ...options
    });
};

/**
 * Marketplace stock
 * Stock Amazon and Noon hold for us, current pools only, grouped.
 *
 * ``search`` matches a SKU code, seller SKU or ASIN. Needs ``inventory:view``.
 */
export const reportFbaStock = <ThrowOnError extends boolean = false>(options: Options<ReportFbaStockData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportFbaStockResponse, unknown, ThrowOnError>({
        url: '/v1/reports/fba-stock',
        ...options
    });
};

/**
 * Stock in transit
 * Stock ordered from suppliers and group companies, by the warehouse it is for, grouped.
 *
 * ``search`` matches a SKU code or a vendor order code. Needs ``inventory:view``.
 */
export const reportInTransit = <ThrowOnError extends boolean = false>(options: Options<ReportInTransitData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportInTransitResponse, unknown, ThrowOnError>({
        url: '/v1/reports/in-transit',
        ...options
    });
};

/**
 * Advertising
 * Amazon advertising by day, grouped, with totals per currency.
 *
 * Adds up to Amazon's ad-group report wherever it has a row. A day is the
 * ads profile's own. With ``convert_to``, spend and ad sales are in that
 * currency, each group and the totals are one row, and ACOS, ROAS and CPC
 * are recomputed from the converted sums. Needs ``ads:view``.
 */
export const reportAds = <ThrowOnError extends boolean = false>(options: Options<ReportAdsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportAdsResponse, unknown, ThrowOnError>({
        url: '/v1/reports/ads',
        ...options
    });
};

/**
 * Traffic
 * Amazon's weekly traffic per product, grouped, with totals.
 *
 * A week is in the date range when its Sunday is. Needs ``catalogue:view``.
 */
export const reportTraffic = <ThrowOnError extends boolean = false>(options: Options<ReportTrafficData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportTrafficResponse, unknown, ThrowOnError>({
        url: '/v1/reports/traffic',
        ...options
    });
};

/**
 * Amazon vendor sell-out
 * Amazon's weekly sell-out of what it bought from us, grouped, per currency.
 *
 * Amazon's sales, never ours. A week is in the date range when its Sunday
 * is. Needs ``catalogue:view``.
 */
export const reportVendorSales = <ThrowOnError extends boolean = false>(options: Options<ReportVendorSalesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportVendorSalesResponse, unknown, ThrowOnError>({
        url: '/v1/reports/vendor-sales',
        ...options
    });
};

/**
 * Amazon vendor stock
 * Amazon's stock of what it bought from us, grouped, per currency.
 *
 * Each store's newest reported week: no date range. Amazon's stock, never
 * ours. Needs ``catalogue:view``.
 */
export const reportVendorInventory = <ThrowOnError extends boolean = false>(options: Options<ReportVendorInventoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportVendorInventoryResponse, unknown, ThrowOnError>({
        url: '/v1/reports/vendor-inventory',
        ...options
    });
};

/**
 * Listings
 * Live listings as they stand, grouped, with their status and price.
 *
 * No date range. Needs ``catalogue:view``.
 */
export const reportListings = <ThrowOnError extends boolean = false>(options: Options<ReportListingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportListingsResponse, unknown, ThrowOnError>({
        url: '/v1/reports/listings',
        ...options
    });
};

/**
 * Business View
 * Sales by channel, payments, stock, advertising and Amazon's data, per SKU or listing.
 *
 * Each figure is read from its own report and summed there before the rows
 * are joined, so no figure is repeated. Amounts are per currency. Rows are
 * the SKUs that sold or hold stock. Needs ``orders:view``; each further
 * section needs its report's permission and is ``null`` without it.
 */
export const reportBusinessView = <ThrowOnError extends boolean = false>(options: Options<ReportBusinessViewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportBusinessViewResponse, unknown, ThrowOnError>({
        url: '/v1/reports/business-view',
        ...options
    });
};

/**
 * Distinct values of a Business View field
 * For a text field's filter list: searched, paged by cursor, under every other filter.
 *
 * The field's own filter is left out, so the list offers what the rest of the
 * view leaves. Needs ``orders:view``.
 */
export const businessViewValues = <ThrowOnError extends boolean = false>(options: Options<BusinessViewValuesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<BusinessViewValuesResponse, unknown, ThrowOnError>({
        url: '/v1/reports/business-view/values',
        ...options
    });
};

/**
 * Download the Business View
 * Every row of the view, as the page filters and sorts them, in one ``.xlsx``.
 *
 * The page's columns in its order, an amount as a number in its currency.
 * Needs what the page needs; at most ``MAX_EXPORT_ROWS`` rows.
 */
export const exportBusinessView = <ThrowOnError extends boolean = false>(options: Options<ExportBusinessViewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/v1/reports/business-view/export',
        ...options
    });
};

/**
 * Payment reconciliation
 * Each marketplace order line placed in the range, against what it was paid.
 *
 * The line's price and units beside the principal, tax, commission and
 * fees the settlement lines linked to it paid, and whether that squares:
 * matched, unmatched, partially matched or returned. Totals are over every
 * matching line, per currency. Beside them, the line's buying cost and its
 * margin — what it earned less that cost — over the line price, and the
 * SKU's replenishment class. Sort by ``order_date`` (the default) or any
 * column of the row. Needs ``finance:view``.
 */
export const reportPaymentReconciliation = <ThrowOnError extends boolean = false>(options: Options<ReportPaymentReconciliationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportPaymentReconciliationResponse, unknown, ThrowOnError>({
        url: '/v1/reports/payment-reconciliation',
        ...options
    });
};

/**
 * Review Data
 * Each SKU's Business View figures over two periods, with what it is now.
 *
 * The two periods are the Business View's SKU rows over each window, joined
 * on the SKU: a SKU that sold in either is a row. Beside them, focus, A+,
 * IDQ, Prime, stranded, stock by warehouse priority and Amazon's aged-stock
 * fee now; the fill rate and best rank per period; and the current period's
 * money still to be paid and its loss. Stock cover is (P1 + FBA stock) *
 * days ÷ seller units and returns are the units back at the warehouse, as
 * VentaHub's were. A warehouse is required; SKUs that neither sold nor hold
 * stock are rows unless ``hide_inactive``. Sort by a SKU field, by
 * ``p1_warehouse_units`` / ``other_warehouse_units``, or by
 * ``previous_<figure>`` / ``current_<figure>``; unset, the most P1 stock
 * first. Needs ``orders:view``.
 */
export const reportReviewData = <ThrowOnError extends boolean = false>(options: Options<ReportReviewDataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ReportReviewDataResponse, unknown, ThrowOnError>({
        url: '/v1/reports/review-data',
        ...options
    });
};